export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    /** Long type */
    Long: any;
    /** A ISO8601 compliant date time */
    Timestamp: any;
};

/** An allocated variant when participating in an A/B test */
export type AbTestVariant = {
    /**  Experiment id in a/bisko  */
    experiment: Scalars['String'];
    /**  Project id in a/bisko  */
    project: Scalars['String'];
    /**  Allocated variant (for now, variant slug in a/bisko)  */
    variant: Scalars['String'];
};

export enum Accessibility {
    AudioDescribed = 'AudioDescribed',
    Default = 'Default',
    SignInterpreted = 'SignInterpreted',
}

export type AccessibilityFlag = {
    __typename?: 'AccessibilityFlag';
    /**  Displayable name in Swedish  */
    name: Scalars['String'];
    /**
     * Type is one of:
     * * SignInterpreted
     * * AudioDescribed
     * * SpeechEnhancement
     * * SpokenSubtitles
     */
    type: Scalars['String'];
};

export type AnalyticsIdentifiers = {
    __typename?: 'AnalyticsIdentifiers';
    viewId: Scalars['String'];
    viewType: Scalars['String'];
};

/** The analytics metadata sent to Helix for every watchable video. */
export type AnalyticsMetadata = {
    __typename?: 'AnalyticsMetadata';
    episode: Maybe<Episode>;
    id: Scalars['ID'];
    name: Scalars['String'];
    producingDepartmentId: Maybe<Scalars['String']>;
    producingDepartmentName: Maybe<Scalars['String']>;
    seasonId: Maybe<Scalars['String']>;
    seasonName: Maybe<Scalars['String']>;
    seasonNumber: Maybe<Scalars['Int']>;
    seasonProducedEpisodes: Maybe<Scalars['Int']>;
    seasonYear: Maybe<Scalars['Int']>;
    svtId: Scalars['String'];
    title: Maybe<Content>;
    titles: Array<Content>;
    typeName: Scalars['String'];
    video: Playable;
};

export enum AssociatedContentId {
    Accessibility = 'accessibility',
    Clips = 'clips',
    ProductionPeriod = 'productionPeriod',
    Related = 'related',
    Season = 'season',
    Upcoming = 'upcoming',
    UpcomingLive = 'upcomingLive',
}

/** A badge for a teaser, usually shown as a label/overlay on the teaser/image. */
export type Badge = {
    __typename?: 'Badge';
    /**  Textual description of the badge for accessibility (screen reading and other) purposes, can be empty  */
    altText: Scalars['String'];
    text: Scalars['String'];
    /**
     * Type can be one of:
     * * live
     * * upcomingLive
     * * upcoming
     * * nextEpisode
     * * oppetArkiv
     * * lastChance
     * If multiple are true they are prioritized in the order above.
     */
    type: Scalars['String'];
};

export enum BroadcastAudio {
    Surround51 = 'surround51',
    Unknown = 'unknown',
}

export type BroadcastItem = {
    __typename?: 'BroadcastItem';
    /**  Is this broadcast available in more high fidelity audio formats?  */
    broadcastAudio: BroadcastAudio;
    description: Scalars['String'];
    end: Scalars['Timestamp'];
    /**  Is this broadcast aired in HD in linear tv?  */
    highDefinition: Scalars['Boolean'];
    id: Scalars['ID'];
    /**  Image for item or background image for channel if there is no current broadcast(sändningsuppehåll)  */
    image: Image;
    /**  is this a "Sändningsuppehåll"?  */
    isBroadcastIntermission: Scalars['Boolean'];
    item: Maybe<Playable>;
    /**  Name of program  */
    name: Scalars['String'];
    /**  The progress of the broadcast item as a percentage. 0 if upcoming, >0 if running, 100 if ended.  */
    progress: Scalars['Int'];
    /**  Information of when it gets a rerun in the broadcast television.  */
    rerunDescription: Scalars['String'];
    start: Scalars['Timestamp'];
    /**  Start time in format HH:mm  */
    startTime: Scalars['String'];
    /**  Start time in format Idag/Ikväll/Inatt HH:mm  */
    startTimeWithDay: Scalars['String'];
    state: BroadcastState;
    /**  Sub heading (underrubrik) to be used when displaying this item on the channel page.  */
    subHeading: Scalars['String'];
    svtId: Maybe<Scalars['String']>;
    /**  Link to UR Play, Null if not UR program  */
    urPlayLink: Maybe<Scalars['String']>;
    /**  For Ui purposes: If a fallback image was used for image, usingFallbackImage is true, otherwise false  */
    usingFallbackImage: Scalars['Boolean'];
};

export enum BroadcastState {
    Ended = 'ended',
    Running = 'running',
    Upcoming = 'upcoming',
}

export type CastAndCrewSection = {
    __typename?: 'CastAndCrewSection';
    name: Scalars['String'];
    people: Array<Person>;
};

export type CategoryPage = {
    __typename?: 'CategoryPage';
    analyticsIdentifiers: AnalyticsIdentifiers;
    description: Scalars['String'];
    /**  Selections in a flat structure, without tabs  */
    flat: Array<Selection>;
    heading: Scalars['String'];
    id: Scalars['ID'];
    image: Maybe<Image>;
    /**  Same as tabs, but only populates selections for the selected tab slug. If slug is empty, a default tab to display will be selected  */
    lazyLoadedTabs: Array<CategoryTab>;
    /**  Selections divided into tabs/groups  */
    tabs: Array<CategoryTab>;
};

export type CategoryPageLazyLoadedTabsArgs = {
    slug: Maybe<Scalars['String']>;
};

/** A group of selections to be displayed together. */
export type CategoryTab = {
    __typename?: 'CategoryTab';
    id: Scalars['ID'];
    /**  User friendly name of the tab  */
    name: Scalars['String'];
    selections: Array<Selection>;
    /**  Url friendly id for the tab. Used as parameter in lazyLoadedTabs  */
    slug: Scalars['String'];
};

export type CategoryTeaser = {
    __typename?: 'CategoryTeaser';
    byline: Scalars['String'];
    heading: Scalars['String'];
    id: Scalars['ID'];
    image: Image;
    isMainCategory: Scalars['Boolean'];
};

export type Channel = {
    __typename?: 'Channel';
    id: Scalars['ID'];
    logo: Image;
    name: Scalars['String'];
    running: BroadcastItem;
    /** The schedule for today or a given day in yyyy-MM-dd format, today +- 3 weeks */
    schedule: Array<BroadcastItem>;
};

export type ChannelScheduleArgs = {
    day: Maybe<Scalars['String']>;
};

export type Channels = {
    __typename?: 'Channels';
    analyticsIdentifiers: AnalyticsIdentifiers;
    channels: Array<Channel>;
    /**  Used to know when to update ui, if needed. 0 means that a new program as started in any channel.  */
    secondsToNextBroadcast: Scalars['Int'];
};

export type Clip = ExtraMaterial &
    Listable &
    Node &
    Playable &
    Video & {
        __typename?: 'Clip';
        /**  List of available accessibility aides.  */
        accessibilities: Array<Accessibility>;
        /**  Accessibility data for this clip  */
        accessibility: Maybe<Accessibility>;
        /**  Client hint for reporting to datalake  */
        analyticsIdentifiers: AnalyticsIdentifiers;
        /**  The proportional relationship between the video's width and height  */
        aspectRatio: Scalars['String'];
        /**  A list of lists with associated content, for example seasons from parent, related from parent and clips from parent  */
        associatedContent: Array<Selection>;
        /**  Is this intended for children based on escenic barn tags?  */
        barn: Scalars['Boolean'];
        /**  Viewer warnings for this playable  */
        contentWarning: Maybe<ContentWarning>;
        /**  Content length in seconds  */
        duration: Scalars['Int'];
        /**  Content length in a formatted format according to the styleguide  */
        durationFormatted: Scalars['String'];
        /**  Content length in ISO format (hh:mm:ss)  */
        durationISOFormatted: Scalars['String'];
        /**  End Credit Start time in seconds  */
        endCreditStart: Maybe<Scalars['Int']>;
        /**
         *  The episode this playable belongs to. Examples: Variant will return the Episode or Single to which it belongs.
         * Single and Episode it will return itself. Clip and Trailer will return itself because it has no episode playable.
         */
        episode: Playable;
        /**
         *  Is this Content migrated from the Öppet Arkiv catalogue?
         * @deprecated This is a temporary flag until all clients handle all Öppet Arkiv content
         */
        fullOppetArkiv: Scalars['Boolean'];
        genres: Array<Genre>;
        id: Scalars['ID'];
        image: Image;
        /**  Images from Escenic, including keyart, see rules on contento startpage  */
        images: Images;
        /**  Clips can never be live, only needed for completeness  */
        live: Maybe<Live>;
        longDescription: Scalars['String'];
        /**  Editorial messages directed to the viewer  */
        messages: Maybe<Messages>;
        /**  The name of the item. Follows all the presentation rules for our services.  */
        name: Scalars['String'];
        /**  Teaser image used by news & sports for current events in a news context, for example if Charlotte Kalla has won. Can contain spoilers  */
        newsTeaserImage: Image;
        /**  Is this Content from öppetArkiv?  */
        oppetArkiv: Scalars['Boolean'];
        /**  The original title for the playables parent content, always empty for extra material  */
        originalProgramTitle: Scalars['String'];
        /**
         * The main parent content (TvSeries/TvShow/Single) this clip belongs to ((if it has any relation).
         * This is only left for legacy reasons.
         */
        parent: Maybe<Content>;
        parentNode: Maybe<Node>;
        /**  All parents (TvSeries/TvShows/Singles) that this clips belongs to.  */
        parents: Array<Content>;
        /**  Popularity for this item from popapp  */
        popularity: Scalars['Int'];
        /**  Production year from Vision  */
        productionYear: Maybe<Scalars['Int']>;
        restrictions: Restrictions;
        shortDescription: Scalars['String'];
        /**  Slug fragment that can be used to construct a URL to this item  */
        slug: Scalars['String'];
        /**  New unique identifier  */
        svtId: Scalars['String'];
        tags: Array<Tag>;
        /**  URL field containing various URL:s, for example SVT Play  */
        urls: Urls;
        /**  Start of rights  */
        validFrom: Maybe<Scalars['Timestamp']>;
        /**  Start of rights in a formatted format according to the styleguide  */
        validFromFormatted: Maybe<Scalars['String']>;
        /**  End of rights  */
        validTo: Maybe<Scalars['Timestamp']>;
        /**  End of rights in a formatted format according to the styleguide  */
        validToFormatted: Maybe<Scalars['String']>;
        videoFormats: Array<Scalars['String']>;
        /**
         * Default playable video id for this item. Can be used to match a variant
         * to an episode item on a detail page, for example to render progress from
         * local storage or match selected item
         */
        videoSvtId: Scalars['String'];
        /**  List of playable videos  */
        videos: Array<Video>;
        /**
         * When in seconds clients should show skip to next episode button.
         * Based on endCreditStart or logic based on length of program.
         * If missing, do not show skip to next button.
         */
        whenToDisplaySkipToNext: Maybe<Scalars['Int']>;
    };

export type ClipAssociatedContentArgs = {
    addExtras: Maybe<Array<ExtraAssociatedContentId>>;
    exclude: Maybe<Array<AssociatedContentId>>;
    include: Maybe<Array<AssociatedContentId>>;
};

export type Company = {
    __typename?: 'Company';
    /**  Unique code for company  */
    id: Scalars['ID'];
    name: Scalars['String'];
};

export type Content = {
    /** List of accessibility aides. Each aid is present if at least one of the episodes or variants has it */
    accessibilities: Array<Accessibility>;
    /**  Client hint for reporting to datalake  */
    analyticsIdentifiers: AnalyticsIdentifiers;
    /**  A list of lists with associated content, for example seasons, related and clips  */
    associatedContent: Array<Selection>;
    /**  Is this intended for children based on escenic barn tags?  */
    barn: Scalars['Boolean'];
    /**  Popularity for this item from barnplay-popapp, for use in the SVT barn service  */
    barnPopularity: Scalars['Int'];
    /**  TrendingMetric for this item from barnplay-popapp, for use in the SVT barn service  */
    barnTrending: Scalars['Float'];
    /**  Special image used for kids content to show the main character of the show  */
    characterImage: Maybe<Image>;
    /**  Viewer warnings for this content  */
    contentWarning: Maybe<ContentWarning>;
    /**  Producing country or countries  */
    countriesOfOrigin: Array<Scalars['String']>;
    /**  Deep links for different services, e.g. svt play and barn play  */
    deepLinks: DeepLinks;
    /**  Episodes as a flat list  */
    episodes: Array<Playable>;
    /**
     *  Episodes as a flat list including some upcoming episodes used by searchIndexer
     * @deprecated This is only used by searchIndexer and is therefor hidden in explorer
     */
    episodesForSearchIndexer: Array<Playable>;
    /**  Extra material like clips or trailers for the entire tv show  */
    extraMaterial: Array<ExtraMaterial>;
    /**
     *  Is this Content migrated from the Öppet Arkiv catalogue?
     * @deprecated This is a temporary flag until all clients handle all Öppet Arkiv content
     */
    fullOppetArkiv: Scalars['Boolean'];
    /**  Categorization by cluster tags ("video@..." or "editorialvideo@...")  */
    genres: Array<Genre>;
    /**  Unique identifier. Today this is the Vision episode id or Escenic title page id  */
    id: Scalars['ID'];
    /**  Image from Escenic is used, see rules on contento startpage  */
    image: Image;
    /**  Images from Escenic, including keyart, see rules on contento startpage  */
    images: Images;
    /**  Languages for all episodes of all seasons. Uses three-letter iso format, and "sgn" for Sign language  */
    languages: Array<Scalars['String']>;
    /**  The duration of the latest episode in seconds  */
    latestEpisodeDurationSeconds: Maybe<Scalars['Long']>;
    /**  The latest PublicationDate of its underlying episodes  */
    latestEpisodePublicationDate: Maybe<Scalars['Timestamp']>;
    /**  Defined in Vision. Format is suitable for a printed TV Guide  */
    longDescription: Scalars['String'];
    /**  Contains all languages that are present as mainLanguage in any episode variant  */
    mainLanguages: Array<Language>;
    /**  Editorial messages directed to the viewer  */
    messages: Maybe<Messages>;
    /**  The name of the item. Follows all the presentation rules for our services.  */
    name: Scalars['String'];
    /**  Time when the next episode will be published  */
    nextEpisodeAvailable: Maybe<Scalars['Timestamp']>;
    /**  Next episode in a formatted format according to the styleguide  */
    nextEpisodeAvailableFormatted: Maybe<Scalars['String']>;
    /**  Number of active episodes  */
    numberOfActiveEpisodes: Scalars['Int'];
    /**  Is this Content from öppetArkiv?  */
    oppetArkiv: Scalars['Boolean'];
    /**  Popularity for this item from popapp  */
    popularity: Scalars['Int'];
    /**  Special image used for kids content to show a portrait poster image  */
    portraitPosterImage: Maybe<Image>;
    prioritizedSearchTags: Array<Scalars['String']>;
    /**  Related content from Balthazar  */
    related: Array<Content>;
    /**  Rerun information, has this content been present on Play before? Calculated as 'has all episodes been broadcasted earlier'  */
    rerun: Scalars['Boolean'];
    /**  Restrictions for different viewer groups (location, age)  */
    restrictions: Restrictions;
    /**  SearchTags also describing this content (searchTags)  */
    searchTags: Array<Scalars['String']>;
    /**  Defined in Vision. Usually used as byline below the name  */
    shortDescription: Scalars['String'];
    /**  Slug fragment that can be used to construct a URL to this item  */
    slug: Scalars['String'];
    /**  New unique identifier  */
    svtId: Scalars['String'];
    /**  Defined in Escenic. Tags are used to group or classify content  */
    tags: Array<Tag>;
    /**  Internal title info  */
    titleInternalInformation: Maybe<TitleInternalInformation>;
    /**  URL field containing various URL:s, for example SVT Play  */
    urls: Urls;
};

export type ContentAssociatedContentArgs = {
    addExtras: Maybe<Array<ExtraAssociatedContentId>>;
    exclude: Maybe<Array<AssociatedContentId>>;
    include: Maybe<Array<AssociatedContentId>>;
};

export type ContentInformation = {
    __typename?: 'ContentInformation';
    contentSvtId: Scalars['String'];
    videoSvtId: Scalars['String'];
};

export enum ContentStatus {
    Active = 'active',
    Expired = 'expired',
    Upcoming = 'upcoming',
}

export type ContentWarning = {
    __typename?: 'ContentWarning';
    code: Scalars['String'];
    text: Scalars['String'];
};

export type DeepLinks = {
    __typename?: 'DeepLinks';
    svtplay: Maybe<Links>;
};

export type DetailsPage = {
    __typename?: 'DetailsPage';
    analyticsIdentifiers: AnalyticsIdentifiers;
    /**  A list of lists with associated content, for example seasons, related and clips  */
    associatedContent: Array<Selection>;
    badge: Maybe<Badge>;
    byline: Scalars['String'];
    /**  List of cast and crew, grouped by role, sorted for presentation  */
    castAndCrew: Array<CastAndCrewSection>;
    categories: Array<CategoryTeaser>;
    contentSvtId: Scalars['String'];
    /**  Viewer warnings for this listable.  */
    contentWarning: Maybe<ContentWarning>;
    description: Scalars['String'];
    heading: Scalars['String'];
    id: Scalars['ID'];
    images: Images;
    /**
     *  If no active content, this message contains `Inga avsnitt finns tillgängliga just nu`
     * together with a date for when an episode was last active
     */
    inactiveContentMessage: Maybe<Scalars['String']>;
    /**  If this is a live episode that is upcoming and will start soon  */
    isLiveSoon: Scalars['Boolean'];
    /**  If this is a live stream that is upcoming  */
    isUpcomingLive: Scalars['Boolean'];
    /**  If this is a playable that is upcoming  */
    isUpcomingVOD: Scalars['Boolean'];
    item: Listable;
    live: Maybe<Live>;
    messages: Maybe<Messages>;
    moreDetails: MoreDetails;
    positionInSeason: Maybe<Scalars['String']>;
    restrictions: Maybe<Restrictions>;
    subHeading: Scalars['String'];
    svtId: Scalars['String'];
    validFrom: Maybe<Scalars['String']>;
    video: Maybe<Video>;
};

export type DetailsPageAssociatedContentArgs = {
    addExtras: Maybe<Array<ExtraAssociatedContentId>>;
    exclude: Maybe<Array<AssociatedContentId>>;
    include: Maybe<Array<AssociatedContentId>>;
};

/** Filter by type. Used for editorial search. */
export enum EditorialSearchFilterType {
    Content = 'Content',
    ExtraMaterial = 'ExtraMaterial',
    Playable = 'Playable',
}

export type Episode = Listable &
    Node &
    Playable & {
        __typename?: 'Episode';
        /**  List of available accessibility aides.  */
        accessibilities: Array<Accessibility>;
        /**  Client hint for reporting to datalake  */
        analyticsIdentifiers: AnalyticsIdentifiers;
        /**  The proportional relationship between the video's width and height  */
        aspectRatio: Maybe<Scalars['String']>;
        /**  A list of lists with associated content, for example seasons, related and clips  */
        associatedContent: Array<Selection>;
        /**  Is this intended for children based on escenic barn tags?  */
        barn: Scalars['Boolean'];
        /**  List of cast, today taken from Meta  */
        cast: Array<Participant>;
        /**  List of cast and crew, grouped by role, sorted for presentation  */
        castAndCrew: Array<CastAndCrewSection>;
        /**  List of production companies that produced this episode  */
        coProducedByCompanies: Array<Company>;
        /**  Viewer warning for this playable  */
        contentWarning: Maybe<ContentWarning>;
        /**  List of crew, today taken from Meta  */
        crew: Array<Participant>;
        /**  Deep links for different services, e.g. svt play and barn play  */
        deepLinks: DeepLinks;
        /**  Content length in seconds  */
        duration: Scalars['Int'];
        /**  Content length in a formatted format according to the styleguide  */
        durationFormatted: Scalars['String'];
        /**  Content length in ISO format (hh:mm:ss)  */
        durationISOFormatted: Scalars['String'];
        /**  End Credit Start time in seconds  */
        endCreditStart: Maybe<Scalars['Int']>;
        /**
         *  The episode this playable belongs to. Examples: Variant will return the Episode or Single to which it belongs.
         * Single and Episode it will return itself. Clip and Trailer will return itself because it has no episode playable.
         */
        episode: Playable;
        /**
         *  Is this Content migrated from the Öppet Arkiv catalogue?
         * @deprecated This is a temporary flag until all clients handle all Öppet Arkiv content
         */
        fullOppetArkiv: Scalars['Boolean'];
        /**  Categorization by cluster tags ("video@..." or "editorialvideo@...")  */
        genres: Array<Genre>;
        /**  Unique episode id. Today based on Vision episode id, i.e. [programId]-[episodeno]  */
        id: Scalars['ID'];
        /**  Image from Escenic is used, see rules on contento startpage  */
        image: Image;
        /**  Images from Escenic, including keyart, see rules on contento startpage  */
        images: Images;
        /**  Internal Information - Do not build integrations using this, it´s meant to be read by a human  */
        internal: InternalInformation;
        /**  Information for live broadcasts  */
        live: Maybe<Live>;
        /**  Long episode synopsis, taken from Vision.  */
        longDescription: Scalars['String'];
        /**  Editorial messages directed to the viewer  */
        messages: Maybe<Messages>;
        /**  The name of the item. Follows all the presentation rules for our services.  */
        name: Scalars['String'];
        /**  Name without any episode or season numbers. Unedited from source  */
        nameRaw: Scalars['String'];
        /**  Episode number in season  */
        number: Maybe<Scalars['Int']>;
        /**  Number of episodes in the season this episode belongs to  */
        numberOfEpisodesInSeason: Scalars['Int'];
        /**  Is this Content from öppetArkiv?  */
        oppetArkiv: Scalars['Boolean'];
        /**  The original title for the playables parent content  */
        originalProgramTitle: Scalars['String'];
        /**  The parent TvSeries as a Content instance. Use this if you do not need TvSeries specific data.  */
        parent: Content;
        /**  The parent season or productionPeriod  */
        parentNode: Maybe<Node>;
        /**  Popularity for this item from popapp  */
        popularity: Scalars['Int'];
        /**  Formatted string for position of episode relative to its siblings and seasons i.e 'Säsong 3 — Avsnitt 5'  */
        positionInSeason: Scalars['String'];
        prioritizedSearchTags: Array<Scalars['String']>;
        /**  Production year from Vision  */
        productionYear: Maybe<Scalars['Int']>;
        /**  Restrictions for different viewer groups (location, age)  */
        restrictions: Restrictions;
        /**  SearchTags also describing this content (searchTags)  */
        searchTags: Array<Scalars['String']>;
        /**  Intended for short episode synopsis. Taken from vision, where it currently is abused to write season name  */
        shortDescription: Scalars['String'];
        /**  Slug fragment that can be used to construct a URL to this item  */
        slug: Scalars['String'];
        /**  New unique identifier  */
        svtId: Scalars['String'];
        /**  Defined in Escenic. Tags are used to group or classify content  */
        tags: Array<Tag>;
        /**  URL field containing various URL:s, for example SVT Play  */
        urls: Urls;
        /**  Start of rights  */
        validFrom: Maybe<Scalars['Timestamp']>;
        /**  Start of rights in a formatted format according to the styleguide  */
        validFromFormatted: Maybe<Scalars['String']>;
        /**  End of rights  */
        validTo: Maybe<Scalars['Timestamp']>;
        /**  End of rights in a formatted format according to the styleguide  */
        validToFormatted: Maybe<Scalars['String']>;
        /**  Variants of this content like accessibility or spoken language  */
        variants: Array<Variant>;
        /**  Available video streaming formats  */
        videoFormats: Array<Scalars['String']>;
        /**
         * Default playable video id for this item. Can be used to match a variant
         * to an episode item on a detail page, for example to render progress from
         * local storage or match selected item
         */
        videoSvtId: Scalars['String'];
        /**  List of playable videos  */
        videos: Array<Video>;
        /**
         * When in seconds clients should show skip to next episode button.
         * Based on endCreditStart or logic based on length of program.
         * If missing, do not show skip to next button.
         */
        whenToDisplaySkipToNext: Maybe<Scalars['Int']>;
    };

export type EpisodeAssociatedContentArgs = {
    addExtras: Maybe<Array<ExtraAssociatedContentId>>;
    exclude: Maybe<Array<AssociatedContentId>>;
    include: Maybe<Array<AssociatedContentId>>;
};

export type Episodes = {
    __typename?: 'Episodes';
    tvSeriesEpisodes: Array<Episode>;
    tvShowEpisodes: Array<Episode>;
};

export enum ExtraAssociatedContentId {
    Accessibility = 'accessibility',
    Upcoming = 'upcoming',
}

export type ExtraMaterial = {
    /**  Client hint for reporting to datalake  */
    analyticsIdentifiers: AnalyticsIdentifiers;
    /**  The proportional relationship between the video's width and height  */
    aspectRatio: Scalars['String'];
    /**  Is this intended for children based on escenic barn tags?  */
    barn: Scalars['Boolean'];
    /**  Content length in seconds  */
    duration: Scalars['Int'];
    /**  Content length in a formatted format according to the styleguide  */
    durationFormatted: Scalars['String'];
    /**  Content length in ISO format (hh:mm:ss)  */
    durationISOFormatted: Scalars['String'];
    genres: Array<Genre>;
    id: Scalars['ID'];
    image: Image;
    /**  Images from Escenic, including keyart, see rules on contento startpage  */
    images: Images;
    longDescription: Scalars['String'];
    /**  The name of the item. Follows all the presentation rules for our services.  */
    name: Scalars['String'];
    /**  Teaser image used by news & sports for current events in a news context, for example if Charlotte Kalla has won. Can contain spoilers  */
    newsTeaserImage: Image;
    /**  Is this Content from öppetArkiv?  */
    oppetArkiv: Scalars['Boolean'];
    /**  The original title for the playables parent content, always empty for extra material  */
    originalProgramTitle: Scalars['String'];
    /**
     * The main parent content (TvSeries/TvShow/Single) this clip belongs to ((if it has any relation).
     * This is only left for legacy reasons.
     */
    parent: Maybe<Content>;
    /**  All parents (TvSeries/TvShows/Singles) that this clips belongs to.  */
    parents: Array<Content>;
    /**  Production year from Vision  */
    productionYear: Maybe<Scalars['Int']>;
    restrictions: Restrictions;
    shortDescription: Scalars['String'];
    /**  New unique identifier  */
    svtId: Scalars['String'];
    tags: Array<Tag>;
    /**  URL field containing various URL:s, for example SVT Play  */
    urls: Urls;
    /**  Start of rights  */
    validFrom: Maybe<Scalars['Timestamp']>;
    /**  Start of rights in a formatted format according to the styleguide  */
    validFromFormatted: Maybe<Scalars['String']>;
    /**  End of rights  */
    validTo: Maybe<Scalars['Timestamp']>;
    /**  End of rights in a formatted format according to the styleguide  */
    validToFormatted: Maybe<Scalars['String']>;
    videoFormats: Array<Scalars['String']>;
    /**  List of playable videos  */
    videos: Array<Video>;
};

export type Filter = {
    /** Do you want to include all öppet arkiv, not only promoted ones? If so, set this flag to true! */
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
    /** Removes items with blockedForChildren: true */
    kidsFilter: Maybe<Scalars['Boolean']>;
    /** Removes non-kids content (items with barn: false) */
    onlyKidsContent: Maybe<Scalars['Boolean']>;
    /** Removes items with onlyAvailableInSweden: false */
    userIsAbroad: Maybe<Scalars['Boolean']>;
};

export type Genre = {
    __typename?: 'Genre';
    /**  Client hint for reporting to datalake  */
    analyticsIdentifiers: AnalyticsIdentifiers;
    /**
     *  TvShows, TvSeries and Singles for genre
     * @deprecated Use `selections` 'all' instead
     */
    content: Array<Content>;
    /**  Used as description for genre page  */
    description: Maybe<Scalars['String']>;
    /**  Extra material for genre  */
    extraMaterial: Array<ExtraMaterial>;
    /**  Unique identifier for genre  */
    id: Scalars['ID'];
    /**  Image from Escenic is used, see rules on contento startpage  */
    image: Maybe<Image>;
    /**  Items in the genre, TvShows, TvSeries, Singles and Episodes  */
    items: Array<Listable>;
    /**
     *  List of Playable objects containing selection of content based on expiration date
     * @deprecated Use `selections` 'lastChance' instead
     */
    lastChance: Array<Playable>;
    /**
     *  List of Playable objects containing selection of content based on expiring validTo
     * @deprecated Use `selections` 'latest' instead
     */
    latest: Array<Playable>;
    /**  The name of the genre, e.g. "Samhälle & fakta"  */
    name: Scalars['String'];
    /**
     *  List of Playable objects containing selection of content based on popularity
     * @deprecated Use `selections` 'popular' instead
     */
    popular: Array<Playable>;
    /**  Popularity for this item from popapp  */
    popularity: Scalars['Int'];
    /**
     *  List of references to Playable objects containing an editorial selection of content
     * @deprecated Use `selections` 'recommended' instead
     */
    recommended: Array<RecommendedItem>;
    /**  List of Genres related to this Genre through editorial selection  */
    relatedGenres: Array<Genre>;
    /**  List of selections for this genre  */
    selections: Array<Selection>;
    /**  List of selections for this genre for use in SvtPlay-Web  */
    selectionsForWeb: Array<Selection>;
    selectionsPersonalized: Array<Selection>;
    /**  One of either main, emi-based or editorial  */
    type: GenreType;
};

export type GenreSelectionsArgs = {
    exclude: Maybe<Array<GenreSelectionId>>;
    include: Maybe<Array<GenreSelectionId>>;
};

export type GenreSelectionsForWebArgs = {
    exclude: Maybe<Array<GenreSelectionId>>;
    include: Maybe<Array<GenreSelectionId>>;
};

export type GenreSelectionsPersonalizedArgs = {
    abTestVariants: Maybe<Array<AbTestVariant>>;
    exclude: Maybe<Array<GenreSelectionId>>;
    history: Array<Scalars['String']>;
    include: Maybe<Array<GenreSelectionId>>;
};

export enum GenreSelectionId {
    All = 'all',
    Clips = 'clips',
    Fiona = 'fiona',
    Lastchance = 'lastchance',
    Latest = 'latest',
    PersonalRecommendations = 'personalRecommendations',
    Popular = 'popular',
    Recommended = 'recommended',
    Signinterpretedsplit = 'signinterpretedsplit',
}

export enum GenreType {
    Editorial = 'Editorial',
    EmiBased = 'EmiBased',
    Main = 'Main',
}

export type Genres = {
    __typename?: 'Genres';
    /**  Client hint for reporting to datalake  */
    analyticsIdentifiers: AnalyticsIdentifiers;
    /**  Genres  */
    genres: Array<Genre>;
};

export type Highlight = {
    __typename?: 'Highlight';
    /**  More verbose description of the highlight  */
    description: Scalars['String'];
    /**  Name of the highlight  */
    name: Scalars['String'];
    /**  Position in human readable form  */
    positionFormatted: Scalars['String'];
    /**  Position for the start of the highlight, can be used for direct linking with position in video player  */
    positionInSeconds: Scalars['Int'];
    /**  Title slug - slugified name  */
    slug: Scalars['String'];
    /**  Thumbnail url  */
    thumbnail: Maybe<Scalars['String']>;
    /**  Article Id to the thumbnail to be used to create an URL for the image via image proxy  */
    thumbnailId: Maybe<Scalars['Int']>;
};

export type History = {
    /**  Listable id  */
    id: Scalars['String'];
    /**  Progress in percentage between 0 - 100  */
    progressFraction: Maybe<Scalars['Int']>;
    /**  Progress in seconds  */
    progressSeconds: Maybe<Scalars['Int']>;
};

export type Image = {
    __typename?: 'Image';
    blurHash: Scalars['String'];
    /**  Description of the image, as a text suitable for showing below the image. Often the same as caption  */
    caption: Scalars['String'];
    changed: Scalars['Long'];
    /**  Description of the image, as a text also suitable for screenreaders and search bots. Often the same as caption  */
    description: Scalars['String'];
    id: Scalars['ID'];
    keyart: Scalars['Boolean'];
    photographer: Scalars['String'];
};

/**
 * Different kinds of images
 * The Keyart images is used as default for all entities. If no key art is available (indicated by `Image.keyart` being false), the following fallback rules apply:
 * The Thumbnail image is used as first fallback, and Poster image is used as a second fallback for tv show episodes, tv series episodes,
 * singles and extra material. If none of them are present, the fallback is the corresponding image for the "title". If no title image exists,
 * a generic fallback image is served (this is a rare case).
 * For genres, tv shows and tv series the Poster image is used as first fallback, with the Thumbnail image as second fallback.
 */
export type Images = {
    __typename?: 'Images';
    cleanPortrait: Image;
    cleanWide: Image;
    imax: Image;
    logotype: Maybe<Image>;
    portrait: Image;
    wide: Image;
};

export type ImportantMessage = {
    __typename?: 'ImportantMessage';
    /**  Timestamp of message creation */
    created: Scalars['Timestamp'];
    /**  Escenic id  */
    id: Scalars['String'];
    /**  Optional link for more information regarding the message  */
    link: Maybe<Scalars['String']>;
    /**  Optional text to be displayed for the link that the link field points to  */
    linkText: Maybe<Scalars['String']>;
    /**  Platform that this message is valid for, can be ALL for all platforms */
    platform: Maybe<ImportantMessagePlatform>;
    /**  The message text  */
    text: Scalars['String'];
    /**  VMA or TMA  */
    type: ImportantMessageType;
    /**  Timestamp last updated e.g. state or content of the message  */
    updated: Scalars['Timestamp'];
};

/** Platform that this message is valid for, can be ALL for all platforms */
export enum ImportantMessagePlatform {
    All = 'ALL',
    AndroidTv = 'ANDROID_TV',
    AppleTv = 'APPLE_TV',
    AppleTvOld = 'APPLE_TV_OLD',
    MobileAndroid = 'MOBILE_ANDROID',
    MobileIos = 'MOBILE_IOS',
    SmartTv = 'SMART_TV',
    Web = 'WEB',
}

export enum ImportantMessageType {
    /** Tekniskt Meddelande till Allmänheten (used for major technical issues regarding our services or clarifying rights issues) */
    Tma = 'TMA',
    /** Viktigt Meddelande till Allmänheten (used in case of accidents, serious incidents and disruptions in essential national services) */
    Vma = 'VMA',
}

export type InternalInformation = {
    __typename?: 'InternalInformation';
    /**  Department within SVT that produced or bought the content  */
    producingDepartment: ProducingDepartment;
    /**  program id from vision  */
    programId: Scalars['Int'];
};

export type InternalSearchHit = {
    __typename?: 'InternalSearchHit';
    /**  List of accessibility aides  */
    accessibilities: Array<Accessibility>;
    /**  Description for the search hit  */
    description: Scalars['String'];
    /**  Episode title for the search hit if this is an episode  */
    episodeTitle: Maybe<Scalars['String']>;
    /**  Exclusive tags ie, tags set explicitly on this item  */
    exclusiveTags: Maybe<Array<Maybe<Scalars['String']>>>;
    /**  Reason for the hit being in the result  */
    hitReason: Maybe<InternalSearchHitReason>;
    /**  Id of the underlying item  */
    id: Scalars['ID'];
    /**  Image for the search hit  */
    image: Image;
    /**  The underlying item. A union of Genre and Listable. Avoid accessing this if possible  */
    item: SearchHitItem;
    /**  If this is an ongoing live broadcast  */
    liveNow: Scalars['Boolean'];
    /**  Name of the search hit, Can be a combination of "title - episode title"  */
    name: Scalars['String'];
    /**  If search hit is öppet arkiv   */
    oppetArkiv: Scalars['Boolean'];
    /**  Program Ids associated with the hit  */
    programIds: Maybe<Array<Maybe<Scalars['Int']>>>;
    /**  Score based on fuzzy search relevance to query  */
    score: Maybe<Scalars['Float']>;
    /**  Is this title Published or Unpublished? Is this an episode? Then you get null.  */
    state: Maybe<TitleState>;
    /**  SvtId of the underlying item or null if a genre hit  */
    svtId: Maybe<Scalars['String']>;
    /**  Title for the search hit, If this is an episode hit, this is the parent title  */
    title: Scalars['String'];
};

export type InternalSearchHitDescriptionArgs = {
    maxDescriptionLength: Maybe<Scalars['Int']>;
};

export enum InternalSearchHitReason {
    Filter = 'Filter',
    Fuzzy = 'Fuzzy',
    Id = 'Id',
}

/**  Filter by type (granular). Used for searchInternal */
export enum InternalSearchMatchType {
    Clip = 'Clip',
    Episode = 'Episode',
    KidsTvShow = 'KidsTvShow',
    Single = 'Single',
    Trailer = 'Trailer',
    TvSeries = 'TvSeries',
    TvShow = 'TvShow',
}

export enum InternalSearchPaginationType {
    SonicWorkaround = 'SonicWorkaround',
    TitleAndEpisode = 'TitleAndEpisode',
}

export type InternalSearchResult = {
    __typename?: 'InternalSearchResult';
    data: Array<InternalSearchHit>;
    first: Scalars['Int'];
    offset: Scalars['Int'];
    total: Scalars['Int'];
};

export enum KidsOrAdult {
    Adult = 'Adult',
    Kids = 'Kids',
    KidsAndAdult = 'KidsAndAdult',
}

/**
 * A Kids TV Show is content for younger children, where order does not matter.
 * A protected, predictable title to put kids in front of. When the last episode
 * is played, it should loop back and start from the beginning.
 */
export type KidsTvShow = Content &
    Listable &
    Node & {
        __typename?: 'KidsTvShow';
        /**  List of accessibility aides. Each aid is present if at least one of the episodes has it  */
        accessibilities: Array<Accessibility>;
        /**  Client hint for reporting to datalake  */
        analyticsIdentifiers: AnalyticsIdentifiers;
        /**  A list of lists with associated content, for example seasons, related and clips  */
        associatedContent: Array<Selection>;
        /**  Is this intended for children based on escenic barn tags?  */
        barn: Scalars['Boolean'];
        /**  Popularity for this item from barnplay-popapp, for use in the SVT barn service  */
        barnPopularity: Scalars['Int'];
        /**  TrendingMetric for this item from barnplay-popapp, for use in the SVT barn service  */
        barnTrending: Scalars['Float'];
        /**  Special image used for kids content to show the main character of the show  */
        characterImage: Maybe<Image>;
        /**  Viewer warnings for this playable  */
        contentWarning: Maybe<ContentWarning>;
        /**  Producing country or countries  */
        countriesOfOrigin: Array<Scalars['String']>;
        /**  Are the seasons composed from editorial tv show sections?  */
        customSections: Scalars['Boolean'];
        /**  Deep links for different services, e.g. svt play and barn play  */
        deepLinks: DeepLinks;
        /**  Episodes as a flat list  */
        episodes: Array<Playable>;
        /**
         *  Episodes as a flat list including some upcoming episodes used by searchIndexer
         * @deprecated This is only used by searchIndexer and is therefor hidden in explorer
         */
        episodesForSearchIndexer: Array<Playable>;
        /**  Extra material like clips or trailers for the entire tv show  */
        extraMaterial: Array<ExtraMaterial>;
        /**
         *  Is this Content migrated from the Öppet Arkiv catalogue?
         * @deprecated This is a temporary flag until all clients handle all Öppet Arkiv content
         */
        fullOppetArkiv: Scalars['Boolean'];
        /**  Categorization by cluster tags ("video@..." or "editorialvideo@...")  */
        genres: Array<Genre>;
        /**  Unique identifier. Today this is the Escenic title page id  */
        id: Scalars['ID'];
        /**  Image from Escenic is used, see rules on contento startpage  */
        image: Image;
        /**  Images from Escenic, including keyart, see rules on contento startpage  */
        images: Images;
        /**  Languages for all episodes of all seasons. Uses three-letter iso format, and "sgn" for Sign language  */
        languages: Array<Scalars['String']>;
        /**  The duration of the latest episode in seconds  */
        latestEpisodeDurationSeconds: Maybe<Scalars['Long']>;
        /**  The latest PublicationDate of its underlying episodes  */
        latestEpisodePublicationDate: Maybe<Scalars['Timestamp']>;
        /**  Defined in Vision. Format is suitable for a printed TV Guide  */
        longDescription: Scalars['String'];
        /**  Contains all languages that are present as mainLanguage in any episode variant  */
        mainLanguages: Array<Language>;
        /**  Editorial messages directed to the viewer  */
        messages: Maybe<Messages>;
        /**  The name of the item. Follows all the presentation rules for our services.  */
        name: Scalars['String'];
        /**  Time when the next episode will be published  */
        nextEpisodeAvailable: Maybe<Scalars['Timestamp']>;
        /**  Next episode in a formatted format according to the styleguide  */
        nextEpisodeAvailableFormatted: Maybe<Scalars['String']>;
        /**  Number of active episodes  */
        numberOfActiveEpisodes: Scalars['Int'];
        /**  Is this Content from öppetArkiv?  */
        oppetArkiv: Scalars['Boolean'];
        /** Parent to which this belongs. Content will return itself. */
        parent: Maybe<Content>;
        parentNode: Maybe<Node>;
        /**  Popularity for this item from popapp  */
        popularity: Scalars['Int'];
        /**  Special image used for kids content to show a portrait poster image  */
        portraitPosterImage: Maybe<Image>;
        prioritizedSearchTags: Array<Scalars['String']>;
        /**  Related content from Balthazar  */
        related: Array<Content>;
        /**  Rerun information, has this content been present on Play before? Calculated as 'has all episodes been broadcasted earlier'  */
        rerun: Scalars['Boolean'];
        /**  Restrictions for different viewer groups (location, age)  */
        restrictions: Restrictions;
        /**  SearchTags also describing this content (searchTags)  */
        searchTags: Array<Scalars['String']>;
        /**  All available seasons  */
        seasons: Array<Season>;
        /**  Defined in Vision. Usually used as byline below the name  */
        shortDescription: Scalars['String'];
        /**  Slug fragment that can be used to construct a URL to this item  */
        slug: Scalars['String'];
        /**  New unique identifier  */
        svtId: Scalars['String'];
        /**  Defined in Escenic. Tags are used to group or classify content  */
        tags: Array<Tag>;
        /**  Internal title info  */
        titleInternalInformation: Maybe<TitleInternalInformation>;
        /**  URL field containing various URL:s, for example SVT Play  */
        urls: Urls;
        /**
         * Default playable video id for this item. Can be used to match a variant
         * to an episode item on a detail page, for example to render progress from
         * local storage or match selected item
         */
        videoSvtId: Scalars['String'];
    };

/**
 * A Kids TV Show is content for younger children, where order does not matter.
 * A protected, predictable title to put kids in front of. When the last episode
 * is played, it should loop back and start from the beginning.
 */
export type KidsTvShowAssociatedContentArgs = {
    addExtras: Maybe<Array<ExtraAssociatedContentId>>;
    exclude: Maybe<Array<AssociatedContentId>>;
    include: Maybe<Array<AssociatedContentId>>;
};

export type KunskapskanalenBroadcast = {
    __typename?: 'KunskapskanalenBroadcast';
    description: Scalars['String'];
    end: Scalars['Timestamp'];
    /**  Episode title  */
    episodeName: Scalars['String'];
    episodeNumber: Maybe<Scalars['Int']>;
    /**  List of associated image ids  */
    episodeThumbnailIds: Maybe<Array<Scalars['Int']>>;
    id: Scalars['ID'];
    /**  Name of program  */
    name: Scalars['String'];
    numberOfEpisodes: Maybe<Scalars['Int']>;
    /**  Planned runtime in seconds  */
    plannedRuntime: Scalars['Int'];
    /**  Start of rights in SVT Play */
    playValidFrom: Maybe<Scalars['Timestamp']>;
    /**  Start of rights in a formatted format  */
    playValidFromFormatted: Maybe<Scalars['String']>;
    /**  End of rights in SVT Play */
    playValidTo: Maybe<Scalars['Timestamp']>;
    /**  End of rights in a formatted format  */
    playValidToFormatted: Maybe<Scalars['String']>;
    /**  Program id from vision  */
    programId: Scalars['String'];
    /**  Unique publishing id for this tableau item  */
    publishingId: Maybe<Scalars['String']>;
    /**  Information of when it gets a rerun in the broadcast television.  */
    rerunDescription: Scalars['String'];
    seasonNumber: Maybe<Scalars['Int']>;
    start: Scalars['Timestamp'];
    /**  Title Escenic id when available (Singles uses Vision id)  */
    titleId: Maybe<Scalars['String']>;
    /**  Link to UR Play, Null if not UR program  */
    urPlayLink: Maybe<Scalars['String']>;
};

export type Language = {
    __typename?: 'Language';
    /**  Three letter ISO-code (ISO 639-2)  */
    id: Scalars['ID'];
    name: Scalars['String'];
};

export type Links = {
    __typename?: 'Links';
    info: Scalars['String'];
    watch: Maybe<Scalars['String']>;
};

export type Listable = {
    /**  List of available accessibility aides.  */
    accessibilities: Array<Accessibility>;
    /**  Client hint for reporting to datalake  */
    analyticsIdentifiers: AnalyticsIdentifiers;
    /**  A list of lists with associated content, for example seasons, related and clips  */
    associatedContent: Array<Selection>;
    /**  Is this intended for children based on escenic barn tags?  */
    barn: Scalars['Boolean'];
    /**
     *  Is this Content migrated from the Öppet Arkiv catalogue?
     * @deprecated This is a temporary flag until all clients handle all Öppet Arkiv content
     */
    fullOppetArkiv: Scalars['Boolean'];
    id: Scalars['ID'];
    image: Image;
    /**  Images from Escenic, including keyart, see rules on contento startpage  */
    images: Images;
    longDescription: Scalars['String'];
    /**  Editorial messages directed to the viewer  */
    messages: Maybe<Messages>;
    /**  The name of the item. Follows all the presentation rules for our services  */
    name: Scalars['String'];
    /**  Is this Content from öppetArkiv?  */
    oppetArkiv: Scalars['Boolean'];
    /** Parent to which this belongs. Content will return itself. */
    parent: Maybe<Content>;
    /**  Popularity for this item from popapp  */
    popularity: Scalars['Int'];
    /**  Restrictions for different viewer groups (location, age)  */
    restrictions: Restrictions;
    shortDescription: Scalars['String'];
    /**  Slug fragment that can be used to construct a URL to this item  */
    slug: Scalars['String'];
    /**  New unique identifier  */
    svtId: Scalars['String'];
    /**  Defined in Escenic. Tags are used to group or classify content  */
    tags: Array<Tag>;
    /**  URL field containing various URL:s, for example SVT Play  */
    urls: Urls;
    /**
     * Default playable video id for this item. Can be used to match a variant
     * to an episode item on a detail page, for example to render progress from
     * local storage or match selected item
     */
    videoSvtId: Scalars['String'];
};

export type ListableAssociatedContentArgs = {
    addExtras: Maybe<Array<ExtraAssociatedContentId>>;
    exclude: Maybe<Array<AssociatedContentId>>;
    include: Maybe<Array<AssociatedContentId>>;
};

/** Start and end times for live broadcasts */
export type Live = {
    __typename?: 'Live';
    /**
     * liveNow is true when the PK (Playout) systems says the program is live. There might be some delay between liveNow being true
     * and the Video-api responding with video-links.
     */
    liveNow: Scalars['Boolean'];
    plannedEnd: Maybe<Scalars['Timestamp']>;
    start: Maybe<Scalars['Timestamp']>;
};

export type Message = {
    __typename?: 'Message';
    link: Maybe<Scalars['String']>;
    linkText: Maybe<Scalars['String']>;
    message: Maybe<Scalars['String']>;
};

/** Editorial messages associated with content items */
export type Messages = {
    __typename?: 'Messages';
    editorial: Message;
    urgent: Message;
};

export type MoreDetails = {
    __typename?: 'MoreDetails';
    byline: Scalars['String'];
    duration: Maybe<Scalars['String']>;
    episodeDescription: Maybe<Scalars['String']>;
    episodeHeading: Maybe<Scalars['String']>;
    heading: Scalars['String'];
    originalTitle: Maybe<Scalars['String']>;
    productionYear: Maybe<Scalars['Int']>;
    productionYearRange: Maybe<Scalars['String']>;
    restrictions: Maybe<Restrictions>;
    titleDescription: Scalars['String'];
    titleHeading: Scalars['String'];
    validFrom: Maybe<Scalars['String']>;
    validTo: Maybe<Scalars['String']>;
};

export type Node = {
    id: Scalars['ID'];
    /**  The name of the item. Follows all the presentation rules for our services  */
    name: Scalars['String'];
    parentNode: Maybe<Node>;
};

export type Participant = {
    __typename?: 'Participant';
    artisticName: Maybe<Scalars['String']>;
    firstName: Maybe<Scalars['String']>;
    numberOfParticipations: Scalars['Int'];
    publicInterest: Scalars['Boolean'];
    role: Maybe<Scalars['String']>;
    roleName: Maybe<Scalars['String']>;
    surName: Maybe<Scalars['String']>;
};

export type Person = {
    __typename?: 'Person';
    name: Scalars['String'];
    numberOfParticipations: Scalars['Int'];
};

export enum Platform {
    Android = 'android',
    Androidtv = 'androidtv',
    Appletv = 'appletv',
    Ios = 'ios',
    Smarttv = 'smarttv',
    Web = 'web',
}

/** All playable content. Holds Singles, TV Series, TV Shows, Kids TV shows, Content lists. */
export type PlayContent = {
    __typename?: 'PlayContent';
    all: Array<Content>;
    kidsTvShows: Array<KidsTvShow>;
    recommended: Array<RecommendedItem>;
    singles: Array<Single>;
    tvSeries: Array<TvSeries>;
    tvShows: Array<TvShow>;
};

/** A queue with the things to play for a video */
export type PlayQueue = {
    __typename?: 'PlayQueue';
    /**
     * The playQueue in a flat flavor. Basically a list of teasers.
     * For KidsTvShow the selected episode is first and all episodes for the show is in the queue.
     */
    flat: Array<Teaser>;
    /**  The next item to play as a teaser  */
    nextToPlay: Maybe<Teaser>;
    /**  The playQueue in a selections based flavor. Selections can be Seasons, recommended, extramaterial etc.  */
    selections: Array<Selection>;
    /**
     * When in seconds clients should show skip to next episode button.
     * Based on endCreditStart or logic based on length of program.
     * If missing, do not show skip to next button.
     */
    whenToDisplaySkipToNext: Maybe<Scalars['Int']>;
};

/** A queue with the things to play for a video */
export type PlayQueueFlatArgs = {
    filter: Maybe<Filter>;
};

/** A queue with the things to play for a video */
export type PlayQueueNextToPlayArgs = {
    filter: Maybe<Filter>;
    startVariantId: Scalars['String'];
};

/** A queue with the things to play for a video */
export type PlayQueueSelectionsArgs = {
    exclude: Maybe<Array<AssociatedContentId>>;
    include: Maybe<Array<AssociatedContentId>>;
};

/** Actual playable content */
export type Playable = {
    /**  Client hint for reporting to datalake  */
    analyticsIdentifiers: AnalyticsIdentifiers;
    /**  The proportional relationship between the video's width and height  */
    aspectRatio: Maybe<Scalars['String']>;
    /**  Is this intended for children based on escenic barn tags?  */
    barn: Scalars['Boolean'];
    /**  Viewer warning for this playable  */
    contentWarning: Maybe<ContentWarning>;
    /**  Content length in seconds  */
    duration: Scalars['Int'];
    /**  Content length in a formatted format according to the styleguide  */
    durationFormatted: Scalars['String'];
    /**  Content length in ISO format (hh:mm:ss)  */
    durationISOFormatted: Scalars['String'];
    /**  End Credit Start time in seconds  */
    endCreditStart: Maybe<Scalars['Int']>;
    /**
     *  The episode this playable belongs to. Examples: Variant will return the Episode or Single to which it belongs.
     * Single and Episode it will return itself. Clip and Trailer will return itself because it has no episode playable.
     */
    episode: Playable;
    /**
     *  Is this Content migrated from the Öppet Arkiv catalogue?
     * @deprecated This is a temporary flag until all clients handle all Öppet Arkiv content
     */
    fullOppetArkiv: Scalars['Boolean'];
    genres: Array<Genre>;
    id: Scalars['ID'];
    image: Image;
    /**  Images from Escenic, including keyart, see rules on contento startpage  */
    images: Images;
    /**  Information for live broadcasts  */
    live: Maybe<Live>;
    longDescription: Scalars['String'];
    /**  The name of the item. Follows all the presentation rules for our services.  */
    name: Scalars['String'];
    /**  Is this Content from öppetArkiv?  */
    oppetArkiv: Scalars['Boolean'];
    /**  The original title for the playables parent content  */
    originalProgramTitle: Scalars['String'];
    /**  The parent content (TvSeries/TvShow/Single) this item belongs to. Sometimes pointer to self. Can be null.  */
    parent: Maybe<Content>;
    /**  Popularity for this item from popapp  */
    popularity: Scalars['Int'];
    /**  Production year from Vision  */
    productionYear: Maybe<Scalars['Int']>;
    restrictions: Restrictions;
    shortDescription: Scalars['String'];
    /**  Slug fragment that can be used to construct a URL to this item  */
    slug: Scalars['String'];
    /**  New unique identifier  */
    svtId: Scalars['String'];
    tags: Array<Tag>;
    validFrom: Maybe<Scalars['Timestamp']>;
    validFromFormatted: Maybe<Scalars['String']>;
    validTo: Maybe<Scalars['Timestamp']>;
    validToFormatted: Maybe<Scalars['String']>;
    videoFormats: Array<Scalars['String']>;
    /**
     * Default playable video id for this item. Can be used to match a variant
     * to an episode item on a detail page, for example to render progress from
     * local storage or match selected item
     */
    videoSvtId: Scalars['String'];
    /**  List of playable videos  */
    videos: Array<Video>;
    /**
     * When in seconds clients should show skip to next episode button.
     * Based on endCreditStart or logic based on length of program.
     * If missing, do not show skip to next button.
     */
    whenToDisplaySkipToNext: Maybe<Scalars['Int']>;
};

/**  Config that controls the chat  */
export type PlayerChatConfig = {
    __typename?: 'PlayerChatConfig';
    /**  Direktcenter chatId  */
    chatId: Scalars['String'];
    description: Maybe<Scalars['String']>;
    /**  Decides the time of day to disable the chat. Null means midnight.  */
    endTime: Maybe<Scalars['String']>;
    hideAvatars: Scalars['Boolean'];
    /**  Id of the matching configuration  */
    id: Scalars['String'];
    reactions: Array<PlayerReaction>;
    /**  Decides the time of day when the chat is available. If null chat is available from midnight  */
    startTime: Maybe<Scalars['String']>;
};

/**  Config for content specific features  */
export type PlayerConfig = {
    __typename?: 'PlayerConfig';
    chat: Maybe<PlayerChatConfig>;
    extras: Maybe<PlayerExtraConfig>;
};

/**  Untyped json blob used for experiments  */
export type PlayerExtraConfig = {
    __typename?: 'PlayerExtraConfig';
    data: Scalars['String'];
    id: Scalars['String'];
};

/** A player page */
export type PlayerPage = {
    __typename?: 'PlayerPage';
    /**  description for episode or movie */
    description: Scalars['String'];
    /**  e.g. title of show or movie name */
    heading: Scalars['String'];
    playerConfig: Maybe<PlayerConfig>;
    /**  e.g. episode numer and name or byline for movie */
    subheading: Scalars['String'];
};

/**  Describes a reaction the emoji rain  */
export type PlayerReaction = {
    __typename?: 'PlayerReaction';
    emoji: Scalars['String'];
    id: Scalars['String'];
};

/** A collection of published playables */
export type Playlist = Listable & {
    __typename?: 'Playlist';
    /**  Not used for Playlist  */
    accessibilities: Array<Accessibility>;
    /**  Client hint for reporting to datalake  */
    analyticsIdentifiers: AnalyticsIdentifiers;
    associatedContent: Array<Selection>;
    /**  Is this intended for children based on escenic barn tags?  */
    barn: Scalars['Boolean'];
    /**
     *  Is this Content migrated from the Öppet Arkiv catalogue?
     * @deprecated This is a temporary flag until all clients handle all Öppet Arkiv content
     */
    fullOppetArkiv: Scalars['Boolean'];
    /**  Unique identifier  */
    id: Scalars['ID'];
    /**  Not used for Playlist  */
    image: Image;
    /**  Not used for Playlist  */
    images: Images;
    /**  Not used for Playlist  */
    longDescription: Scalars['String'];
    /**  Editorial messages directed to the viewer  */
    messages: Maybe<Messages>;
    /**  The name of the playlist.  */
    name: Scalars['String'];
    /**  Is this Content from öppetArkiv?  */
    oppetArkiv: Scalars['Boolean'];
    /**  The parent content this item belongs to. For playlists, a pointer to null just for uniformity.  */
    parent: Maybe<Content>;
    /**  Published playables in this playlist  */
    playables: Array<Playable>;
    /**  Popularity for this item from popapp  */
    popularity: Scalars['Int'];
    /**  Not used for Playlist  */
    restrictions: Restrictions;
    /**  Not used for Playlist  */
    shortDescription: Scalars['String'];
    /**  Not used for Playlist  */
    slug: Scalars['String'];
    /**  Not used for Playlist  */
    svtId: Scalars['String'];
    /**  Not used for Playlist  */
    tags: Array<Tag>;
    /**  URL field containing various URL:s, for example SVT Play  */
    urls: Urls;
    /**
     * Default playable video id for this item. Can be used to match a variant
     * to an episode item on a detail page, for example to render progress from
     * local storage or match selected item
     */
    videoSvtId: Scalars['String'];
};

/** A collection of published playables */
export type PlaylistAssociatedContentArgs = {
    addExtras: Maybe<Array<ExtraAssociatedContentId>>;
    exclude: Maybe<Array<AssociatedContentId>>;
    include: Maybe<Array<AssociatedContentId>>;
};

/** Different presentation styles for a selection. */
export enum Presentation {
    /**  A selection that should be presented in the default way  */
    Default = 'Default',
    /**  Content to discover related to other content  */
    Discovery = 'Discovery',
    /**  Should be displayed as a grid  */
    Grid = 'Grid',
    /**  Should be displayed as a "Keep watching" list with for instance a progressbar  */
    KeepWatching = 'KeepWatching',
    /**  Playable items. Used for "snabbtittat" lists  */
    Playlist = 'Playlist',
    /**  Should be displayed with portrait poster images  */
    PortraitPosters = 'PortraitPosters',
    /**  Should be displayed as a list of categories  */
    RelatedCategories = 'RelatedCategories',
    /**  Present this as a season selection under a title */
    Season = 'Season',
    /**  Promoted content. This means that it is presented in a more distinctive manner  */
    Showcase = 'Showcase',
    /**  Present this as a selection containing upcoming  */
    Upcoming = 'Upcoming',
}

export type PresentationHints = {
    __typename?: 'PresentationHints';
    /**  Special mode for breaking news  */
    breakingNews: Scalars['Boolean'];
};

export type ProducingDepartment = {
    __typename?: 'ProducingDepartment';
    id: Scalars['ID'];
    name: Scalars['String'];
};

export type ProductionPeriod = Node & {
    __typename?: 'ProductionPeriod';
    /**  Published episodes within production period  */
    episodes: Array<Episode>;
    /**  Published episodes including upcoming within production period  */
    episodesIncludingUpcoming: Array<Episode>;
    /**  Unique identifier. Today this is the owning Tv Shows´s id with a hyphen and season number appended  */
    id: Scalars['ID'];
    /**  The name of the item. Today it derives from production year.  */
    name: Scalars['String'];
    /**  Total number of episodes in production period  */
    numberOfProducedEpisodes: Scalars['Int'];
    parentNode: Maybe<Node>;
    /**  Rerun information, has this content been present on Play before? Calculated as 'has all episodes been broadcasted earlier'  */
    rerun: Scalars['Boolean'];
    /**  URL field containing various URL:s, for example SVT Play  */
    urls: Urls;
};

/** All content. Used for 'A till Ö'. Holds Singles, TV Series, TV Shows, Kids TV shows */
export type ProgramAtillO = {
    __typename?: 'ProgramAtillO';
    analyticsIdentifiers: AnalyticsIdentifiers;
    flat: Array<Content>;
    selections: Array<Selection>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type Query = {
    __typename?: 'Query';
    /** A selection of more genres. Listed in some clients. */
    additionalGenres: Genres;
    /** Returns all actibve, expired and upcoming episodes that exists in contento, for internal use. */
    allEpisodesForInternalUse: Maybe<Array<Maybe<Episode>>>;
    /** Query for all kids content (titles and singles) which is used internally by editorial applications */
    allKidsTitlesForEditorialSystems: Array<Content>;
    /** Query for all content (titles and singles) which is used internally by fiona to enrich that application */
    allTitlesForEditorialSystems: Array<Content>;
    /**
     * Query for all content (titles and singles, including upcoming) which is used internally by the search indexer for
     * the foundation that search is based at
     */
    allTitlesForSearchIndexer: Array<Content>;
    /** A flat structure of all watchable videos ie Episode and Single Variant as well as clips. Built for Helix. */
    analyticsMetadata: Array<AnalyticsMetadata>;
    /** Query for getting the svt id for the content of a video (e.g. variant) (even for unpublished videos) */
    androidTvContentIdBackfill: Array<ContentInformation>;
    /** Query for fetching data to display on the category page, e.g. "drama" or "sport" */
    categoryPage: Maybe<CategoryPage>;
    /** Returns a list of SVTs channels and their broadcast schedule for today and part of tomorrow */
    channels: Channels;
    /**
     * Query for one or more content items which can be TvSeries, TvShow, KidsTvShow Single, Episode, Clip, Trailer.
     * This query also includes historical content that has expired. Used by editorial systems.
     */
    contentById: Array<Listable>;
    /** Title for given programId */
    contentByProgramIds: Array<Content>;
    /** Query for all content (titles and singles) which is used by external feeds such as Apple, Google and Generic (tv.nu) */
    contentForExternalFeeds: Array<Content>;
    /** Query for modelling a details page, i.e. details page for a Title (TvSeries, TvShow etc) or an Episode */
    detailsPage: Maybe<DetailsPage>;
    /** Query for modelling a details page, i.e. details page for a Title (TvSeries, TvShow etc) or an Episode */
    detailsPageByPath: Maybe<DetailsPage>;
    /** Search indented for editorial system */
    editorialSearch: Array<Listable>;
    /** Returns the endscreenRecomentations that is related to the currently watched playable */
    endScreenRecommendations: Selection;
    /** Query for all episodes in a single flat list */
    episodes: Episodes;
    /** Selection of favorites given a list of title (Content) ids */
    favorites: Selection;
    /**
     * Query for all content (titles and singles) which is used internally by fiona to enrich that application
     * @deprecated Use `allTitlesForEditorialSystems` instead
     */
    fionaContent: Array<Content>;
    /** Query for fetching data for a genre, e.g. "drama", "sport" */
    genres: Array<Genre>;
    /** Query for fetching data for a genre by id, e.g. "drama", "sport" */
    genresByIds: Genres;
    /** All main genres, i.e. 'Huvudkluster' */
    genresInMain: Genres;
    /** Query for fetching all genres in alphabetical order */
    genresSortedByName: Genres;
    /** Query for getting current important messages (VMA/TMA) */
    importantMessages: Array<ImportantMessage>;
    /** Given a list of item ids (svtIds or episode/clip/variant id:s) return a custom selection that can be used for keep watching */
    keepWatching: Selection;
    /** Returns the next running or upcoming live Playable among all kids (barn) titles */
    kidsLiveAndUpcomingLive: Array<Playable>;
    /** Returns all programs scheduled in kunskapskanalen for a specific day */
    kunskapskanalen: Array<KunskapskanalenBroadcast>;
    /** Returns latest news episode from Rapport or Aktuellt */
    latestNewsEpisode: Episode;
    /**
     * Query for one or more items of type Listable which can be TvSeries, TvShow, Single, Episode, Clip, Trailer
     * See the detailsPage query instead of this one which we promote for building a detailsPage.
     */
    listables: Array<Listable>;
    /**
     * Listables by escenicId. Used by svtplay-web. Use listable with svtId if possible
     * See the detailsPage query instead of this one which we promote for building a detailsPage.
     */
    listablesByEscenicId: Array<Listable>;
    /**
     * Query with case insensitive substring search for one or more items of type Listable which can be TvSeries, TvShow, Single, Episode, Clip, Trailer
     * See the detailsPage query instead of this one which we promote for building a detailsPage.
     */
    listablesByName: Array<Listable>;
    /**
     * Returns Content by slug. Used by svtplay-web. Use listables with svtId if possible
     * See the detailsPage query instead of this one which we promote for building a detailsPage.
     */
    listablesBySlug: Array<Listable>;
    /** All main categories, i.e. 'Huvudkluster'. Replaces genresInMain */
    mainCategories: Array<Maybe<CategoryTeaser>>;
    /**
     * New titles which you can start to watch now, i.e. where all episodes are published in the last week.
     * Used for example by kampanj-newsletters
     */
    newTitlesInSvtPlay: Array<RecentlyPublishedContent>;
    /** Query for one or more versions or episodes by ids */
    nodes: Array<Node>;
    /** Given a list of item ids (svtIds or episode/clip/variant id:s) return a custom selection with personal recommendations from Balthazar */
    personalRecommendations: Selection;
    /** Query for all playable content. Default value includeInactiveTvShowsAndSeries is false */
    playContent: PlayContent;
    /** Returns a playQueue for a given variant. */
    playQueue: PlayQueue;
    /** Query for playable content in a flat structure */
    playables: Array<Playable>;
    /** PlayerPage */
    playerPage: PlayerPage;
    /** Query for all content, sorted alphabetically. Used in the web for the 'a till ö' list */
    programAtillO: ProgramAtillO;
    /** Titles where all episodes have expired within the last week */
    recentlyExpiredContent: Maybe<Array<Maybe<Content>>>;
    /** Returns the screen saver page */
    screenSaverPage: ScreenSaverPage;
    /** Search for content by specifying query string and optional maxHits */
    search: Array<SearchHit>;
    /** Search made for Editorial systems */
    searchInternal: InternalSearchResult;
    /** Search for content by specifying query string and optional maxHits */
    searchPage: SearchPage;
    /** Query for selections by Id. Includes fiona selections by genre and start page selections. */
    selectionById: Maybe<Selection>;
    /**
     * Query for SelectionGroups from Fiona by product slug and one or more SelectionGroup slugs.
     * Parameter "names" is deprecated.
     */
    selectionGroups: Array<SelectionGroup>;
    /** Query to get the suggested playable for a title based on history */
    smartStart: Maybe<SmartStart>;
    /** Query startForKids Experimental top query for getting fiona lists for Barn Android TV */
    startForKids: SelectionGroup;
    /** Query for selected lists for start page, e.g. "Recommended", "Popular", "Latest", "Last chance", "Live broadcasts" */
    startForSvtPlay: StartForSvtPlay;
    /** Query for getting the active surveys */
    surveys: Array<Survey>;
    /** TvSeries, TvShows and Singles with upcoming live */
    upcomingLive: Array<Content>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryAllEpisodesForInternalUseArgs = {
    include: Maybe<Array<ContentStatus>>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryAllTitlesForEditorialSystemsArgs = {
    includeAllExtraMaterial: Maybe<Scalars['Boolean']>;
    includeExpiredSingles: Maybe<Scalars['Boolean']>;
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryAnalyticsMetadataArgs = {
    ids: Maybe<Array<Scalars['String']>>;
    sampleSize: Maybe<Scalars['Int']>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryAndroidTvContentIdBackfillArgs = {
    svtIds: Array<Scalars['String']>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryCategoryPageArgs = {
    abTestVariants: Maybe<Array<AbTestVariant>>;
    history: Maybe<Array<History>>;
    id: Scalars['String'];
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryContentByIdArgs = {
    ids: Maybe<Array<Scalars['String']>>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryContentByProgramIdsArgs = {
    programIds: Array<Scalars['String']>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryContentForExternalFeedsArgs = {
    names: Maybe<Array<Scalars['String']>>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryDetailsPageArgs = {
    accessibility: Maybe<Accessibility>;
    id: Scalars['String'];
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryDetailsPageByPathArgs = {
    accessibility: Maybe<Accessibility>;
    path: Scalars['String'];
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryEditorialSearchArgs = {
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
    kidsOrAdult: Maybe<KidsOrAdult>;
    limit: Maybe<Scalars['Int']>;
    query: Maybe<Scalars['String']>;
    typesFilter: Maybe<Array<EditorialSearchFilterType>>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryEndScreenRecommendationsArgs = {
    history: Array<History>;
    id: Scalars['String'];
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryFavoritesArgs = {
    titleIds: Array<Scalars['String']>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryGenresArgs = {
    ids: Maybe<Array<Scalars['String']>>;
    names: Maybe<Array<Scalars['String']>>;
    type: Maybe<Scalars['String']>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryGenresByIdsArgs = {
    ids: Array<Scalars['String']>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryImportantMessagesArgs = {
    platform: Maybe<ImportantMessagePlatform>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryKeepWatchingArgs = {
    history: Array<History>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryKidsLiveAndUpcomingLiveArgs = {
    upcomingLiveUntil: Scalars['Long'];
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryKunskapskanalenArgs = {
    day: Scalars['String'];
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryListablesArgs = {
    accessibility: Maybe<Accessibility>;
    ids: Maybe<Array<Scalars['String']>>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryListablesByEscenicIdArgs = {
    abTestVariants: Maybe<Array<AbTestVariant>>;
    accessibility: Maybe<Accessibility>;
    escenicIds: Array<Scalars['Int']>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryListablesByNameArgs = {
    accessibility: Maybe<Accessibility>;
    names: Maybe<Array<Scalars['String']>>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryListablesBySlugArgs = {
    abTestVariants: Maybe<Array<AbTestVariant>>;
    accessibility: Maybe<Accessibility>;
    slugs: Array<Scalars['String']>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryNodesArgs = {
    ids: Maybe<Array<Scalars['String']>>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryPersonalRecommendationsArgs = {
    abTestVariants: Maybe<Array<AbTestVariant>>;
    clientId: Maybe<Scalars['String']>;
    history: Array<Scalars['String']>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryPlayContentArgs = {
    ids: Maybe<Array<Scalars['String']>>;
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
    includeInactiveTvShowsAndSeries: Maybe<Scalars['Boolean']>;
    names: Maybe<Array<Scalars['String']>>;
    tags: Maybe<Array<Scalars['String']>>;
    upcomingLiveMinutes: Maybe<Scalars['Int']>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryPlayQueueArgs = {
    abTestVariants: Maybe<Array<AbTestVariant>>;
    allowTrailers: Maybe<Scalars['Boolean']>;
    history: Maybe<Array<Scalars['String']>>;
    variantId: Scalars['String'];
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryPlayablesArgs = {
    ids: Maybe<Array<Scalars['String']>>;
    legacyIds: Maybe<Array<Scalars['Int']>>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryPlayerPageArgs = {
    playableId: Scalars['String'];
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryProgramAtillOArgs = {
    filter: Maybe<Filter>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryScreenSaverPageArgs = {
    abTestVariants: Maybe<Array<AbTestVariant>>;
    filter: Maybe<Filter>;
    history: Maybe<Array<History>>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QuerySearchArgs = {
    abTestVariants: Maybe<Array<AbTestVariant>>;
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
    kidsFilter: Maybe<Scalars['Boolean']>;
    maxDescriptionLength: Maybe<Scalars['Int']>;
    maxHits: Maybe<Scalars['Int']>;
    onlyChildContent: Maybe<Scalars['Boolean']>;
    query: Scalars['String'];
    removeEpisodic: Maybe<Scalars['Boolean']>;
    types: Maybe<Array<Maybe<Scalars['String']>>>;
    userIsAbroad: Maybe<Scalars['Boolean']>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QuerySearchInternalArgs = {
    first: Maybe<Scalars['Int']>;
    includeExpired: Maybe<Scalars['Boolean']>;
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
    kidsFilter: Maybe<Scalars['Boolean']>;
    mustExcludeTags: Maybe<Array<Maybe<Scalars['String']>>>;
    mustIncludeTags: Maybe<Array<Maybe<Scalars['String']>>>;
    offset: Maybe<Scalars['Int']>;
    onlyChildContent: Maybe<Scalars['Boolean']>;
    paginateBy: Maybe<InternalSearchPaginationType>;
    query: Maybe<Scalars['String']>;
    types: Maybe<Array<Maybe<InternalSearchMatchType>>>;
    userIsAbroad: Maybe<Scalars['Boolean']>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QuerySearchPageArgs = {
    abTestVariants: Maybe<Array<AbTestVariant>>;
    filter: Maybe<Filter>;
    kidsFilter: Maybe<Scalars['Boolean']>;
    maxHits: Maybe<Scalars['Int']>;
    onlyChildContent: Maybe<Scalars['Boolean']>;
    query: Maybe<Scalars['String']>;
    searchClickHistory: Maybe<Array<SearchHistoryItem>>;
    userIsAbroad: Maybe<Scalars['Boolean']>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QuerySelectionByIdArgs = {
    id: Scalars['String'];
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QuerySelectionGroupsArgs = {
    names: Maybe<Array<Scalars['String']>>;
    product: Maybe<Scalars['String']>;
    slugs: Maybe<Array<Scalars['String']>>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QuerySmartStartArgs = {
    accessibility: Maybe<Accessibility>;
    filter: Maybe<Filter>;
    history: Maybe<Array<History>>;
    id: Scalars['String'];
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryStartForKidsArgs = {
    abTestVariants: Maybe<Array<AbTestVariant>>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QueryStartForSvtPlayArgs = {
    abTestVariants: Maybe<Array<AbTestVariant>>;
};

/**
 * Query is the top level element when writing queries in Contento.
 * You start with a query and drill further down the graph.
 */
export type QuerySurveysArgs = {
    abTestVariants: Array<AbTestVariant>;
    platform: Maybe<Platform>;
};

export type RecentlyPublishedContent = {
    __typename?: 'RecentlyPublishedContent';
    byline: Scalars['String'];
    description: Scalars['String'];
    id: Scalars['ID'];
    name: Scalars['String'];
    title: Content;
};

/**
 * A reference to a Playable. Fields defined in a RecommendedItem allows for
 * overriding the corresponding field in the Promoted Content based on editorial context
 */
export type RecommendedItem = {
    __typename?: 'RecommendedItem';
    byline: Maybe<Scalars['String']>;
    content: Playable;
    description: Maybe<Scalars['String']>;
    image: Image;
    /**  Images from Escenic, including keyart  */
    images: Images;
    legacySlug: Scalars['String'];
    /**  The name of the item when shown in this list. May differ from the actual name of the item.  */
    name: Scalars['String'];
};

export type Restrictions = {
    __typename?: 'Restrictions';
    blockedForChildren: Scalars['Boolean'];
    drmCopyProtection: Scalars['Boolean'];
    onlyAvailableInSweden: Scalars['Boolean'];
    onlyAvailableInSwedenFormatted: Scalars['String'];
};

export type ScreenSaverPage = {
    __typename?: 'ScreenSaverPage';
    /**  Identifiers to use when reporting to Helix  */
    analyticsIdentifiers: AnalyticsIdentifiers;
    /**  Recommendations to show on screen saver page. */
    recommendations: Selection;
};

export type SearchHistoryItem = {
    /**  Listable id  */
    id: Scalars['String'];
};

/**
 * This is a search hit. It aims to contain all fields that are needed to present this in a search result.
 * If something is missing, try accessing it from item field.
 * Can represent `Listable` or `Genre.
 */
export type SearchHit = {
    __typename?: 'SearchHit';
    /**  List of accessibility aides  */
    accessibilities: Array<Accessibility>;
    /**  The badge (overlay/label) for a teaser, for example Live broadcast, Öppet Arkiv, Upcoming, Last chance  */
    badge: Maybe<Badge>;
    /**  Description for the search hit, may contain <em> tags for highlighted words  */
    description: Scalars['String'];
    /**  Episode title for the search hit if this is an episode, may contain <em> tags for highlighted words  */
    episodeTitle: Maybe<Scalars['String']>;
    /**  Id of the underlying item  */
    id: Scalars['ID'];
    /**  Image for the search hit  */
    image: Image;
    /**  If this is a genre hit  */
    isGenre: Scalars['Boolean'];
    /**  The underlying item. A union of Genre and Listable. Avoid accessing this if possible  */
    item: SearchHitItem;
    /**  If this is an ongoing live broadcast  */
    liveNow: Scalars['Boolean'];
    /**  Name of the search hit, may contain <em> tags for highlighted words. Can be a combination of "title - episode title"  */
    name: Scalars['String'];
    /**  If search hit is öppet arkiv   */
    oppetArkiv: Scalars['Boolean'];
    /**  SvtId of the underlying item or null if a genre hit  */
    svtId: Maybe<Scalars['String']>;
    /**  Title for the search hit, may contain <em> tags for highlighted words. If this is an episode hit, this is the parent title  */
    title: Scalars['String'];
};

export type SearchHitItem = Clip | Episode | Genre | KidsTvShow | Single | Trailer | TvSeries | TvShow;

export type SearchPage = {
    __typename?: 'SearchPage';
    /**  Identifiers to use when reporting to Helix  */
    analyticsIdentifiers: AnalyticsIdentifiers;
    /**  All search hits including categories */
    flat: Maybe<SearchPageHits>;
    heading: Maybe<SearchPageHeading>;
    /**  Recommendations to show on search page. May be empty. */
    recommendations: Array<Selection>;
    /**  All search hits including categories divided into sections */
    sectioned: Array<SearchPageHits>;
};

export type SearchPageHeading = {
    __typename?: 'SearchPageHeading';
    text: Scalars['String'];
    type: SearchPageHeadingType;
};

export enum SearchPageHeadingType {
    /**  Information to display when presenting hits  */
    Default = 'Default',
    /**  Information to display before searching  */
    PreSearch = 'PreSearch',
    /**  Information to display when there are no hits  */
    ZeroHits = 'ZeroHits',
}

export type SearchPageHit = {
    __typename?: 'SearchPageHit';
    /**  The hit item if it is a category  */
    categoryTeaser: Maybe<CategoryTeaser>;
    /**  The hit item if it is not a category  */
    teaser: Maybe<Teaser>;
};

export type SearchPageHits = {
    __typename?: 'SearchPageHits';
    /**  Identifiers for this list of hits  */
    analyticsIdentifiers: SelectionAnalyticsIdentifiers;
    hits: Array<SearchPageHit>;
    /**  Heading to display above hits, if there is one  */
    name: Maybe<Scalars['String']>;
};

export type Season = Node & {
    __typename?: 'Season';
    /**  Published episodes within season  */
    episodes: Array<Episode>;
    /**  Published episodes including upcoming within season  */
    episodesIncludingUpcoming: Array<Episode>;
    /**  Unique identifier. Today this is the owning Tv Series´s id with a hyphen and season number appended  */
    id: Scalars['ID'];
    /**  The name of the item. Today it derives from season number  */
    name: Scalars['String'];
    number: Scalars['Int'];
    /**  Total number of episodes in season  */
    numberOfProducedEpisodes: Scalars['Int'];
    parentNode: Maybe<Node>;
    /**  Rerun information, has this content been present on Play before? Calculated as 'has all episodes been broadcasted earlier'  */
    rerun: Scalars['Boolean'];
    urls: Urls;
};

/** A named list of selection of Content items */
export type Selection = {
    __typename?: 'Selection';
    /**
     *  If the selection is filtered by Accessibility, this field will be set
     * to the same accessibility as the corresponding filter
     */
    accessibility: Maybe<Accessibility>;
    /**  Identifiers to use when reporting to Helix  */
    analyticsIdentifiers: SelectionAnalyticsIdentifiers;
    /**  List of categories, used for fetching related categories.  */
    categories: Array<CategoryTeaser>;
    /**
     *  List of content items comprising the selection
     * @deprecated Use `items`
     */
    content: Array<Node>;
    /**  Unique id for the selection  */
    id: Scalars['ID'];
    /**  Image of the selection  */
    image: Maybe<Image>;
    /**  List containing teaser data  */
    items: Array<Teaser>;
    /**  Name of the selection, e.g. "Drama"  */
    name: Scalars['String'];
    /**  How to present this selection, e.g. "showcase"  */
    presentation: Presentation;
    /**  Hints on how to present special case e.g. breaking mode in Showcase window  */
    presentationHints: Maybe<PresentationHints>;
    /**  Type of content in list. For example: recommended, latest, upcoming  */
    selectionType: Scalars['String'];
    /**
     *  Type of the selection, e.g. "showcase"
     * @deprecated Use `presentation`
     */
    type: SelectionType;
};

/** A named list of selection of Content items */
export type SelectionItemsArgs = {
    filter: Maybe<Filter>;
    kidsFilter: Maybe<Scalars['Boolean']>;
    maxSize: Maybe<Scalars['Int']>;
    userIsAbroad: Maybe<Scalars['Boolean']>;
};

export type SelectionAnalyticsIdentifiers = {
    __typename?: 'SelectionAnalyticsIdentifiers';
    listId: Scalars['String'];
    listType: Scalars['String'];
};

export type SelectionGroup = {
    __typename?: 'SelectionGroup';
    analyticsIdentifiers: AnalyticsIdentifiers;
    name: Scalars['String'];
    selections: Array<Selection>;
    slug: Scalars['String'];
};

/** Type of item the selection contains */
export enum SelectionType {
    /**  general content  */
    Default = 'Default',
    /**  content to discover related to other content  */
    Discovery = 'Discovery',
    /**  content that should be displayed as a "Continue watching" list with for example an progressbar  */
    KeepWatching = 'KeepWatching',
    /**
     * A list with content that a client decides what it should be.
     * Can for example be recommendations or history. Used by SVT barn for now.
     */
    Personal = 'Personal',
    /**  playable items  */
    Playlist = 'Playlist',
    /**  episodes in a season or production period  */
    Season = 'Season',
    /**  promoted content  */
    Showcase = 'Showcase',
    /**  upcoming content  */
    Upcoming = 'Upcoming',
}

/** A Single is a piece of stand-alone, playable content, e.g. a movie or short film */
export type Single = Content &
    Listable &
    Node &
    Playable & {
        __typename?: 'Single';
        /**  List of accessibility aides. Each aid is present if at least one of the variants has it  */
        accessibilities: Array<Accessibility>;
        /**  Client hint for reporting to datalake  */
        analyticsIdentifiers: AnalyticsIdentifiers;
        /**  The proportional relationship between the video's width and height  */
        aspectRatio: Maybe<Scalars['String']>;
        /**  A list of lists with associated content, for example related and clips  */
        associatedContent: Array<Selection>;
        /**  Is this intended for children based on escenic barn tags?  */
        barn: Scalars['Boolean'];
        /**  Popularity for this item from barnplay-popapp, for use in the SVT barn service  */
        barnPopularity: Scalars['Int'];
        /**  TrendingMetric for this item from barnplay-popapp, for use in the SVT barn service  */
        barnTrending: Scalars['Float'];
        /**  List of cast, today taken from Meta  */
        cast: Array<Participant>;
        /**  List of cast and crew, grouped by role, sorted for presentation  */
        castAndCrew: Array<CastAndCrewSection>;
        /**  Special image used for kids content to show the main character of the show  */
        characterImage: Maybe<Image>;
        /**  List of production companies that produced this single  */
        coProducedByCompanies: Array<Company>;
        /**  Viewer warnings for this playable  */
        contentWarning: Maybe<ContentWarning>;
        /**  Producing country or countries  */
        countriesOfOrigin: Array<Scalars['String']>;
        /**  List of crew, today taken from Meta  */
        crew: Array<Participant>;
        /**  Deep links for different services, e.g. svt play and barn play  */
        deepLinks: DeepLinks;
        /**  Content length in seconds  */
        duration: Scalars['Int'];
        /**  Content length in a formatted format according to the styleguide  */
        durationFormatted: Scalars['String'];
        /**  Content length in ISO format (hh:mm:ss)  */
        durationISOFormatted: Scalars['String'];
        /**  End Credit Start time in seconds  */
        endCreditStart: Maybe<Scalars['Int']>;
        /**
         *  The episode this playable belongs to. Examples: Variant will return the Episode or Single to which it belongs.
         * Single and Episode it will return itself. Clip and Trailer will return itself because it has no episode playable.
         */
        episode: Playable;
        /**  Episodes as a flat list  */
        episodes: Array<Playable>;
        /**
         *  Episodes as a flat list including some upcoming episodes used by searchIndexer
         * @deprecated This is only used by searchIndexer and is therefor hidden in explorer
         */
        episodesForSearchIndexer: Array<Playable>;
        /**  Extra material like clips or trailers for the entire tv show  */
        extraMaterial: Array<ExtraMaterial>;
        /**
         *  Is this Content migrated from the Öppet Arkiv catalogue?
         * @deprecated This is a temporary flag until all clients handle all Öppet Arkiv content
         */
        fullOppetArkiv: Scalars['Boolean'];
        /**  Categorization by cluster tags ("video@..." or "editorialvideo@...")  */
        genres: Array<Genre>;
        /**  Unique identifier. Today this is the Vision episode id  */
        id: Scalars['ID'];
        /**  Image from Escenic is used, see rules on contento startpage  */
        image: Image;
        /**  Images from Escenic, including keyart, see rules on contento startpage  */
        images: Images;
        /**  Internal Information - Do not build integrations using this, it´s meant to be read by a human  */
        internal: InternalInformation;
        /**  Languages for all episodes of all seasons. Uses three-letter iso format, and "sgn" for Sign language  */
        languages: Array<Scalars['String']>;
        /**  The duration of the latest episode in seconds  */
        latestEpisodeDurationSeconds: Maybe<Scalars['Long']>;
        /**  The latest PublicationDate of its underlying episodes  */
        latestEpisodePublicationDate: Maybe<Scalars['Timestamp']>;
        /**  Information for live broadcasts  */
        live: Maybe<Live>;
        /**  Defined in Vision. Format is suitable for a printed TV Guide  */
        longDescription: Scalars['String'];
        /**  Contains all languages that are present as mainLanguage in any variant  */
        mainLanguages: Array<Language>;
        /**  Editorial messages directed to the viewer  */
        messages: Maybe<Messages>;
        /**  The name of the item. Follows all the presentation rules for our services.  */
        name: Scalars['String'];
        /**  Time when the next episode will be published, empty for Singles  */
        nextEpisodeAvailable: Maybe<Scalars['Timestamp']>;
        /**  Next episode in a formatted format according to the styleguide, empty for Singles  */
        nextEpisodeAvailableFormatted: Maybe<Scalars['String']>;
        /**  Number of active episodes  */
        numberOfActiveEpisodes: Scalars['Int'];
        /**  Is this Content from öppetArkiv?  */
        oppetArkiv: Scalars['Boolean'];
        /**  The original title for the playables parent content  */
        originalProgramTitle: Scalars['String'];
        /**  Pointer to self as a Content instance, can be used for accessing parent.legacySlug in a type-agnostic way for example  */
        parent: Content;
        parentNode: Maybe<Node>;
        /**  Popularity for this item from popapp  */
        popularity: Scalars['Int'];
        /**  Special image used for kids content to show a portrait poster image  */
        portraitPosterImage: Maybe<Image>;
        prioritizedSearchTags: Array<Scalars['String']>;
        /**  Production year from Vision  */
        productionYear: Maybe<Scalars['Int']>;
        /**  Related content from Balthazar  */
        related: Array<Content>;
        /**  Rerun information, has this content been present on Play before? Calculated as 'has all episodes been broadcasted earlier'  */
        rerun: Scalars['Boolean'];
        /**  Restrictions for different viewer groups (location, age)  */
        restrictions: Restrictions;
        /**  SearchTags also describing this content (searchTags)  */
        searchTags: Array<Scalars['String']>;
        /**  Defined in Vision. Usually used as byline below the name  */
        shortDescription: Scalars['String'];
        /**  Slug fragment that can be used to construct a URL to this item  */
        slug: Scalars['String'];
        /**  New unique identifier  */
        svtId: Scalars['String'];
        /**  Defined in Escenic. Tags are used to group or classify content  */
        tags: Array<Tag>;
        /**  Internal title info  */
        titleInternalInformation: Maybe<TitleInternalInformation>;
        /**  URL field containing various URL:s, for example SVT Play  */
        urls: Urls;
        /**  Start of rights  */
        validFrom: Maybe<Scalars['Timestamp']>;
        /**  Start of rights in a formatted format according to the styleguide  */
        validFromFormatted: Maybe<Scalars['String']>;
        /**  End of rights  */
        validTo: Maybe<Scalars['Timestamp']>;
        /**  End of rights in a formatted format according to the styleguide  */
        validToFormatted: Maybe<Scalars['String']>;
        /**  Variants of this content like accessibility or spoken language  */
        variants: Array<Variant>;
        /**  Available video streaming formats  */
        videoFormats: Array<Scalars['String']>;
        /**
         * Default playable video id for this item. Can be used to match a variant
         * to an episode item on a detail page, for example to render progress from
         * local storage or match selected item
         */
        videoSvtId: Scalars['String'];
        /**  List of playable videos  */
        videos: Array<Video>;
        /**
         * When in seconds clients should show skip to next episode button.
         * Based on endCreditStart or logic based on length of program.
         * If missing, do not show skip to next button.
         */
        whenToDisplaySkipToNext: Maybe<Scalars['Int']>;
    };

/** A Single is a piece of stand-alone, playable content, e.g. a movie or short film */
export type SingleAssociatedContentArgs = {
    addExtras: Maybe<Array<ExtraAssociatedContentId>>;
    exclude: Maybe<Array<AssociatedContentId>>;
    include: Maybe<Array<AssociatedContentId>>;
};

export type SmartStart = {
    __typename?: 'SmartStart';
    badge: Maybe<Badge>;
    /**  Content Warning for Content. Content Warning for Playable is on SmartStart.item.contentWarning  */
    contentWarning: Maybe<ContentWarning>;
    id: Scalars['ID'];
    isDrmCopyProtected: Scalars['Boolean'];
    item: Playable;
    label: Scalars['String'];
    screenreaderLabel: Scalars['String'];
    videoSvtId: Scalars['String'];
};

export type StartForSvtPlay = {
    __typename?: 'StartForSvtPlay';
    analyticsIdentifiers: AnalyticsIdentifiers;
    name: Scalars['String'];
    selections: Array<Selection>;
};

export type StartForSvtPlaySelectionsArgs = {
    exclude: Maybe<Array<Maybe<StartSelectionId>>>;
    include: Maybe<Array<Maybe<StartSelectionId>>>;
    includeById: Maybe<Array<Scalars['String']>>;
};

export enum StartSelectionId {
    Dokumentartips = 'dokumentartips',
    DokumentartipsStart = 'dokumentartips_start',
    Dramatips = 'dramatips',
    DramatipsStart = 'dramatips_start',
    Fiona = 'fiona',
    Humortips = 'humortips',
    HumortipsStart = 'humortips_start',
    Lastchance = 'lastchance',
    LastchanceStart = 'lastchance_start',
    Latest = 'latest',
    LatestStart = 'latest_start',
    Live = 'live',
    LiveStart = 'live_start',
    Popular = 'popular',
    PopularStart = 'popular_start',
    Recommended = 'recommended',
    RecommendedStart = 'recommended_start',
    Shortformat = 'shortformat',
    ShortformatStart = 'shortformat_start',
}

export type Survey = {
    __typename?: 'Survey';
    customAttributes: Array<SurveyCustomAttribute>;
    heading: Scalars['String'];
    id: Scalars['String'];
    image: Image;
    qrCodeImage: Image;
    subHeading: Scalars['String'];
    surveyUrl: Scalars['String'];
};

/**
 * These values are fetched from surveys backend (Athena), and can be used for placement or
 * other platform specific modification like only visible from version x.x.x
 */
export type SurveyCustomAttribute = {
    __typename?: 'SurveyCustomAttribute';
    key: Scalars['String'];
    value: Scalars['String'];
};

export type Tag = {
    __typename?: 'Tag';
    id: Scalars['ID'];
    /**  The name of the tag, e.g. "Barn"  */
    name: Scalars['String'];
    /**  The slug of the tag, e.g. "samhalle-och-fakta"  */
    slug: Scalars['String'];
};

export type Teaser = {
    __typename?: 'Teaser';
    /**  Which accessibility icons/flags/info that should be marked for this teaser  */
    accessibilityFlags: Array<AccessibilityFlag>;
    /**  The badge (overlay/label) for a teaser, for example Live broadcast, Öppet Arkiv, Upcoming, Last chance  */
    badge: Maybe<Badge>;
    /**  Ingångsord  */
    byline: Scalars['String'];
    /**  Custom short description that can be placed on a small area e.g an Image  */
    description: Scalars['String'];
    /**  Custom short description suitable for mobile apps where space is limited  */
    descriptionForMobile: Scalars['String'];
    /**  Content length in a formatted format according to the styleguide, null if tvseries or tvshows  */
    durationFormatted: Maybe<Scalars['String']>;
    /**  Main heading (rubrik) to be used when displaying this item in a list. Context-sensitive, depending on in which selection this teaser is shown.  */
    heading: Scalars['String'];
    /** The unique id of a teaser */
    id: Scalars['String'];
    /**  The Image of this item, choosen specific for teasing for it  */
    image: Image;
    /**  Images from Escenic, including keyart  */
    images: Images;
    /**  The item we tease for  */
    item: Listable;
    /**  The name of the item when shown in this list. May differ from the actual name of the item.  */
    name: Scalars['String'];
    /**  If teaser is for an item that has watch progress, for keepWatching case, this is the progress  */
    progressFraction: Maybe<Scalars['Int']>;
    /**  If this is item should be shown as selected, for example in a play queue  */
    selected: Scalars['Boolean'];
    /**  Sub heading (underrubrik) to be used when displaying this item in a list. Context-sensitive, depending on in which selection this teaser is shown.  */
    subHeading: Scalars['String'];
};

export type TitleInternalInformation = {
    __typename?: 'TitleInternalInformation';
    programIds: Maybe<Array<Maybe<Scalars['Int']>>>;
    state: TitleState;
};

export enum TitleState {
    Published = 'Published',
    Unpublished = 'Unpublished',
}

export type Trailer = ExtraMaterial &
    Listable &
    Node &
    Playable &
    Video & {
        __typename?: 'Trailer';
        /**  List of available accessibility aides.  */
        accessibilities: Array<Accessibility>;
        /**  Accessibility data for this trailer  */
        accessibility: Maybe<Accessibility>;
        /**  Client hint for reporting to datalake  */
        analyticsIdentifiers: AnalyticsIdentifiers;
        /**  The proportional relationship between the video's width and height  */
        aspectRatio: Scalars['String'];
        /**
         * A list of lists with associated content, for example seasons from parent,
         * related from parent and clips from parent.
         */
        associatedContent: Array<Selection>;
        /**  Is this intended for children based on escenic barn tags?  */
        barn: Scalars['Boolean'];
        /**  Viewer warnings for this playable  */
        contentWarning: Maybe<ContentWarning>;
        /**  Content length in seconds  */
        duration: Scalars['Int'];
        /**  Content length in a formatted format according to the styleguide  */
        durationFormatted: Scalars['String'];
        /**  Content length in ISO format (hh:mm:ss)  */
        durationISOFormatted: Scalars['String'];
        /**  End Credit Start time in seconds  */
        endCreditStart: Maybe<Scalars['Int']>;
        /**
         *  The episode this playable belongs to. Examples: Variant will return the Episode or Single to which it belongs.
         * Single and Episode it will return itself. Clip and Trailer will return itself because it has no episode playable.
         */
        episode: Playable;
        /**
         *  Is this Content migrated from the Öppet Arkiv catalogue?
         * @deprecated This is a temporary flag until all clients handle all Öppet Arkiv content
         */
        fullOppetArkiv: Scalars['Boolean'];
        genres: Array<Genre>;
        id: Scalars['ID'];
        image: Image;
        /**  Images from Escenic, including keyart, see rules on contento startpage  */
        images: Images;
        /**  Trailers can never be live, only needed for completeness  */
        live: Maybe<Live>;
        longDescription: Scalars['String'];
        /**  Editorial messages directed to the viewer  */
        messages: Maybe<Messages>;
        /**  The name of the item. Follows all the presentation rules for our services.  */
        name: Scalars['String'];
        /**  Teaser image used by news & sports for current events in a news context, for example if Charlotte Kalla has won. Can contain spoilers  */
        newsTeaserImage: Image;
        /**  Is this Content from öppetArkiv?  */
        oppetArkiv: Scalars['Boolean'];
        /**  The original title for the playables parent content, always empty for extra material  */
        originalProgramTitle: Scalars['String'];
        /**
         * The main parent content (TvSeries/TvShow/Single) this clip belongs to ((if it has any relation).
         * This is only left for legacy reasons.
         */
        parent: Maybe<Content>;
        parentNode: Maybe<Node>;
        /**  All parents (TvSeries/TvShows/Singles) that this clips belongs to.  */
        parents: Array<Content>;
        /**  Popularity for this item from popapp  */
        popularity: Scalars['Int'];
        /**  Production year from Vision  */
        productionYear: Maybe<Scalars['Int']>;
        restrictions: Restrictions;
        shortDescription: Scalars['String'];
        /**  Slug fragment that can be used to construct a URL to this item  */
        slug: Scalars['String'];
        /**  New unique identifier  */
        svtId: Scalars['String'];
        tags: Array<Tag>;
        /**  URL field containing various URL:s, for example SVT Play  */
        urls: Urls;
        /**  Start of rights  */
        validFrom: Maybe<Scalars['Timestamp']>;
        /**  Start of rights in a formatted format according to the styleguide  */
        validFromFormatted: Maybe<Scalars['String']>;
        /**  End of rights  */
        validTo: Maybe<Scalars['Timestamp']>;
        /**  End of rights in a formatted format according to the styleguide  */
        validToFormatted: Maybe<Scalars['String']>;
        videoFormats: Array<Scalars['String']>;
        /**
         * Default playable video id for this item. Can be used to match a variant
         * to an episode item on a detail page, for example to render progress from
         * local storage or match selected item
         */
        videoSvtId: Scalars['String'];
        /**  List of playable videos  */
        videos: Array<Video>;
        /**
         * When in seconds clients should show skip to next episode button.
         * Based on endCreditStart or logic based on length of program.
         * If missing, do not show skip to next button.
         */
        whenToDisplaySkipToNext: Maybe<Scalars['Int']>;
    };

export type TrailerAssociatedContentArgs = {
    addExtras: Maybe<Array<ExtraAssociatedContentId>>;
    exclude: Maybe<Array<AssociatedContentId>>;
    include: Maybe<Array<AssociatedContentId>>;
};

/**
 * A TV Series is episodic content, intended to be watched in a specific order. It usually consists of a number
 * of seasons, each with a number of connected **tv series episodes** in them
 */
export type TvSeries = Content &
    Listable &
    Node & {
        __typename?: 'TvSeries';
        /**  List of accessibility aides. Each aid is present if at least one of the episodes has it  */
        accessibilities: Array<Accessibility>;
        /**  Client hint for reporting to datalake  */
        analyticsIdentifiers: AnalyticsIdentifiers;
        /**  A list of lists with associated content, for example seasons, related and clips  */
        associatedContent: Array<Selection>;
        /**  Is this intended for children based on escenic barn tags?  */
        barn: Scalars['Boolean'];
        /**  Popularity for this item from barnplay-popapp, for use in the SVT barn service  */
        barnPopularity: Scalars['Int'];
        /**  TrendingMetric for this item from barnplay-popapp, for use in the SVT barn service  */
        barnTrending: Scalars['Float'];
        /**  Special image used for kids content to show the main character of the show  */
        characterImage: Maybe<Image>;
        /**  Viewer warning for this content, calculated from its episodes  */
        contentWarning: Maybe<ContentWarning>;
        /**  Producing country or countries  */
        countriesOfOrigin: Array<Scalars['String']>;
        /**  Deep links for different services, e.g. svt play and barn play  */
        deepLinks: DeepLinks;
        /**  Episodes as a flat list  */
        episodes: Array<Playable>;
        /**
         *  Episodes as a flat list including some upcoming episodes used by searchIndexer
         * @deprecated This is only used by searchIndexer and is therefor hidden in explorer
         */
        episodesForSearchIndexer: Array<Playable>;
        /**  Extra material like clips or trailers for the entire series  */
        extraMaterial: Array<ExtraMaterial>;
        /**
         *  Is this Content migrated from the Öppet Arkiv catalogue?
         * @deprecated This is a temporary flag until all clients handle all Öppet Arkiv content
         */
        fullOppetArkiv: Scalars['Boolean'];
        /**  Categorization by cluster tags ("video@..." or "editorialvideo@...")  */
        genres: Array<Genre>;
        /**  Unique identifier. Today this is the Escenic title page id  */
        id: Scalars['ID'];
        /**  Image from Escenic is used, see rules on contento startpage  */
        image: Image;
        /**  Images from Escenic, including keyart, see rules on contento startpage  */
        images: Images;
        /**  Languages for all episodes of all seasons. Uses three-letter iso format, and "sgn" for Sign language  */
        languages: Array<Scalars['String']>;
        /**  The duration of the latest episode in seconds  */
        latestEpisodeDurationSeconds: Maybe<Scalars['Long']>;
        /**  The latest PublicationDate of its underlying episodes  */
        latestEpisodePublicationDate: Maybe<Scalars['Timestamp']>;
        /**  Defined in Vision. Format is suitable for a printed TV Guide  */
        longDescription: Scalars['String'];
        /**  Contains all languages that are present as mainLanguage in any episode variant  */
        mainLanguages: Array<Language>;
        /**  Editorial messages directed to the viewer  */
        messages: Maybe<Messages>;
        /**  The name of the item. Follows all the presentation rules for our services  */
        name: Scalars['String'];
        /**  Time when the next episode will be published  */
        nextEpisodeAvailable: Maybe<Scalars['Timestamp']>;
        /**  Next episode in a formatted format according to the styleguide  */
        nextEpisodeAvailableFormatted: Maybe<Scalars['String']>;
        /**  Number of active episodes  */
        numberOfActiveEpisodes: Scalars['Int'];
        /**  Is this Content from öppetArkiv?  */
        oppetArkiv: Scalars['Boolean'];
        /** Parent to which this belongs. Content will return itself. */
        parent: Maybe<Content>;
        parentNode: Maybe<Node>;
        /**  Popularity for this item from popapp  */
        popularity: Scalars['Int'];
        /**  Special image used for kids content to show a portrait poster image  */
        portraitPosterImage: Maybe<Image>;
        prioritizedSearchTags: Array<Scalars['String']>;
        /**  Related content from Balthazar  */
        related: Array<Content>;
        /**  Rerun information, has this content been present on Play before? Calculated as 'has all episodes been broadcasted earlier'  */
        rerun: Scalars['Boolean'];
        /**  Restrictions for different viewer groups (location, age)  */
        restrictions: Restrictions;
        /**  SearchTags also describing this content (searchTags)  */
        searchTags: Array<Scalars['String']>;
        /**  All available seasons  */
        seasons: Array<Season>;
        /**  Defined in Vision. Usually used as byline below the name  */
        shortDescription: Scalars['String'];
        /**  Slug fragment that can be used to construct a URL to this item  */
        slug: Scalars['String'];
        /**  New unique identifier  */
        svtId: Scalars['String'];
        /**  Defined in Escenic. Tags are used to group or classify content  */
        tags: Array<Tag>;
        /**  Internal title info  */
        titleInternalInformation: Maybe<TitleInternalInformation>;
        /**  URL field containing various URL:s, for example SVT Play  */
        urls: Urls;
        /**
         * Default playable video id for this item. Can be used to match a variant
         * to an episode item on a detail page, for example to render progress from
         * local storage or match selected item
         */
        videoSvtId: Scalars['String'];
    };

/**
 * A TV Series is episodic content, intended to be watched in a specific order. It usually consists of a number
 * of seasons, each with a number of connected **tv series episodes** in them
 */
export type TvSeriesAssociatedContentArgs = {
    addExtras: Maybe<Array<ExtraAssociatedContentId>>;
    exclude: Maybe<Array<AssociatedContentId>>;
    include: Maybe<Array<AssociatedContentId>>;
};

/**
 * A TV Show is split up by its production periods, each with a number of
 * **tv show episodes** in them, where the last broadcasted episode is usually
 * the one the viewer wants to watch
 */
export type TvShow = Content &
    Listable &
    Node & {
        __typename?: 'TvShow';
        /**  List of accessibility aides. Each aid is present if at least one of the episodes has it  */
        accessibilities: Array<Accessibility>;
        /**  Client hint for reporting to datalake  */
        analyticsIdentifiers: AnalyticsIdentifiers;
        /**  A list of lists with associated content, for example seasons, related and clips  */
        associatedContent: Array<Selection>;
        /**  Is this intended for children based on escenic barn tags?  */
        barn: Scalars['Boolean'];
        /**  Popularity for this item from barnplay-popapp, for use in the SVT barn service  */
        barnPopularity: Scalars['Int'];
        /**  TrendingMetric for this item from barnplay-popapp, for use in the SVT barn service  */
        barnTrending: Scalars['Float'];
        /**  Special image used for kids content to show the main character of the show  */
        characterImage: Maybe<Image>;
        /**  Viewer warnings for this TV show  */
        contentWarning: Maybe<ContentWarning>;
        /**  Producing country or countries  */
        countriesOfOrigin: Array<Scalars['String']>;
        /**  Are the production periods composed from editorial tv show sections?  */
        customSections: Scalars['Boolean'];
        /**  Deep links for different services, e.g. svt play and barn play  */
        deepLinks: DeepLinks;
        /**  Episodes as a flat list  */
        episodes: Array<Playable>;
        /**
         *  Episodes as a flat list including some upcoming episodes used by searchIndexer
         * @deprecated This is only used by searchIndexer and is therefor hidden in explorer
         */
        episodesForSearchIndexer: Array<Playable>;
        /**  Extra material like clips or trailers for the entire tv show  */
        extraMaterial: Array<ExtraMaterial>;
        /**
         *  Is this Content migrated from the Öppet Arkiv catalogue?
         * @deprecated This is a temporary flag until all clients handle all Öppet Arkiv content
         */
        fullOppetArkiv: Scalars['Boolean'];
        /**  Categorization by cluster tags ("video@..." or "editorialvideo@...")  */
        genres: Array<Genre>;
        /**  Unique identifier. Today this is the Escenic title page id  */
        id: Scalars['ID'];
        /**  Image from Escenic is used, see rules on contento startpage  */
        image: Image;
        /**  Images from Escenic, including keyart, see rules on contento startpage  */
        images: Images;
        /**  Languages for all episodes of all seasons. Uses three-letter iso format, and "sgn" for Sign language  */
        languages: Array<Scalars['String']>;
        /**  The duration of the latest episode in seconds  */
        latestEpisodeDurationSeconds: Maybe<Scalars['Long']>;
        /**  The latest PublicationDate of its underlying episodes  */
        latestEpisodePublicationDate: Maybe<Scalars['Timestamp']>;
        /**  Defined in Vision. Format is suitable for a printed TV Guide  */
        longDescription: Scalars['String'];
        /**  Contains all languages that are present as mainLanguage in any episode variant  */
        mainLanguages: Array<Language>;
        /**  Editorial messages directed to the viewer  */
        messages: Maybe<Messages>;
        /**  The name of the item. Follows all the presentation rules for our services.  */
        name: Scalars['String'];
        /**  Time when the next episode will be published  */
        nextEpisodeAvailable: Maybe<Scalars['Timestamp']>;
        /**  Next episode in a formatted format according to the styleguide  */
        nextEpisodeAvailableFormatted: Maybe<Scalars['String']>;
        /**  Number of active episodes  */
        numberOfActiveEpisodes: Scalars['Int'];
        /**  Is this Content from öppetArkiv?  */
        oppetArkiv: Scalars['Boolean'];
        /** Parent to which this belongs. Content will return itself. */
        parent: Maybe<Content>;
        parentNode: Maybe<Node>;
        /**  Popularity for this item from popapp  */
        popularity: Scalars['Int'];
        /**  Special image used for kids content to show a portrait poster image  */
        portraitPosterImage: Maybe<Image>;
        prioritizedSearchTags: Array<Scalars['String']>;
        /**  All available production periods grouped by production year  */
        productionPeriods: Array<ProductionPeriod>;
        /**  Related content from Balthazar  */
        related: Array<Content>;
        /**  Rerun information, has this content been present on Play before? Calculated as 'has all episodes been broadcasted earlier'  */
        rerun: Scalars['Boolean'];
        /**  Restrictions for different viewer groups (location, age)  */
        restrictions: Restrictions;
        /**  SearchTags also describing this content (searchTags)  */
        searchTags: Array<Scalars['String']>;
        /**  Defined in Vision. Usually used as byline below the name  */
        shortDescription: Scalars['String'];
        /**  Slug fragment that can be used to construct a URL to this item  */
        slug: Scalars['String'];
        /**  New unique identifier  */
        svtId: Scalars['String'];
        /**  Defined in Escenic. Tags are used to group or classify content  */
        tags: Array<Tag>;
        /**  Internal title info  */
        titleInternalInformation: Maybe<TitleInternalInformation>;
        /**  URL field containing various URL:s, for example SVT Play  */
        urls: Urls;
        /**
         * Default playable video id for this item. Can be used to match a variant
         * to an episode item on a detail page, for example to render progress from
         * local storage or match selected item
         */
        videoSvtId: Scalars['String'];
    };

/**
 * A TV Show is split up by its production periods, each with a number of
 * **tv show episodes** in them, where the last broadcasted episode is usually
 * the one the viewer wants to watch
 */
export type TvShowAssociatedContentArgs = {
    addExtras: Maybe<Array<ExtraAssociatedContentId>>;
    exclude: Maybe<Array<AssociatedContentId>>;
    include: Maybe<Array<AssociatedContentId>>;
};

export type Urls = {
    __typename?: 'Urls';
    svtplay: Scalars['String'];
};

/** Variants of same content like accessibility or spoken language */
export type Variant = Listable &
    Node &
    Playable &
    Video & {
        __typename?: 'Variant';
        /**  List of available accessibility aides.  */
        accessibilities: Array<Accessibility>;
        /**  Accessibility data for this variant  */
        accessibility: Maybe<Accessibility>;
        /**  Not used for variant, use field on parent episode  */
        analyticsIdentifiers: AnalyticsIdentifiers;
        /**  The proportional relationship between the video's width and height  */
        aspectRatio: Maybe<Scalars['String']>;
        /**  A list of lists with associated content, for example seasons, related and clips  */
        associatedContent: Array<Selection>;
        /**  Is this intended for children based on escenic barn tags?  */
        barn: Scalars['Boolean'];
        /**  Viewer warnings for this playable  */
        contentWarning: Maybe<ContentWarning>;
        /**  Content length in seconds  */
        duration: Scalars['Int'];
        /**  Content length in a formatted format according to the styleguide  */
        durationFormatted: Scalars['String'];
        /**  Content length in ISO format (hh:mm:ss)  */
        durationISOFormatted: Scalars['String'];
        /**  End Credit Start time in seconds  */
        endCreditStart: Maybe<Scalars['Int']>;
        /**  The episode this variant belongs to  */
        episode: Playable;
        /**
         *  Is this Content migrated from the Öppet Arkiv catalogue?
         * @deprecated This is a temporary flag until all clients handle all Öppet Arkiv content
         */
        fullOppetArkiv: Scalars['Boolean'];
        /**  Categorization by cluster tags ("video@..." or "editorialvideo@...")  */
        genres: Array<Genre>;
        /**  Highlights are like bookmarks within the video which editors have selected  */
        highlights: Array<Highlight>;
        /**
         * Id for variant. Note: Variant is incidentally related
         * to the TvSeries/TvShow id. The TvSeries/TvShow id can not inferred be from
         * any contained variant id
         */
        id: Scalars['ID'];
        /**  Image from Escenic is used, see rules on contento startpage  */
        image: Image;
        /**  Images from Escenic, including keyart, see rules on contento startpage  */
        images: Images;
        /**  Spoken languages in this variant  */
        languages: Maybe<Array<Scalars['String']>>;
        /**  Escenic id of this variant  */
        legacyId: Scalars['Int'];
        /**  Information for live broadcasts  */
        live: Maybe<Live>;
        /**  Long episode synopsis, taken from Vision.  */
        longDescription: Scalars['String'];
        /**  Main spoken language in this variant  */
        mainLanguage: Language;
        /**  Editorial messages directed to the viewer  */
        messages: Maybe<Messages>;
        /**  Name for the variant. EpisodeName with suffix for language versions and accessibility  */
        name: Scalars['String'];
        /**  Name without any episode or season numbers. Unedited from source  */
        nameRaw: Scalars['String'];
        /**  Is this Content from öppetArkiv?  */
        oppetArkiv: Scalars['Boolean'];
        /**  The original title for the playables parent content  */
        originalProgramTitle: Scalars['String'];
        /**  The parent TvSeries/TvShow as a Content instance. Use this if you do not need TvSeries specific data.  */
        parent: Maybe<Content>;
        parentNode: Maybe<Node>;
        /**  Popularity for this item from popapp  */
        popularity: Scalars['Int'];
        /**  Production year from Vision  */
        productionYear: Maybe<Scalars['Int']>;
        /**  Restrictions for different viewer groups (location, age)  */
        restrictions: Restrictions;
        /**  Intended for short episode synopsis. Taken from vision, where it currently is abused to write season name  */
        shortDescription: Scalars['String'];
        /**  Slug fragment that can be used to construct a URL to this item  */
        slug: Scalars['String'];
        /**  New unique identifier  */
        svtId: Scalars['String'];
        /**  Defined in Escenic. Tags are used to group or classify content  */
        tags: Array<Tag>;
        /**  URL field containing various URL:s, for example SVT Play  */
        urls: Urls;
        /**  Start of rights  */
        validFrom: Maybe<Scalars['Timestamp']>;
        /**  Start of rights in a formatted format according to the styleguide  */
        validFromFormatted: Maybe<Scalars['String']>;
        /**  End of rights  */
        validTo: Maybe<Scalars['Timestamp']>;
        /**  End of rights in a formatted format according to the styleguide  */
        validToFormatted: Maybe<Scalars['String']>;
        /**  Available video streaming formats  */
        videoFormats: Array<Scalars['String']>;
        /**
         * First playable variant for this item. Can be used to match a variant to an episode item on a detail page,
         * for example to render progress from local storage or match selected item
         */
        videoSvtId: Scalars['String'];
        /**  List of playable videos  */
        videos: Array<Video>;
        /**
         * When in seconds clients should show skip to next episode button.
         * Based on endCreditStart or logic based on length of program.
         * If missing, do not show skip to next button.
         */
        whenToDisplaySkipToNext: Maybe<Scalars['Int']>;
    };

/** Variants of same content like accessibility or spoken language */
export type VariantAssociatedContentArgs = {
    addExtras: Maybe<Array<ExtraAssociatedContentId>>;
    exclude: Maybe<Array<AssociatedContentId>>;
    include: Maybe<Array<AssociatedContentId>>;
};

/** A distinct video asset to be played by a video player */
export type Video = {
    /**  Accessibility data for this video  */
    accessibility: Maybe<Accessibility>;
    /**  Unique identifier for this video, can be used against https://api.svt.se/video/{svtId}  */
    svtId: Scalars['String'];
};

export type AccessServiceSelectionFragment = {
    __typename?: 'Selection';
    id: string;
    name: string;
    selectionType: string;
    analyticsIdentifiers: { __typename?: 'SelectionAnalyticsIdentifiers'; listId: string; listType: string };
    items: Array<{
        __typename?: 'Teaser';
        heading: string;
        subHeading: string;
        byline: string;
        durationFormatted: string | null;
        progressFraction: number | null;
        description: string;
        badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
        images: {
            __typename?: 'Images';
            wide: {
                __typename?: 'Image';
                changed: any;
                id: string;
                keyart: boolean;
                description: string;
                blurHash: string;
            };
            portrait: {
                __typename?: 'Image';
                changed: any;
                id: string;
                keyart: boolean;
                description: string;
                blurHash: string;
            };
        };
        item:
            | {
                  __typename?: 'Clip';
                  duration: number;
                  name: string;
                  id: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'Episode';
                  duration: number;
                  name: string;
                  positionInSeason: string;
                  id: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  variants: Array<{
                      __typename?: 'Variant';
                      accessibility: Accessibility | null;
                      videoSvtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                  }>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        };
              }
            | {
                  __typename?: 'KidsTvShow';
                  id: string;
                  name: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'Playlist';
                  id: string;
                  name: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'Single';
                  duration: number;
                  name: string;
                  id: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  variants: Array<{
                      __typename?: 'Variant';
                      accessibility: Accessibility | null;
                      urls: { __typename?: 'Urls'; svtplay: string };
                  }>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        };
              }
            | {
                  __typename?: 'Trailer';
                  duration: number;
                  name: string;
                  id: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'TvSeries';
                  id: string;
                  name: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'TvShow';
                  id: string;
                  name: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'Variant';
                  id: string;
                  name: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | null;
              };
    }>;
};

export type AccessServiceOverviewQueryVariables = Exact<{
    genre: Maybe<Array<Scalars['String']> | Scalars['String']>;
    selectionType?: Maybe<GenreSelectionId>;
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
}>;

export type AccessServiceOverviewQuery = {
    __typename?: 'Query';
    genres: Array<{
        __typename?: 'Genre';
        name: string;
        id: string;
        analyticsIdentifiers: { __typename?: 'AnalyticsIdentifiers'; viewId: string; viewType: string };
        selectionsForWeb: Array<{
            __typename?: 'Selection';
            id: string;
            name: string;
            selectionType: string;
            analyticsIdentifiers: {
                __typename?: 'SelectionAnalyticsIdentifiers';
                listId: string;
                listType: string;
            };
            items: Array<{
                __typename?: 'Teaser';
                heading: string;
                subHeading: string;
                byline: string;
                durationFormatted: string | null;
                progressFraction: number | null;
                description: string;
                badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
                images: {
                    __typename?: 'Images';
                    wide: {
                        __typename?: 'Image';
                        changed: any;
                        id: string;
                        keyart: boolean;
                        description: string;
                        blurHash: string;
                    };
                    portrait: {
                        __typename?: 'Image';
                        changed: any;
                        id: string;
                        keyart: boolean;
                        description: string;
                        blurHash: string;
                    };
                };
                item:
                    | {
                          __typename?: 'Clip';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Episode';
                          duration: number;
                          name: string;
                          positionInSeason: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          variants: Array<{
                              __typename?: 'Variant';
                              accessibility: Accessibility | null;
                              videoSvtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                };
                      }
                    | {
                          __typename?: 'KidsTvShow';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Playlist';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Single';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          variants: Array<{
                              __typename?: 'Variant';
                              accessibility: Accessibility | null;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                };
                      }
                    | {
                          __typename?: 'Trailer';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'TvSeries';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'TvShow';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Variant';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      };
            }>;
        }>;
    }>;
};

export type CategoryPageQueryQueryVariables = Exact<{
    id: Scalars['String'];
    tab: Maybe<Scalars['String']>;
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
    history: Maybe<Array<History> | History>;
    abTestVariants: Maybe<Array<AbTestVariant> | AbTestVariant>;
}>;

export type CategoryPageQueryQuery = {
    __typename?: 'Query';
    categoryPage: {
        __typename?: 'CategoryPage';
        heading: string;
        description: string;
        image: { __typename?: 'Image'; id: string; changed: any } | null;
        analyticsIdentifiers: { __typename?: 'AnalyticsIdentifiers'; viewId: string; viewType: string };
        lazyLoadedTabs: Array<{
            __typename?: 'CategoryTab';
            name: string;
            slug: string;
            id: string;
            selections: Array<{
                __typename?: 'Selection';
                id: string;
                name: string;
                selectionType: string;
                presentation: Presentation;
                analyticsIdentifiers: {
                    __typename?: 'SelectionAnalyticsIdentifiers';
                    listId: string;
                    listType: string;
                };
                items: Array<{
                    __typename?: 'Teaser';
                    heading: string;
                    subHeading: string;
                    byline: string;
                    durationFormatted: string | null;
                    progressFraction: number | null;
                    description: string;
                    badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
                    images: {
                        __typename?: 'Images';
                        wide: {
                            __typename?: 'Image';
                            changed: any;
                            id: string;
                            keyart: boolean;
                            description: string;
                            blurHash: string;
                        };
                        portrait: {
                            __typename?: 'Image';
                            changed: any;
                            id: string;
                            keyart: boolean;
                            description: string;
                            blurHash: string;
                        };
                    };
                    item:
                        | {
                              __typename?: 'Clip';
                              duration: number;
                              name: string;
                              id: string;
                              longDescription: string;
                              oppetArkiv: boolean;
                              svtId: string;
                              videoSvtId: string;
                              accessibilities: Array<Accessibility>;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                              parent:
                                  | {
                                        __typename?: 'KidsTvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'Single';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvSeries';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | null;
                          }
                        | {
                              __typename?: 'Episode';
                              duration: number;
                              name: string;
                              positionInSeason: string;
                              id: string;
                              longDescription: string;
                              oppetArkiv: boolean;
                              svtId: string;
                              videoSvtId: string;
                              accessibilities: Array<Accessibility>;
                              variants: Array<{
                                  __typename?: 'Variant';
                                  accessibility: Accessibility | null;
                                  videoSvtId: string;
                                  urls: { __typename?: 'Urls'; svtplay: string };
                              }>;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                              parent:
                                  | {
                                        __typename?: 'KidsTvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'Single';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvSeries';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    };
                          }
                        | {
                              __typename?: 'KidsTvShow';
                              id: string;
                              name: string;
                              longDescription: string;
                              oppetArkiv: boolean;
                              svtId: string;
                              videoSvtId: string;
                              accessibilities: Array<Accessibility>;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                              parent:
                                  | {
                                        __typename?: 'KidsTvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'Single';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvSeries';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | null;
                          }
                        | {
                              __typename?: 'Playlist';
                              id: string;
                              name: string;
                              longDescription: string;
                              oppetArkiv: boolean;
                              svtId: string;
                              videoSvtId: string;
                              accessibilities: Array<Accessibility>;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                              parent:
                                  | {
                                        __typename?: 'KidsTvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'Single';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvSeries';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | null;
                          }
                        | {
                              __typename?: 'Single';
                              duration: number;
                              name: string;
                              id: string;
                              longDescription: string;
                              oppetArkiv: boolean;
                              svtId: string;
                              videoSvtId: string;
                              accessibilities: Array<Accessibility>;
                              variants: Array<{
                                  __typename?: 'Variant';
                                  accessibility: Accessibility | null;
                                  urls: { __typename?: 'Urls'; svtplay: string };
                              }>;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                              parent:
                                  | {
                                        __typename?: 'KidsTvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'Single';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvSeries';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    };
                          }
                        | {
                              __typename?: 'Trailer';
                              duration: number;
                              name: string;
                              id: string;
                              longDescription: string;
                              oppetArkiv: boolean;
                              svtId: string;
                              videoSvtId: string;
                              accessibilities: Array<Accessibility>;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                              parent:
                                  | {
                                        __typename?: 'KidsTvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'Single';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvSeries';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | null;
                          }
                        | {
                              __typename?: 'TvSeries';
                              id: string;
                              name: string;
                              longDescription: string;
                              oppetArkiv: boolean;
                              svtId: string;
                              videoSvtId: string;
                              accessibilities: Array<Accessibility>;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                              parent:
                                  | {
                                        __typename?: 'KidsTvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'Single';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvSeries';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | null;
                          }
                        | {
                              __typename?: 'TvShow';
                              id: string;
                              name: string;
                              longDescription: string;
                              oppetArkiv: boolean;
                              svtId: string;
                              videoSvtId: string;
                              accessibilities: Array<Accessibility>;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                              parent:
                                  | {
                                        __typename?: 'KidsTvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'Single';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvSeries';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | null;
                          }
                        | {
                              __typename?: 'Variant';
                              id: string;
                              name: string;
                              longDescription: string;
                              oppetArkiv: boolean;
                              svtId: string;
                              videoSvtId: string;
                              accessibilities: Array<Accessibility>;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                              parent:
                                  | {
                                        __typename?: 'KidsTvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'Single';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvSeries';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | {
                                        __typename?: 'TvShow';
                                        id: string;
                                        name: string;
                                        svtId: string;
                                        images: {
                                            __typename?: 'Images';
                                            wide: {
                                                __typename?: 'Image';
                                                changed: any;
                                                id: string;
                                                description: string;
                                            };
                                        };
                                    }
                                  | null;
                          };
                }>;
                categories: Array<{
                    __typename?: 'CategoryTeaser';
                    heading: string;
                    id: string;
                    image: { __typename?: 'Image'; id: string; changed: any; description: string };
                }>;
            }>;
        }>;
    } | null;
};

export type ChannelsQueryQueryVariables = Exact<{ [key: string]: never }>;

export type ChannelsQueryQuery = {
    __typename?: 'Query';
    channels: {
        __typename?: 'Channels';
        analyticsIdentifiers: { __typename?: 'AnalyticsIdentifiers'; viewId: string; viewType: string };
        channels: Array<{
            __typename?: 'Channel';
            id: string;
            name: string;
            running: {
                __typename?: 'BroadcastItem';
                id: string;
                name: string;
                description: string;
                rerunDescription: string;
                startTime: string;
                state: BroadcastState;
                svtId: string | null;
                progress: number;
                start: any;
                subHeading: string;
                end: any;
                image: { __typename?: 'Image'; id: string; changed: any; description: string };
                item:
                    | {
                          __typename?: 'Clip';
                          parent:
                              | { __typename?: 'KidsTvShow'; svtId: string }
                              | { __typename?: 'Single'; svtId: string }
                              | { __typename?: 'TvSeries'; svtId: string }
                              | { __typename?: 'TvShow'; svtId: string }
                              | null;
                      }
                    | {
                          __typename?: 'Episode';
                          parent:
                              | { __typename?: 'KidsTvShow'; svtId: string }
                              | { __typename?: 'Single'; svtId: string }
                              | { __typename?: 'TvSeries'; svtId: string }
                              | { __typename?: 'TvShow'; svtId: string };
                      }
                    | {
                          __typename?: 'Single';
                          parent:
                              | { __typename?: 'KidsTvShow'; svtId: string }
                              | { __typename?: 'Single'; svtId: string }
                              | { __typename?: 'TvSeries'; svtId: string }
                              | { __typename?: 'TvShow'; svtId: string };
                      }
                    | {
                          __typename?: 'Trailer';
                          parent:
                              | { __typename?: 'KidsTvShow'; svtId: string }
                              | { __typename?: 'Single'; svtId: string }
                              | { __typename?: 'TvSeries'; svtId: string }
                              | { __typename?: 'TvShow'; svtId: string }
                              | null;
                      }
                    | {
                          __typename?: 'Variant';
                          urls: { __typename?: 'Urls'; svtplay: string };
                          parent:
                              | { __typename?: 'KidsTvShow'; svtId: string }
                              | { __typename?: 'Single'; svtId: string }
                              | { __typename?: 'TvSeries'; svtId: string }
                              | { __typename?: 'TvShow'; svtId: string }
                              | null;
                      }
                    | null;
            };
        }>;
    };
};

export type GenreItemFragment = { __typename?: 'Genre'; name: string; id: string };

export type AllGenresQueryVariables = Exact<{ [key: string]: never }>;

export type AllGenresQuery = {
    __typename?: 'Query';
    genresSortedByName: {
        __typename?: 'Genres';
        genres: Array<{ __typename?: 'Genre'; name: string; id: string }>;
        analyticsIdentifiers: { __typename?: 'AnalyticsIdentifiers'; viewId: string; viewType: string };
    };
};

export type ContinueWatchingQueryQueryVariables = Exact<{
    history: Array<History> | History;
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
}>;

export type ContinueWatchingQueryQuery = {
    __typename?: 'Query';
    keepWatching: {
        __typename?: 'Selection';
        id: string;
        name: string;
        analyticsIdentifiers: {
            __typename?: 'SelectionAnalyticsIdentifiers';
            listId: string;
            listType: string;
        };
        items: Array<{
            __typename?: 'Teaser';
            heading: string;
            subHeading: string;
            byline: string;
            durationFormatted: string | null;
            progressFraction: number | null;
            description: string;
            badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
            images: {
                __typename?: 'Images';
                wide: {
                    __typename?: 'Image';
                    changed: any;
                    id: string;
                    keyart: boolean;
                    description: string;
                    blurHash: string;
                };
                portrait: {
                    __typename?: 'Image';
                    changed: any;
                    id: string;
                    keyart: boolean;
                    description: string;
                    blurHash: string;
                };
            };
            item:
                | {
                      __typename?: 'Clip';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Episode';
                      duration: number;
                      name: string;
                      positionInSeason: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      variants: Array<{
                          __typename?: 'Variant';
                          accessibility: Accessibility | null;
                          videoSvtId: string;
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            };
                  }
                | {
                      __typename?: 'KidsTvShow';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Playlist';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Single';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      variants: Array<{
                          __typename?: 'Variant';
                          accessibility: Accessibility | null;
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            };
                  }
                | {
                      __typename?: 'Trailer';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'TvSeries';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'TvShow';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Variant';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  };
        }>;
    };
};

export type HighlightsFragment = {
    __typename?: 'Highlight';
    name: string;
    positionFormatted: string;
    slug: string;
    positionInSeconds: number;
    thumbnailId: number | null;
};

export type CategoryFragment = { __typename?: 'CategoryTeaser'; heading: string; id: string };

export type CastAndCrewFragment = {
    __typename?: 'CastAndCrewSection';
    name: string;
    people: Array<{ __typename?: 'Person'; name: string; numberOfParticipations: number }>;
};

export type AssociatedContentItemFragment = {
    __typename?: 'Teaser';
    heading: string;
    subHeading: string;
    durationFormatted: string | null;
    description: string;
    selected: boolean;
    badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
    images: { __typename?: 'Images'; wide: { __typename?: 'Image'; id: string; changed: any } };
    item:
        | {
              __typename: 'Clip';
              validFrom: any | null;
              validFromFormatted: string | null;
              duration: number;
              id: string;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              restrictions: {
                  __typename?: 'Restrictions';
                  onlyAvailableInSwedenFormatted: string;
                  onlyAvailableInSweden: boolean;
              };
              urls: { __typename?: 'Urls'; svtplay: string };
          }
        | {
              __typename: 'Episode';
              validFrom: any | null;
              validFromFormatted: string | null;
              duration: number;
              positionInSeason: string;
              nameRaw: string;
              id: string;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              restrictions: {
                  __typename?: 'Restrictions';
                  onlyAvailableInSwedenFormatted: string;
                  onlyAvailableInSweden: boolean;
              };
              urls: { __typename?: 'Urls'; svtplay: string };
          }
        | {
              __typename: 'KidsTvShow';
              id: string;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              restrictions: {
                  __typename?: 'Restrictions';
                  onlyAvailableInSwedenFormatted: string;
                  onlyAvailableInSweden: boolean;
              };
              urls: { __typename?: 'Urls'; svtplay: string };
          }
        | {
              __typename: 'Playlist';
              id: string;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              restrictions: {
                  __typename?: 'Restrictions';
                  onlyAvailableInSwedenFormatted: string;
                  onlyAvailableInSweden: boolean;
              };
              urls: { __typename?: 'Urls'; svtplay: string };
          }
        | {
              __typename: 'Single';
              validFrom: any | null;
              validFromFormatted: string | null;
              duration: number;
              id: string;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              restrictions: {
                  __typename?: 'Restrictions';
                  onlyAvailableInSwedenFormatted: string;
                  onlyAvailableInSweden: boolean;
              };
              urls: { __typename?: 'Urls'; svtplay: string };
          }
        | {
              __typename: 'Trailer';
              validFrom: any | null;
              validFromFormatted: string | null;
              duration: number;
              id: string;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              restrictions: {
                  __typename?: 'Restrictions';
                  onlyAvailableInSwedenFormatted: string;
                  onlyAvailableInSweden: boolean;
              };
              urls: { __typename?: 'Urls'; svtplay: string };
          }
        | {
              __typename: 'TvSeries';
              id: string;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              restrictions: {
                  __typename?: 'Restrictions';
                  onlyAvailableInSwedenFormatted: string;
                  onlyAvailableInSweden: boolean;
              };
              urls: { __typename?: 'Urls'; svtplay: string };
          }
        | {
              __typename: 'TvShow';
              id: string;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              restrictions: {
                  __typename?: 'Restrictions';
                  onlyAvailableInSwedenFormatted: string;
                  onlyAvailableInSweden: boolean;
              };
              urls: { __typename?: 'Urls'; svtplay: string };
          }
        | {
              __typename: 'Variant';
              validFrom: any | null;
              validFromFormatted: string | null;
              duration: number;
              id: string;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              restrictions: {
                  __typename?: 'Restrictions';
                  onlyAvailableInSwedenFormatted: string;
                  onlyAvailableInSweden: boolean;
              };
              urls: { __typename?: 'Urls'; svtplay: string };
          };
};

export type AssociatedContentSelectionFragment = {
    __typename?: 'Selection';
    id: string;
    name: string;
    selectionType: string;
    analyticsIdentifiers: { __typename?: 'SelectionAnalyticsIdentifiers'; listId: string; listType: string };
    items: Array<{
        __typename?: 'Teaser';
        heading: string;
        subHeading: string;
        durationFormatted: string | null;
        description: string;
        selected: boolean;
        badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
        images: { __typename?: 'Images'; wide: { __typename?: 'Image'; id: string; changed: any } };
        item:
            | {
                  __typename: 'Clip';
                  validFrom: any | null;
                  validFromFormatted: string | null;
                  duration: number;
                  id: string;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  restrictions: {
                      __typename?: 'Restrictions';
                      onlyAvailableInSwedenFormatted: string;
                      onlyAvailableInSweden: boolean;
                  };
                  urls: { __typename?: 'Urls'; svtplay: string };
              }
            | {
                  __typename: 'Episode';
                  validFrom: any | null;
                  validFromFormatted: string | null;
                  duration: number;
                  positionInSeason: string;
                  nameRaw: string;
                  id: string;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  restrictions: {
                      __typename?: 'Restrictions';
                      onlyAvailableInSwedenFormatted: string;
                      onlyAvailableInSweden: boolean;
                  };
                  urls: { __typename?: 'Urls'; svtplay: string };
              }
            | {
                  __typename: 'KidsTvShow';
                  id: string;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  restrictions: {
                      __typename?: 'Restrictions';
                      onlyAvailableInSwedenFormatted: string;
                      onlyAvailableInSweden: boolean;
                  };
                  urls: { __typename?: 'Urls'; svtplay: string };
              }
            | {
                  __typename: 'Playlist';
                  id: string;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  restrictions: {
                      __typename?: 'Restrictions';
                      onlyAvailableInSwedenFormatted: string;
                      onlyAvailableInSweden: boolean;
                  };
                  urls: { __typename?: 'Urls'; svtplay: string };
              }
            | {
                  __typename: 'Single';
                  validFrom: any | null;
                  validFromFormatted: string | null;
                  duration: number;
                  id: string;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  restrictions: {
                      __typename?: 'Restrictions';
                      onlyAvailableInSwedenFormatted: string;
                      onlyAvailableInSweden: boolean;
                  };
                  urls: { __typename?: 'Urls'; svtplay: string };
              }
            | {
                  __typename: 'Trailer';
                  validFrom: any | null;
                  validFromFormatted: string | null;
                  duration: number;
                  id: string;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  restrictions: {
                      __typename?: 'Restrictions';
                      onlyAvailableInSwedenFormatted: string;
                      onlyAvailableInSweden: boolean;
                  };
                  urls: { __typename?: 'Urls'; svtplay: string };
              }
            | {
                  __typename: 'TvSeries';
                  id: string;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  restrictions: {
                      __typename?: 'Restrictions';
                      onlyAvailableInSwedenFormatted: string;
                      onlyAvailableInSweden: boolean;
                  };
                  urls: { __typename?: 'Urls'; svtplay: string };
              }
            | {
                  __typename: 'TvShow';
                  id: string;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  restrictions: {
                      __typename?: 'Restrictions';
                      onlyAvailableInSwedenFormatted: string;
                      onlyAvailableInSweden: boolean;
                  };
                  urls: { __typename?: 'Urls'; svtplay: string };
              }
            | {
                  __typename: 'Variant';
                  validFrom: any | null;
                  validFromFormatted: string | null;
                  duration: number;
                  id: string;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  restrictions: {
                      __typename?: 'Restrictions';
                      onlyAvailableInSwedenFormatted: string;
                      onlyAvailableInSweden: boolean;
                  };
                  urls: { __typename?: 'Urls'; svtplay: string };
              };
    }>;
};

export type DetailsPageQueryQueryVariables = Exact<{
    path: Scalars['String'];
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
}>;

export type DetailsPageQueryQuery = {
    __typename?: 'Query';
    detailsPageByPath: {
        __typename?: 'DetailsPage';
        id: string;
        heading: string;
        subHeading: string;
        description: string;
        isUpcomingVOD: boolean;
        isUpcomingLive: boolean;
        images: {
            __typename?: 'Images';
            wide: { __typename?: 'Image'; blurHash: string; changed: any; id: string };
        };
        video:
            | { __typename?: 'Clip'; svtId: string; urls: { __typename?: 'Urls'; svtplay: string } }
            | { __typename?: 'Trailer'; svtId: string; urls: { __typename?: 'Urls'; svtplay: string } }
            | { __typename?: 'Variant'; svtId: string; urls: { __typename?: 'Urls'; svtplay: string } }
            | null;
        castAndCrew: Array<{
            __typename?: 'CastAndCrewSection';
            name: string;
            people: Array<{ __typename?: 'Person'; name: string; numberOfParticipations: number }>;
        }>;
        categories: Array<{ __typename?: 'CategoryTeaser'; heading: string; id: string }>;
        contentWarning: { __typename?: 'ContentWarning'; code: string; text: string } | null;
        item:
            | {
                  __typename?: 'Clip';
                  id: string;
                  originalProgramTitle: string;
                  durationFormatted: string;
                  durationISOFormatted: string;
                  validTo: any | null;
                  validFrom: any | null;
                  validFromFormatted: string | null;
                  slug: string;
                  name: string;
                  accessibilities: Array<Accessibility>;
                  barn: boolean;
                  shortDescription: string;
                  svtId: string;
                  messages: {
                      __typename?: 'Messages';
                      editorial: {
                          __typename?: 'Message';
                          message: string | null;
                          linkText: string | null;
                          link: string | null;
                      };
                      urgent: {
                          __typename?: 'Message';
                          link: string | null;
                          linkText: string | null;
                          message: string | null;
                      };
                  } | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'Single';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvSeries';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'Episode';
                  id: string;
                  originalProgramTitle: string;
                  durationFormatted: string;
                  durationISOFormatted: string;
                  validTo: any | null;
                  validFrom: any | null;
                  validFromFormatted: string | null;
                  slug: string;
                  name: string;
                  accessibilities: Array<Accessibility>;
                  barn: boolean;
                  shortDescription: string;
                  svtId: string;
                  messages: {
                      __typename?: 'Messages';
                      editorial: {
                          __typename?: 'Message';
                          message: string | null;
                          linkText: string | null;
                          link: string | null;
                      };
                      urgent: {
                          __typename?: 'Message';
                          link: string | null;
                          linkText: string | null;
                          message: string | null;
                      };
                  } | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'Single';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvSeries';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        };
              }
            | {
                  __typename?: 'KidsTvShow';
                  nextEpisodeAvailableFormatted: string | null;
                  slug: string;
                  name: string;
                  accessibilities: Array<Accessibility>;
                  barn: boolean;
                  shortDescription: string;
                  svtId: string;
                  isTitle: string;
                  messages: {
                      __typename?: 'Messages';
                      editorial: {
                          __typename?: 'Message';
                          message: string | null;
                          linkText: string | null;
                          link: string | null;
                      };
                      urgent: {
                          __typename?: 'Message';
                          link: string | null;
                          linkText: string | null;
                          message: string | null;
                      };
                  } | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'Single';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvSeries';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'Playlist';
                  slug: string;
                  name: string;
                  accessibilities: Array<Accessibility>;
                  barn: boolean;
                  shortDescription: string;
                  svtId: string;
                  messages: {
                      __typename?: 'Messages';
                      editorial: {
                          __typename?: 'Message';
                          message: string | null;
                          linkText: string | null;
                          link: string | null;
                      };
                      urgent: {
                          __typename?: 'Message';
                          link: string | null;
                          linkText: string | null;
                          message: string | null;
                      };
                  } | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'Single';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvSeries';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'Single';
                  id: string;
                  originalProgramTitle: string;
                  durationFormatted: string;
                  durationISOFormatted: string;
                  validTo: any | null;
                  validFrom: any | null;
                  validFromFormatted: string | null;
                  nextEpisodeAvailableFormatted: string | null;
                  slug: string;
                  name: string;
                  accessibilities: Array<Accessibility>;
                  barn: boolean;
                  shortDescription: string;
                  svtId: string;
                  isTitle: string;
                  messages: {
                      __typename?: 'Messages';
                      editorial: {
                          __typename?: 'Message';
                          message: string | null;
                          linkText: string | null;
                          link: string | null;
                      };
                      urgent: {
                          __typename?: 'Message';
                          link: string | null;
                          linkText: string | null;
                          message: string | null;
                      };
                  } | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'Single';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvSeries';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        };
              }
            | {
                  __typename?: 'Trailer';
                  id: string;
                  originalProgramTitle: string;
                  durationFormatted: string;
                  durationISOFormatted: string;
                  validTo: any | null;
                  validFrom: any | null;
                  validFromFormatted: string | null;
                  slug: string;
                  name: string;
                  accessibilities: Array<Accessibility>;
                  barn: boolean;
                  shortDescription: string;
                  svtId: string;
                  messages: {
                      __typename?: 'Messages';
                      editorial: {
                          __typename?: 'Message';
                          message: string | null;
                          linkText: string | null;
                          link: string | null;
                      };
                      urgent: {
                          __typename?: 'Message';
                          link: string | null;
                          linkText: string | null;
                          message: string | null;
                      };
                  } | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'Single';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvSeries';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'TvSeries';
                  nextEpisodeAvailableFormatted: string | null;
                  slug: string;
                  name: string;
                  accessibilities: Array<Accessibility>;
                  barn: boolean;
                  shortDescription: string;
                  svtId: string;
                  isTitle: string;
                  messages: {
                      __typename?: 'Messages';
                      editorial: {
                          __typename?: 'Message';
                          message: string | null;
                          linkText: string | null;
                          link: string | null;
                      };
                      urgent: {
                          __typename?: 'Message';
                          link: string | null;
                          linkText: string | null;
                          message: string | null;
                      };
                  } | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'Single';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvSeries';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'TvShow';
                  nextEpisodeAvailableFormatted: string | null;
                  slug: string;
                  name: string;
                  accessibilities: Array<Accessibility>;
                  barn: boolean;
                  shortDescription: string;
                  svtId: string;
                  isTitle: string;
                  messages: {
                      __typename?: 'Messages';
                      editorial: {
                          __typename?: 'Message';
                          message: string | null;
                          linkText: string | null;
                          link: string | null;
                      };
                      urgent: {
                          __typename?: 'Message';
                          link: string | null;
                          linkText: string | null;
                          message: string | null;
                      };
                  } | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'Single';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvSeries';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'Variant';
                  id: string;
                  originalProgramTitle: string;
                  durationFormatted: string;
                  durationISOFormatted: string;
                  validTo: any | null;
                  validFrom: any | null;
                  validFromFormatted: string | null;
                  slug: string;
                  name: string;
                  accessibilities: Array<Accessibility>;
                  barn: boolean;
                  shortDescription: string;
                  svtId: string;
                  highlights: Array<{
                      __typename?: 'Highlight';
                      name: string;
                      positionFormatted: string;
                      slug: string;
                      positionInSeconds: number;
                      thumbnailId: number | null;
                  }>;
                  messages: {
                      __typename?: 'Messages';
                      editorial: {
                          __typename?: 'Message';
                          message: string | null;
                          linkText: string | null;
                          link: string | null;
                      };
                      urgent: {
                          __typename?: 'Message';
                          link: string | null;
                          linkText: string | null;
                          message: string | null;
                      };
                  } | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'Single';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvSeries';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | {
                            __typename: 'TvShow';
                            id: string;
                            svtId: string;
                            name: string;
                            longDescription: string;
                            slug: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                            };
                        }
                      | null;
              };
        analyticsIdentifiers: { __typename?: 'AnalyticsIdentifiers'; viewId: string; viewType: string };
        moreDetails: {
            __typename?: 'MoreDetails';
            byline: string;
            duration: string | null;
            episodeDescription: string | null;
            episodeHeading: string | null;
            heading: string;
            productionYearRange: string | null;
            titleDescription: string;
            titleHeading: string;
            validFrom: string | null;
            validTo: string | null;
            restrictions: {
                __typename?: 'Restrictions';
                blockedForChildren: boolean;
                onlyAvailableInSweden: boolean;
                onlyAvailableInSwedenFormatted: string;
            } | null;
        };
        associatedContent: Array<{
            __typename?: 'Selection';
            id: string;
            name: string;
            selectionType: string;
            analyticsIdentifiers: {
                __typename?: 'SelectionAnalyticsIdentifiers';
                listId: string;
                listType: string;
            };
            items: Array<{
                __typename?: 'Teaser';
                heading: string;
                subHeading: string;
                durationFormatted: string | null;
                description: string;
                selected: boolean;
                badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
                images: { __typename?: 'Images'; wide: { __typename?: 'Image'; id: string; changed: any } };
                item:
                    | {
                          __typename: 'Clip';
                          validFrom: any | null;
                          validFromFormatted: string | null;
                          duration: number;
                          id: string;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          restrictions: {
                              __typename?: 'Restrictions';
                              onlyAvailableInSwedenFormatted: string;
                              onlyAvailableInSweden: boolean;
                          };
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }
                    | {
                          __typename: 'Episode';
                          validFrom: any | null;
                          validFromFormatted: string | null;
                          duration: number;
                          positionInSeason: string;
                          nameRaw: string;
                          id: string;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          restrictions: {
                              __typename?: 'Restrictions';
                              onlyAvailableInSwedenFormatted: string;
                              onlyAvailableInSweden: boolean;
                          };
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }
                    | {
                          __typename: 'KidsTvShow';
                          id: string;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          restrictions: {
                              __typename?: 'Restrictions';
                              onlyAvailableInSwedenFormatted: string;
                              onlyAvailableInSweden: boolean;
                          };
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }
                    | {
                          __typename: 'Playlist';
                          id: string;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          restrictions: {
                              __typename?: 'Restrictions';
                              onlyAvailableInSwedenFormatted: string;
                              onlyAvailableInSweden: boolean;
                          };
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }
                    | {
                          __typename: 'Single';
                          validFrom: any | null;
                          validFromFormatted: string | null;
                          duration: number;
                          id: string;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          restrictions: {
                              __typename?: 'Restrictions';
                              onlyAvailableInSwedenFormatted: string;
                              onlyAvailableInSweden: boolean;
                          };
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }
                    | {
                          __typename: 'Trailer';
                          validFrom: any | null;
                          validFromFormatted: string | null;
                          duration: number;
                          id: string;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          restrictions: {
                              __typename?: 'Restrictions';
                              onlyAvailableInSwedenFormatted: string;
                              onlyAvailableInSweden: boolean;
                          };
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }
                    | {
                          __typename: 'TvSeries';
                          id: string;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          restrictions: {
                              __typename?: 'Restrictions';
                              onlyAvailableInSwedenFormatted: string;
                              onlyAvailableInSweden: boolean;
                          };
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }
                    | {
                          __typename: 'TvShow';
                          id: string;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          restrictions: {
                              __typename?: 'Restrictions';
                              onlyAvailableInSwedenFormatted: string;
                              onlyAvailableInSweden: boolean;
                          };
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }
                    | {
                          __typename: 'Variant';
                          validFrom: any | null;
                          validFromFormatted: string | null;
                          duration: number;
                          id: string;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          restrictions: {
                              __typename?: 'Restrictions';
                              onlyAvailableInSwedenFormatted: string;
                              onlyAvailableInSweden: boolean;
                          };
                          urls: { __typename?: 'Urls'; svtplay: string };
                      };
            }>;
        }>;
    } | null;
};

export type SmartStartQueryQueryVariables = Exact<{
    id: Scalars['String'];
    history: Array<History> | History;
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
    accessibility: Maybe<Accessibility>;
}>;

export type SmartStartQueryQuery = {
    __typename?: 'Query';
    smartStart: {
        __typename?: 'SmartStart';
        label: string;
        screenreaderLabel: string;
        videoSvtId: string;
        badge: { __typename?: 'Badge'; text: string; altText: string; type: string } | null;
        item:
            | {
                  __typename?: 'Clip';
                  id: string;
                  duration: number;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  live: { __typename?: 'Live'; liveNow: boolean } | null;
                  restrictions: {
                      __typename?: 'Restrictions';
                      blockedForChildren: boolean;
                      onlyAvailableInSweden: boolean;
                      onlyAvailableInSwedenFormatted: string;
                  };
                  videos: Array<
                      | {
                            __typename?: 'Clip';
                            id: string;
                            name: string;
                            svtId: string;
                            accessibility: Accessibility | null;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename?: 'Trailer';
                            id: string;
                            name: string;
                            svtId: string;
                            accessibility: Accessibility | null;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename?: 'Variant';
                            id: string;
                            name: string;
                            accessibility: Accessibility | null;
                            accessibilities: Array<Accessibility>;
                            svtId: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                            mainLanguage: { __typename?: 'Language'; name: string };
                            restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                        }
                  >;
              }
            | {
                  __typename?: 'Episode';
                  id: string;
                  duration: number;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  live: { __typename?: 'Live'; liveNow: boolean } | null;
                  restrictions: {
                      __typename?: 'Restrictions';
                      blockedForChildren: boolean;
                      onlyAvailableInSweden: boolean;
                      onlyAvailableInSwedenFormatted: string;
                  };
                  videos: Array<
                      | {
                            __typename?: 'Clip';
                            id: string;
                            name: string;
                            svtId: string;
                            accessibility: Accessibility | null;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename?: 'Trailer';
                            id: string;
                            name: string;
                            svtId: string;
                            accessibility: Accessibility | null;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename?: 'Variant';
                            id: string;
                            name: string;
                            accessibility: Accessibility | null;
                            accessibilities: Array<Accessibility>;
                            svtId: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                            mainLanguage: { __typename?: 'Language'; name: string };
                            restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                        }
                  >;
              }
            | {
                  __typename?: 'Single';
                  id: string;
                  duration: number;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  live: { __typename?: 'Live'; liveNow: boolean } | null;
                  restrictions: {
                      __typename?: 'Restrictions';
                      blockedForChildren: boolean;
                      onlyAvailableInSweden: boolean;
                      onlyAvailableInSwedenFormatted: string;
                  };
                  videos: Array<
                      | {
                            __typename?: 'Clip';
                            id: string;
                            name: string;
                            svtId: string;
                            accessibility: Accessibility | null;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename?: 'Trailer';
                            id: string;
                            name: string;
                            svtId: string;
                            accessibility: Accessibility | null;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename?: 'Variant';
                            id: string;
                            name: string;
                            accessibility: Accessibility | null;
                            accessibilities: Array<Accessibility>;
                            svtId: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                            mainLanguage: { __typename?: 'Language'; name: string };
                            restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                        }
                  >;
              }
            | {
                  __typename?: 'Trailer';
                  id: string;
                  duration: number;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  live: { __typename?: 'Live'; liveNow: boolean } | null;
                  restrictions: {
                      __typename?: 'Restrictions';
                      blockedForChildren: boolean;
                      onlyAvailableInSweden: boolean;
                      onlyAvailableInSwedenFormatted: string;
                  };
                  videos: Array<
                      | {
                            __typename?: 'Clip';
                            id: string;
                            name: string;
                            svtId: string;
                            accessibility: Accessibility | null;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename?: 'Trailer';
                            id: string;
                            name: string;
                            svtId: string;
                            accessibility: Accessibility | null;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename?: 'Variant';
                            id: string;
                            name: string;
                            accessibility: Accessibility | null;
                            accessibilities: Array<Accessibility>;
                            svtId: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                            mainLanguage: { __typename?: 'Language'; name: string };
                            restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                        }
                  >;
              }
            | {
                  __typename?: 'Variant';
                  id: string;
                  duration: number;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  live: { __typename?: 'Live'; liveNow: boolean } | null;
                  restrictions: {
                      __typename?: 'Restrictions';
                      blockedForChildren: boolean;
                      onlyAvailableInSweden: boolean;
                      onlyAvailableInSwedenFormatted: string;
                  };
                  videos: Array<
                      | {
                            __typename?: 'Clip';
                            id: string;
                            name: string;
                            svtId: string;
                            accessibility: Accessibility | null;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename?: 'Trailer';
                            id: string;
                            name: string;
                            svtId: string;
                            accessibility: Accessibility | null;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename?: 'Variant';
                            id: string;
                            name: string;
                            accessibility: Accessibility | null;
                            accessibilities: Array<Accessibility>;
                            svtId: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                            mainLanguage: { __typename?: 'Language'; name: string };
                            restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                        }
                  >;
              };
    } | null;
};

export type NotFoundQueryQueryVariables = Exact<{
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
}>;

export type NotFoundQueryQuery = {
    __typename?: 'Query';
    startForSvtPlay: {
        __typename?: 'StartForSvtPlay';
        selections: Array<{
            __typename?: 'Selection';
            id: string;
            analyticsIdentifiers: {
                __typename?: 'SelectionAnalyticsIdentifiers';
                listId: string;
                listType: string;
            };
            items: Array<{
                __typename?: 'Teaser';
                heading: string;
                subHeading: string;
                byline: string;
                durationFormatted: string | null;
                progressFraction: number | null;
                description: string;
                badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
                images: {
                    __typename?: 'Images';
                    wide: {
                        __typename?: 'Image';
                        changed: any;
                        id: string;
                        keyart: boolean;
                        description: string;
                        blurHash: string;
                    };
                    portrait: {
                        __typename?: 'Image';
                        changed: any;
                        id: string;
                        keyart: boolean;
                        description: string;
                        blurHash: string;
                    };
                };
                item:
                    | {
                          __typename?: 'Clip';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Episode';
                          duration: number;
                          name: string;
                          positionInSeason: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          variants: Array<{
                              __typename?: 'Variant';
                              accessibility: Accessibility | null;
                              videoSvtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                };
                      }
                    | {
                          __typename?: 'KidsTvShow';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Playlist';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Single';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          variants: Array<{
                              __typename?: 'Variant';
                              accessibility: Accessibility | null;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                };
                      }
                    | {
                          __typename?: 'Trailer';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'TvSeries';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'TvShow';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Variant';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      };
            }>;
        }>;
    };
};

export type FavoritesQueryVariables = Exact<{
    titleIds: Array<Scalars['String']> | Scalars['String'];
}>;

export type FavoritesQuery = {
    __typename?: 'Query';
    favorites: {
        __typename?: 'Selection';
        id: string;
        name: string;
        items: Array<{
            __typename?: 'Teaser';
            heading: string;
            subHeading: string;
            byline: string;
            durationFormatted: string | null;
            progressFraction: number | null;
            description: string;
            badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
            images: {
                __typename?: 'Images';
                wide: {
                    __typename?: 'Image';
                    changed: any;
                    id: string;
                    keyart: boolean;
                    description: string;
                    blurHash: string;
                };
                portrait: {
                    __typename?: 'Image';
                    changed: any;
                    id: string;
                    keyart: boolean;
                    description: string;
                    blurHash: string;
                };
            };
            item:
                | {
                      __typename?: 'Clip';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Episode';
                      duration: number;
                      name: string;
                      positionInSeason: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      variants: Array<{
                          __typename?: 'Variant';
                          accessibility: Accessibility | null;
                          videoSvtId: string;
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            };
                  }
                | {
                      __typename?: 'KidsTvShow';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Playlist';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Single';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      variants: Array<{
                          __typename?: 'Variant';
                          accessibility: Accessibility | null;
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            };
                  }
                | {
                      __typename?: 'Trailer';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'TvSeries';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'TvShow';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Variant';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  };
        }>;
    };
};

export type FionaPageQueryVariables = Exact<{
    selectionId: Scalars['String'];
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
}>;

export type FionaPageQuery = {
    __typename?: 'Query';
    selectionById: {
        __typename?: 'Selection';
        id: string;
        name: string;
        analyticsIdentifiers: {
            __typename?: 'SelectionAnalyticsIdentifiers';
            listId: string;
            listType: string;
        };
        items: Array<{
            __typename?: 'Teaser';
            heading: string;
            subHeading: string;
            byline: string;
            durationFormatted: string | null;
            progressFraction: number | null;
            description: string;
            badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
            images: {
                __typename?: 'Images';
                wide: {
                    __typename?: 'Image';
                    changed: any;
                    id: string;
                    keyart: boolean;
                    description: string;
                    blurHash: string;
                };
                portrait: {
                    __typename?: 'Image';
                    changed: any;
                    id: string;
                    keyart: boolean;
                    description: string;
                    blurHash: string;
                };
            };
            item:
                | {
                      __typename?: 'Clip';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Episode';
                      duration: number;
                      name: string;
                      positionInSeason: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      variants: Array<{
                          __typename?: 'Variant';
                          accessibility: Accessibility | null;
                          videoSvtId: string;
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            };
                  }
                | {
                      __typename?: 'KidsTvShow';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Playlist';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Single';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      variants: Array<{
                          __typename?: 'Variant';
                          accessibility: Accessibility | null;
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            };
                  }
                | {
                      __typename?: 'Trailer';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'TvSeries';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'TvShow';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Variant';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  };
        }>;
    } | null;
};

export type GridPageQueryVariables = Exact<{
    selectionId: Maybe<Array<Maybe<StartSelectionId>> | Maybe<StartSelectionId>>;
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
}>;

export type GridPageQuery = {
    __typename?: 'Query';
    startForSvtPlay: {
        __typename?: 'StartForSvtPlay';
        selections: Array<{
            __typename?: 'Selection';
            id: string;
            name: string;
            analyticsIdentifiers: {
                __typename?: 'SelectionAnalyticsIdentifiers';
                listId: string;
                listType: string;
            };
            items: Array<{
                __typename?: 'Teaser';
                heading: string;
                subHeading: string;
                byline: string;
                durationFormatted: string | null;
                progressFraction: number | null;
                description: string;
                badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
                images: {
                    __typename?: 'Images';
                    wide: {
                        __typename?: 'Image';
                        changed: any;
                        id: string;
                        keyart: boolean;
                        description: string;
                        blurHash: string;
                    };
                    portrait: {
                        __typename?: 'Image';
                        changed: any;
                        id: string;
                        keyart: boolean;
                        description: string;
                        blurHash: string;
                    };
                };
                item:
                    | {
                          __typename?: 'Clip';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Episode';
                          duration: number;
                          name: string;
                          positionInSeason: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          variants: Array<{
                              __typename?: 'Variant';
                              accessibility: Accessibility | null;
                              videoSvtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                };
                      }
                    | {
                          __typename?: 'KidsTvShow';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Playlist';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Single';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          variants: Array<{
                              __typename?: 'Variant';
                              accessibility: Accessibility | null;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                };
                      }
                    | {
                          __typename?: 'Trailer';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'TvSeries';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'TvShow';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Variant';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      };
            }>;
        }>;
    };
};

export type BroadcastScheduleQueryVariables = Exact<{
    day: Maybe<Scalars['String']>;
}>;

export type BroadcastScheduleQuery = {
    __typename?: 'Query';
    channels: {
        __typename?: 'Channels';
        channels: Array<{
            __typename?: 'Channel';
            id: string;
            name: string;
            schedule: Array<{
                __typename?: 'BroadcastItem';
                description: string;
                name: string;
                subHeading: string;
                startTime: string;
                start: any;
                state: BroadcastState;
                progress: number;
                svtId: string | null;
                rerunDescription: string;
                isBroadcastIntermission: boolean;
                highDefinition: boolean;
                urPlayLink: string | null;
                broadcastAudio: BroadcastAudio;
                usingFallbackImage: boolean;
                item:
                    | {
                          __typename?: 'Clip';
                          name: string;
                          shortDescription: string;
                          videoSvtId: string;
                          validFrom: any | null;
                          validToFormatted: string | null;
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                          restrictions: {
                              __typename?: 'Restrictions';
                              onlyAvailableInSwedenFormatted: string;
                          };
                      }
                    | {
                          __typename?: 'Episode';
                          name: string;
                          shortDescription: string;
                          videoSvtId: string;
                          validFrom: any | null;
                          validToFormatted: string | null;
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                };
                          restrictions: {
                              __typename?: 'Restrictions';
                              onlyAvailableInSwedenFormatted: string;
                          };
                      }
                    | {
                          __typename?: 'Single';
                          name: string;
                          shortDescription: string;
                          videoSvtId: string;
                          validFrom: any | null;
                          validToFormatted: string | null;
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                };
                          restrictions: {
                              __typename?: 'Restrictions';
                              onlyAvailableInSwedenFormatted: string;
                          };
                      }
                    | {
                          __typename?: 'Trailer';
                          name: string;
                          shortDescription: string;
                          videoSvtId: string;
                          validFrom: any | null;
                          validToFormatted: string | null;
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                          restrictions: {
                              __typename?: 'Restrictions';
                              onlyAvailableInSwedenFormatted: string;
                          };
                      }
                    | {
                          __typename?: 'Variant';
                          name: string;
                          shortDescription: string;
                          videoSvtId: string;
                          validFrom: any | null;
                          validToFormatted: string | null;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          episode:
                              | { __typename?: 'Clip' }
                              | { __typename?: 'Episode'; positionInSeason: string }
                              | { __typename?: 'Single' }
                              | { __typename?: 'Trailer' }
                              | { __typename?: 'Variant' };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    svtId: string;
                                    urls: { __typename?: 'Urls'; svtplay: string };
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                          restrictions: {
                              __typename?: 'Restrictions';
                              onlyAvailableInSwedenFormatted: string;
                          };
                      }
                    | null;
            }>;
        }>;
    };
};

export type AutoCompleteSearchQueryVariables = Exact<{
    querystring: Scalars['String'];
    abTestVariants: Maybe<Array<AbTestVariant> | AbTestVariant>;
    searchClickHistory: Maybe<Array<SearchHistoryItem> | SearchHistoryItem>;
}>;

export type AutoCompleteSearchQuery = {
    __typename?: 'Query';
    searchPage: {
        __typename?: 'SearchPage';
        flat: {
            __typename?: 'SearchPageHits';
            name: string | null;
            analyticsIdentifiers: {
                __typename?: 'SelectionAnalyticsIdentifiers';
                listId: string;
                listType: string;
            };
            hits: Array<{
                __typename?: 'SearchPageHit';
                categoryTeaser: {
                    __typename?: 'CategoryTeaser';
                    heading: string;
                    id: string;
                    byline: string;
                    image: { __typename?: 'Image'; changed: any; description: string; id: string };
                } | null;
                teaser: {
                    __typename?: 'Teaser';
                    byline: string;
                    subHeading: string;
                    heading: string;
                    badge: { __typename?: 'Badge'; type: string; text: string; altText: string } | null;
                    images: {
                        __typename?: 'Images';
                        wide: { __typename?: 'Image'; id: string; description: string; changed: any };
                    };
                    item:
                        | {
                              __typename?: 'Clip';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }
                        | {
                              __typename?: 'Episode';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }
                        | {
                              __typename?: 'KidsTvShow';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }
                        | {
                              __typename?: 'Playlist';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }
                        | {
                              __typename?: 'Single';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }
                        | {
                              __typename?: 'Trailer';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }
                        | {
                              __typename?: 'TvSeries';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }
                        | {
                              __typename?: 'TvShow';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }
                        | {
                              __typename?: 'Variant';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          };
                } | null;
            }>;
        } | null;
    };
};

export type ImportantMessageFragment = {
    __typename?: 'ImportantMessage';
    link: string | null;
    linkText: string | null;
    text: string;
    type: ImportantMessageType;
    id: string;
    created: any;
    updated: any;
};

export type ImportantMessagesQueryVariables = Exact<{ [key: string]: never }>;

export type ImportantMessagesQuery = {
    __typename?: 'Query';
    importantMessages: Array<{
        __typename?: 'ImportantMessage';
        link: string | null;
        linkText: string | null;
        text: string;
        type: ImportantMessageType;
        id: string;
        created: any;
        updated: any;
    }>;
};

export type LoadingQueryQueryVariables = Exact<{
    history: Array<Scalars['String']> | Scalars['String'];
}>;

export type LoadingQueryQuery = {
    __typename?: 'Query';
    personalRecommendations: { __typename?: 'Selection'; id: string };
};

export type MyListPageQueryVariables = Exact<{
    titleIds: Array<Scalars['String']> | Scalars['String'];
}>;

export type MyListPageQuery = {
    __typename?: 'Query';
    favorites: {
        __typename?: 'Selection';
        id: string;
        name: string;
        analyticsIdentifiers: {
            __typename?: 'SelectionAnalyticsIdentifiers';
            listId: string;
            listType: string;
        };
        items: Array<{
            __typename?: 'Teaser';
            heading: string;
            subHeading: string;
            byline: string;
            durationFormatted: string | null;
            progressFraction: number | null;
            description: string;
            badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
            images: {
                __typename?: 'Images';
                wide: {
                    __typename?: 'Image';
                    changed: any;
                    id: string;
                    keyart: boolean;
                    description: string;
                    blurHash: string;
                };
                portrait: {
                    __typename?: 'Image';
                    changed: any;
                    id: string;
                    keyart: boolean;
                    description: string;
                    blurHash: string;
                };
            };
            item:
                | {
                      __typename?: 'Clip';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Episode';
                      duration: number;
                      name: string;
                      positionInSeason: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      variants: Array<{
                          __typename?: 'Variant';
                          accessibility: Accessibility | null;
                          videoSvtId: string;
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            };
                  }
                | {
                      __typename?: 'KidsTvShow';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Playlist';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Single';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      variants: Array<{
                          __typename?: 'Variant';
                          accessibility: Accessibility | null;
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            };
                  }
                | {
                      __typename?: 'Trailer';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'TvSeries';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'TvShow';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Variant';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  };
        }>;
    };
};

export type AlphabeticalListItemFragment = {
    __typename?: 'Teaser';
    heading: string;
    item:
        | {
              __typename?: 'Clip';
              id: string;
              oppetArkiv: boolean;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Episode';
              id: string;
              oppetArkiv: boolean;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'KidsTvShow';
              id: string;
              oppetArkiv: boolean;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Playlist';
              id: string;
              oppetArkiv: boolean;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Single';
              id: string;
              oppetArkiv: boolean;
              variants: Array<{
                  __typename?: 'Variant';
                  id: string;
                  accessibility: Accessibility | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
              }>;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Trailer';
              id: string;
              oppetArkiv: boolean;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'TvSeries';
              id: string;
              oppetArkiv: boolean;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'TvShow';
              id: string;
              oppetArkiv: boolean;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Variant';
              id: string;
              oppetArkiv: boolean;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          };
};

export type AlphabeticalListFragment = {
    __typename?: 'Selection';
    id: string;
    name: string;
    items: Array<{
        __typename?: 'Teaser';
        heading: string;
        item:
            | {
                  __typename?: 'Clip';
                  id: string;
                  oppetArkiv: boolean;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Episode';
                  id: string;
                  oppetArkiv: boolean;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'KidsTvShow';
                  id: string;
                  oppetArkiv: boolean;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Playlist';
                  id: string;
                  oppetArkiv: boolean;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Single';
                  id: string;
                  oppetArkiv: boolean;
                  variants: Array<{
                      __typename?: 'Variant';
                      id: string;
                      accessibility: Accessibility | null;
                      urls: { __typename?: 'Urls'; svtplay: string };
                  }>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Trailer';
                  id: string;
                  oppetArkiv: boolean;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'TvSeries';
                  id: string;
                  oppetArkiv: boolean;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'TvShow';
                  id: string;
                  oppetArkiv: boolean;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Variant';
                  id: string;
                  oppetArkiv: boolean;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              };
    }>;
};

export type ProgramsListingQueryVariables = Exact<{
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
    userIsAbroad: Maybe<Scalars['Boolean']>;
}>;

export type ProgramsListingQuery = {
    __typename?: 'Query';
    programAtillO: {
        __typename?: 'ProgramAtillO';
        analyticsIdentifiers: { __typename?: 'AnalyticsIdentifiers'; viewId: string; viewType: string };
        selections: Array<{
            __typename?: 'Selection';
            id: string;
            name: string;
            items: Array<{
                __typename?: 'Teaser';
                heading: string;
                item:
                    | {
                          __typename?: 'Clip';
                          id: string;
                          oppetArkiv: boolean;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Episode';
                          id: string;
                          oppetArkiv: boolean;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'KidsTvShow';
                          id: string;
                          oppetArkiv: boolean;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Playlist';
                          id: string;
                          oppetArkiv: boolean;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Single';
                          id: string;
                          oppetArkiv: boolean;
                          variants: Array<{
                              __typename?: 'Variant';
                              id: string;
                              accessibility: Accessibility | null;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Trailer';
                          id: string;
                          oppetArkiv: boolean;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'TvSeries';
                          id: string;
                          oppetArkiv: boolean;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'TvShow';
                          id: string;
                          oppetArkiv: boolean;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Variant';
                          id: string;
                          oppetArkiv: boolean;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      };
            }>;
        }>;
    };
};

export type GenreFragment = {
    __typename?: 'Genre';
    id: string;
    name: string;
    image: { __typename?: 'Image'; id: string; changed: any; description: string } | null;
};

export type MainGenresQueryVariables = Exact<{ [key: string]: never }>;

export type MainGenresQuery = {
    __typename?: 'Query';
    genres: Array<{
        __typename?: 'Genre';
        id: string;
        name: string;
        image: { __typename?: 'Image'; id: string; changed: any; description: string } | null;
    }>;
};

export type SearchHitTeaserFragment = {
    __typename?: 'Teaser';
    description: string;
    durationFormatted: string | null;
    byline: string;
    subHeading: string;
    heading: string;
    badge: { __typename?: 'Badge'; type: string; text: string; altText: string } | null;
    images: {
        __typename?: 'Images';
        wide: { __typename?: 'Image'; id: string; description: string; changed: any };
    };
    item:
        | {
              __typename?: 'Clip';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Episode';
              id: string;
              name: string;
              svtId: string;
              variants: Array<{
                  __typename?: 'Variant';
                  accessibility: Accessibility | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
              }>;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'KidsTvShow';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Playlist';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Single';
              id: string;
              name: string;
              svtId: string;
              variants: Array<{
                  __typename?: 'Variant';
                  accessibility: Accessibility | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
              }>;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Trailer';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'TvSeries';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'TvShow';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Variant';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          };
};

export type SearchHitCategoryTeaserFragment = {
    __typename?: 'CategoryTeaser';
    heading: string;
    id: string;
    byline: string;
    image: { __typename?: 'Image'; changed: any; description: string; id: string };
};

export type SearchHitFragment = {
    __typename?: 'SearchPageHit';
    categoryTeaser: {
        __typename?: 'CategoryTeaser';
        heading: string;
        id: string;
        byline: string;
        image: { __typename?: 'Image'; changed: any; description: string; id: string };
    } | null;
    teaser: {
        __typename?: 'Teaser';
        description: string;
        durationFormatted: string | null;
        byline: string;
        subHeading: string;
        heading: string;
        badge: { __typename?: 'Badge'; type: string; text: string; altText: string } | null;
        images: {
            __typename?: 'Images';
            wide: { __typename?: 'Image'; id: string; description: string; changed: any };
        };
        item:
            | {
                  __typename?: 'Clip';
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Episode';
                  id: string;
                  name: string;
                  svtId: string;
                  variants: Array<{
                      __typename?: 'Variant';
                      accessibility: Accessibility | null;
                      urls: { __typename?: 'Urls'; svtplay: string };
                  }>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'KidsTvShow';
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Playlist';
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Single';
                  id: string;
                  name: string;
                  svtId: string;
                  variants: Array<{
                      __typename?: 'Variant';
                      accessibility: Accessibility | null;
                      urls: { __typename?: 'Urls'; svtplay: string };
                  }>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Trailer';
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'TvSeries';
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'TvShow';
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Variant';
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              };
    } | null;
};

export type SearchPageFlatFragment = {
    __typename?: 'SearchPageHits';
    name: string | null;
    analyticsIdentifiers: { __typename?: 'SelectionAnalyticsIdentifiers'; listId: string; listType: string };
    hits: Array<{
        __typename?: 'SearchPageHit';
        categoryTeaser: {
            __typename?: 'CategoryTeaser';
            heading: string;
            id: string;
            byline: string;
            image: { __typename?: 'Image'; changed: any; description: string; id: string };
        } | null;
        teaser: {
            __typename?: 'Teaser';
            description: string;
            durationFormatted: string | null;
            byline: string;
            subHeading: string;
            heading: string;
            badge: { __typename?: 'Badge'; type: string; text: string; altText: string } | null;
            images: {
                __typename?: 'Images';
                wide: { __typename?: 'Image'; id: string; description: string; changed: any };
            };
            item:
                | {
                      __typename?: 'Clip';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Episode';
                      id: string;
                      name: string;
                      svtId: string;
                      variants: Array<{
                          __typename?: 'Variant';
                          accessibility: Accessibility | null;
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'KidsTvShow';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Playlist';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Single';
                      id: string;
                      name: string;
                      svtId: string;
                      variants: Array<{
                          __typename?: 'Variant';
                          accessibility: Accessibility | null;
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Trailer';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'TvSeries';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'TvShow';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Variant';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  };
        } | null;
    }>;
};

export type SearchPageQueryVariables = Exact<{
    query: Scalars['String'];
    abTestVariants: Maybe<Array<AbTestVariant> | AbTestVariant>;
}>;

export type SearchPageQuery = {
    __typename?: 'Query';
    searchPage: {
        __typename?: 'SearchPage';
        flat: {
            __typename?: 'SearchPageHits';
            name: string | null;
            analyticsIdentifiers: {
                __typename?: 'SelectionAnalyticsIdentifiers';
                listId: string;
                listType: string;
            };
            hits: Array<{
                __typename?: 'SearchPageHit';
                categoryTeaser: {
                    __typename?: 'CategoryTeaser';
                    heading: string;
                    id: string;
                    byline: string;
                    image: { __typename?: 'Image'; changed: any; description: string; id: string };
                } | null;
                teaser: {
                    __typename?: 'Teaser';
                    description: string;
                    durationFormatted: string | null;
                    byline: string;
                    subHeading: string;
                    heading: string;
                    badge: { __typename?: 'Badge'; type: string; text: string; altText: string } | null;
                    images: {
                        __typename?: 'Images';
                        wide: { __typename?: 'Image'; id: string; description: string; changed: any };
                    };
                    item:
                        | {
                              __typename?: 'Clip';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          }
                        | {
                              __typename?: 'Episode';
                              id: string;
                              name: string;
                              svtId: string;
                              variants: Array<{
                                  __typename?: 'Variant';
                                  accessibility: Accessibility | null;
                                  urls: { __typename?: 'Urls'; svtplay: string };
                              }>;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          }
                        | {
                              __typename?: 'KidsTvShow';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          }
                        | {
                              __typename?: 'Playlist';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          }
                        | {
                              __typename?: 'Single';
                              id: string;
                              name: string;
                              svtId: string;
                              variants: Array<{
                                  __typename?: 'Variant';
                                  accessibility: Accessibility | null;
                                  urls: { __typename?: 'Urls'; svtplay: string };
                              }>;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          }
                        | {
                              __typename?: 'Trailer';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          }
                        | {
                              __typename?: 'TvSeries';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          }
                        | {
                              __typename?: 'TvShow';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          }
                        | {
                              __typename?: 'Variant';
                              svtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          };
                } | null;
            }>;
        } | null;
    };
};

export type SearchRecommendationsQueryQueryVariables = Exact<{ [key: string]: never }>;

export type SearchRecommendationsQueryQuery = {
    __typename?: 'Query';
    startForSvtPlay: {
        __typename?: 'StartForSvtPlay';
        selections: Array<{
            __typename?: 'Selection';
            id: string;
            name: string;
            presentation: Presentation;
            analyticsIdentifiers: {
                __typename?: 'SelectionAnalyticsIdentifiers';
                listId: string;
                listType: string;
            };
            items: Array<{
                __typename?: 'Teaser';
                heading: string;
                subHeading: string;
                byline: string;
                badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
                images: {
                    __typename?: 'Images';
                    wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                };
                item:
                    | {
                          __typename?: 'Clip';
                          durationFormatted: string;
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Episode';
                          durationFormatted: string;
                          duration: number;
                          name: string;
                          positionInSeason: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          variants: Array<{
                              __typename?: 'Variant';
                              accessibility: Accessibility | null;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }>;
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                };
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'KidsTvShow';
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Playlist';
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Single';
                          durationFormatted: string;
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          variants: Array<{
                              __typename?: 'Variant';
                              accessibility: Accessibility | null;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }>;
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                };
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Trailer';
                          durationFormatted: string;
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'TvSeries';
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'TvShow';
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Variant';
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      };
            }>;
        }>;
    };
};

export type SimilarVideoContentQueryQueryVariables = Exact<{
    id: Scalars['String'];
    userIsAbroad: Scalars['Boolean'];
}>;

export type SimilarVideoContentQueryQuery = {
    __typename?: 'Query';
    detailsPage: {
        __typename?: 'DetailsPage';
        associatedContent: Array<{
            __typename?: 'Selection';
            id: string;
            name: string;
            selectionType: string;
            analyticsIdentifiers: {
                __typename?: 'SelectionAnalyticsIdentifiers';
                listId: string;
                listType: string;
            };
            items: Array<{
                __typename?: 'Teaser';
                heading: string;
                subHeading: string;
                byline: string;
                durationFormatted: string | null;
                progressFraction: number | null;
                description: string;
                badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
                images: {
                    __typename?: 'Images';
                    wide: {
                        __typename?: 'Image';
                        changed: any;
                        id: string;
                        keyart: boolean;
                        description: string;
                        blurHash: string;
                    };
                    portrait: {
                        __typename?: 'Image';
                        changed: any;
                        id: string;
                        keyart: boolean;
                        description: string;
                        blurHash: string;
                    };
                };
                item:
                    | {
                          __typename?: 'Clip';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Episode';
                          duration: number;
                          name: string;
                          positionInSeason: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          variants: Array<{
                              __typename?: 'Variant';
                              accessibility: Accessibility | null;
                              videoSvtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                };
                      }
                    | {
                          __typename?: 'KidsTvShow';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Playlist';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Single';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          variants: Array<{
                              __typename?: 'Variant';
                              accessibility: Accessibility | null;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                };
                      }
                    | {
                          __typename?: 'Trailer';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'TvSeries';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'TvShow';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Variant';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      };
            }>;
        }>;
    } | null;
};

export type PersonalRecommendationsQueryVariables = Exact<{
    history: Array<Scalars['String']> | Scalars['String'];
    clientId: Maybe<Scalars['String']>;
    abTestVariants: Maybe<Array<AbTestVariant> | AbTestVariant>;
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
    userIsAbroad: Maybe<Scalars['Boolean']>;
}>;

export type PersonalRecommendationsQuery = {
    __typename?: 'Query';
    personalRecommendations: {
        __typename?: 'Selection';
        id: string;
        analyticsIdentifiers: {
            __typename?: 'SelectionAnalyticsIdentifiers';
            listId: string;
            listType: string;
        };
        items: Array<{
            __typename?: 'Teaser';
            heading: string;
            subHeading: string;
            byline: string;
            durationFormatted: string | null;
            progressFraction: number | null;
            description: string;
            badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
            images: {
                __typename?: 'Images';
                wide: {
                    __typename?: 'Image';
                    changed: any;
                    id: string;
                    keyart: boolean;
                    description: string;
                    blurHash: string;
                };
                portrait: {
                    __typename?: 'Image';
                    changed: any;
                    id: string;
                    keyart: boolean;
                    description: string;
                    blurHash: string;
                };
            };
            item:
                | {
                      __typename?: 'Clip';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Episode';
                      duration: number;
                      name: string;
                      positionInSeason: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      variants: Array<{
                          __typename?: 'Variant';
                          accessibility: Accessibility | null;
                          videoSvtId: string;
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            };
                  }
                | {
                      __typename?: 'KidsTvShow';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Playlist';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Single';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      variants: Array<{
                          __typename?: 'Variant';
                          accessibility: Accessibility | null;
                          urls: { __typename?: 'Urls'; svtplay: string };
                      }>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            };
                  }
                | {
                      __typename?: 'Trailer';
                      duration: number;
                      name: string;
                      id: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'TvSeries';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'TvShow';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  }
                | {
                      __typename?: 'Variant';
                      id: string;
                      name: string;
                      longDescription: string;
                      oppetArkiv: boolean;
                      svtId: string;
                      videoSvtId: string;
                      accessibilities: Array<Accessibility>;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      parent:
                          | {
                                __typename?: 'KidsTvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'Single';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvSeries';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | {
                                __typename?: 'TvShow';
                                id: string;
                                name: string;
                                svtId: string;
                                images: {
                                    __typename?: 'Images';
                                    wide: {
                                        __typename?: 'Image';
                                        changed: any;
                                        id: string;
                                        description: string;
                                    };
                                };
                            }
                          | null;
                  };
        }>;
    };
};

export type StartPageSelectionFragment = {
    __typename?: 'Selection';
    id: string;
    name: string;
    presentation: Presentation;
    presentationHints: { __typename?: 'PresentationHints'; breakingNews: boolean } | null;
    analyticsIdentifiers: { __typename?: 'SelectionAnalyticsIdentifiers'; listId: string; listType: string };
    items: Array<{
        __typename?: 'Teaser';
        heading: string;
        subHeading: string;
        byline: string;
        durationFormatted: string | null;
        progressFraction: number | null;
        description: string;
        badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
        images: {
            __typename?: 'Images';
            wide: {
                __typename?: 'Image';
                changed: any;
                id: string;
                keyart: boolean;
                description: string;
                blurHash: string;
            };
            portrait: {
                __typename?: 'Image';
                changed: any;
                id: string;
                keyart: boolean;
                description: string;
                blurHash: string;
            };
        };
        item:
            | {
                  __typename?: 'Clip';
                  duration: number;
                  name: string;
                  id: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'Episode';
                  duration: number;
                  name: string;
                  positionInSeason: string;
                  id: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  variants: Array<{
                      __typename?: 'Variant';
                      accessibility: Accessibility | null;
                      videoSvtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                  }>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        };
              }
            | {
                  __typename?: 'KidsTvShow';
                  id: string;
                  name: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'Playlist';
                  id: string;
                  name: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'Single';
                  duration: number;
                  name: string;
                  id: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  variants: Array<{
                      __typename?: 'Variant';
                      accessibility: Accessibility | null;
                      urls: { __typename?: 'Urls'; svtplay: string };
                  }>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        };
              }
            | {
                  __typename?: 'Trailer';
                  duration: number;
                  name: string;
                  id: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'TvSeries';
                  id: string;
                  name: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'TvShow';
                  id: string;
                  name: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | null;
              }
            | {
                  __typename?: 'Variant';
                  id: string;
                  name: string;
                  longDescription: string;
                  oppetArkiv: boolean;
                  svtId: string;
                  videoSvtId: string;
                  accessibilities: Array<Accessibility>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  parent:
                      | {
                            __typename?: 'KidsTvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'Single';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvSeries';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | {
                            __typename?: 'TvShow';
                            id: string;
                            name: string;
                            svtId: string;
                            images: {
                                __typename?: 'Images';
                                wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                            };
                        }
                      | null;
              };
    }>;
};

export type StartPageQueryVariables = Exact<{
    abTestVariants: Maybe<Array<AbTestVariant> | AbTestVariant>;
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
}>;

export type StartPageQuery = {
    __typename?: 'Query';
    startForSvtPlay: {
        __typename?: 'StartForSvtPlay';
        name: string;
        analyticsIdentifiers: { __typename?: 'AnalyticsIdentifiers'; viewId: string; viewType: string };
        selections: Array<{
            __typename?: 'Selection';
            id: string;
            name: string;
            presentation: Presentation;
            presentationHints: { __typename?: 'PresentationHints'; breakingNews: boolean } | null;
            analyticsIdentifiers: {
                __typename?: 'SelectionAnalyticsIdentifiers';
                listId: string;
                listType: string;
            };
            items: Array<{
                __typename?: 'Teaser';
                heading: string;
                subHeading: string;
                byline: string;
                durationFormatted: string | null;
                progressFraction: number | null;
                description: string;
                badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
                images: {
                    __typename?: 'Images';
                    wide: {
                        __typename?: 'Image';
                        changed: any;
                        id: string;
                        keyart: boolean;
                        description: string;
                        blurHash: string;
                    };
                    portrait: {
                        __typename?: 'Image';
                        changed: any;
                        id: string;
                        keyart: boolean;
                        description: string;
                        blurHash: string;
                    };
                };
                item:
                    | {
                          __typename?: 'Clip';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Episode';
                          duration: number;
                          name: string;
                          positionInSeason: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          variants: Array<{
                              __typename?: 'Variant';
                              accessibility: Accessibility | null;
                              videoSvtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                };
                      }
                    | {
                          __typename?: 'KidsTvShow';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Playlist';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Single';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          variants: Array<{
                              __typename?: 'Variant';
                              accessibility: Accessibility | null;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                };
                      }
                    | {
                          __typename?: 'Trailer';
                          duration: number;
                          name: string;
                          id: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'TvSeries';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'TvShow';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      }
                    | {
                          __typename?: 'Variant';
                          id: string;
                          name: string;
                          longDescription: string;
                          oppetArkiv: boolean;
                          svtId: string;
                          videoSvtId: string;
                          accessibilities: Array<Accessibility>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                          parent:
                              | {
                                    __typename?: 'KidsTvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'Single';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvSeries';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | {
                                    __typename?: 'TvShow';
                                    id: string;
                                    name: string;
                                    svtId: string;
                                    images: {
                                        __typename?: 'Images';
                                        wide: {
                                            __typename?: 'Image';
                                            changed: any;
                                            id: string;
                                            description: string;
                                        };
                                    };
                                }
                              | null;
                      };
            }>;
        }>;
    };
};

export type UserSurveyFragment = {
    __typename?: 'Survey';
    surveyUrl: string;
    subHeading: string;
    id: string;
    heading: string;
    image: { __typename?: 'Image'; blurHash: string; changed: any; id: string; description: string };
    customAttributes: Array<{ __typename?: 'SurveyCustomAttribute'; key: string; value: string }>;
};

export type SurveyQueryQueryVariables = Exact<{
    abTestVariants: Array<AbTestVariant> | AbTestVariant;
}>;

export type SurveyQueryQuery = {
    __typename?: 'Query';
    surveys: Array<{
        __typename?: 'Survey';
        surveyUrl: string;
        subHeading: string;
        id: string;
        heading: string;
        image: { __typename?: 'Image'; blurHash: string; changed: any; id: string; description: string };
        customAttributes: Array<{ __typename?: 'SurveyCustomAttribute'; key: string; value: string }>;
    }>;
};

export type AccessibilityVariantFragment = {
    __typename?: 'Variant';
    accessibility: Accessibility | null;
    accessibilities: Array<Accessibility>;
    svtId: string;
    urls: { __typename?: 'Urls'; svtplay: string };
    mainLanguage: { __typename?: 'Language'; name: string };
    restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
};

export type AccessibilityClipFragment = {
    __typename?: 'Clip';
    svtId: string;
    accessibility: Accessibility | null;
    urls: { __typename?: 'Urls'; svtplay: string };
};

export type AccessibilityTrailerFragment = {
    __typename?: 'Trailer';
    svtId: string;
    accessibility: Accessibility | null;
    urls: { __typename?: 'Urls'; svtplay: string };
};

type AccessibilityVariants_Clip_Fragment = {
    __typename?: 'Clip';
    id: string;
    name: string;
    svtId: string;
    accessibility: Accessibility | null;
    urls: { __typename?: 'Urls'; svtplay: string };
};

type AccessibilityVariants_Episode_Fragment = { __typename?: 'Episode'; id: string; name: string };

type AccessibilityVariants_Single_Fragment = { __typename?: 'Single'; id: string; name: string };

type AccessibilityVariants_Trailer_Fragment = {
    __typename?: 'Trailer';
    id: string;
    name: string;
    svtId: string;
    accessibility: Accessibility | null;
    urls: { __typename?: 'Urls'; svtplay: string };
};

type AccessibilityVariants_Variant_Fragment = {
    __typename?: 'Variant';
    id: string;
    name: string;
    accessibility: Accessibility | null;
    accessibilities: Array<Accessibility>;
    svtId: string;
    urls: { __typename?: 'Urls'; svtplay: string };
    mainLanguage: { __typename?: 'Language'; name: string };
    restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
};

export type AccessibilityVariantsFragment =
    | AccessibilityVariants_Clip_Fragment
    | AccessibilityVariants_Episode_Fragment
    | AccessibilityVariants_Single_Fragment
    | AccessibilityVariants_Trailer_Fragment
    | AccessibilityVariants_Variant_Fragment;

export type NextToPlayFragment = {
    __typename?: 'Teaser';
    heading: string;
    subHeading: string;
    byline: string;
    badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
    images: {
        __typename?: 'Images';
        wide: {
            __typename?: 'Image';
            changed: any;
            id: string;
            keyart: boolean;
            description: string;
            blurHash: string;
        };
        portrait: { __typename?: 'Image'; changed: any; id: string; keyart: boolean; description: string };
    };
    item:
        | {
              __typename?: 'Clip';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Episode';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'KidsTvShow';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Playlist';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Single';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Trailer';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'TvSeries';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'TvShow';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
        | {
              __typename?: 'Variant';
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          };
};

export type TypeVariantFragment = {
    __typename?: 'Variant';
    whenToDisplaySkipToNext: number | null;
    highlights: Array<{
        __typename?: 'Highlight';
        name: string;
        slug: string;
        thumbnail: string | null;
        thumbnailId: number | null;
        positionFormatted: string;
        positionInSeconds: number;
    }>;
    urls: { __typename?: 'Urls'; svtplay: string };
    videos: Array<
        | {
              __typename?: 'Clip';
              id: string;
              name: string;
              svtId: string;
              accessibility: Accessibility | null;
              urls: { __typename?: 'Urls'; svtplay: string };
          }
        | {
              __typename?: 'Trailer';
              id: string;
              name: string;
              svtId: string;
              accessibility: Accessibility | null;
              urls: { __typename?: 'Urls'; svtplay: string };
          }
        | {
              __typename?: 'Variant';
              id: string;
              name: string;
              accessibility: Accessibility | null;
              accessibilities: Array<Accessibility>;
              svtId: string;
              urls: { __typename?: 'Urls'; svtplay: string };
              mainLanguage: { __typename?: 'Language'; name: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
          }
    >;
};

export type AssociatedContentFragment = {
    __typename?: 'Selection';
    id: string;
    name: string;
    analyticsIdentifiers: { __typename?: 'SelectionAnalyticsIdentifiers'; listId: string };
    items: Array<{
        __typename?: 'Teaser';
        heading: string;
        selected: boolean;
        badge: { __typename?: 'Badge'; type: string; text: string; altText: string } | null;
        images: {
            __typename?: 'Images';
            wide: { __typename?: 'Image'; id: string; changed: any; description: string };
        };
        item:
            | {
                  __typename?: 'Clip';
                  duration: number;
                  durationFormatted: string;
                  name: string;
                  id: string;
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Episode';
                  duration: number;
                  durationFormatted: string;
                  id: string;
                  svtId: string;
                  variants: Array<{
                      __typename?: 'Variant';
                      accessibility: Accessibility | null;
                      videoSvtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                  }>;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'KidsTvShow';
                  id: string;
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Playlist';
                  id: string;
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Single';
                  duration: number;
                  durationFormatted: string;
                  id: string;
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Trailer';
                  duration: number;
                  durationFormatted: string;
                  name: string;
                  id: string;
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'TvSeries';
                  id: string;
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'TvShow';
                  id: string;
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              }
            | {
                  __typename?: 'Variant';
                  duration: number;
                  durationFormatted: string;
                  id: string;
                  svtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              };
    }>;
};

export type VideoModalQueryVariables = Exact<{
    id: Scalars['String'];
}>;

export type VideoModalQuery = {
    __typename?: 'Query';
    detailsPage: {
        __typename: 'DetailsPage';
        svtId: string;
        id: string;
        images: { __typename?: 'Images'; wide: { __typename?: 'Image'; id: string; changed: any } };
        item:
            | {
                  __typename: 'Clip';
                  name: string;
                  barn: boolean;
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'Single';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvSeries';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  tags: Array<{ __typename?: 'Tag'; slug: string }>;
                  restrictions: { __typename?: 'Restrictions'; blockedForChildren: boolean };
              }
            | {
                  __typename: 'Episode';
                  name: string;
                  barn: boolean;
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'Single';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvSeries';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        };
                  urls: { __typename?: 'Urls'; svtplay: string };
                  tags: Array<{ __typename?: 'Tag'; slug: string }>;
                  restrictions: { __typename?: 'Restrictions'; blockedForChildren: boolean };
              }
            | {
                  __typename: 'KidsTvShow';
                  name: string;
                  barn: boolean;
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'Single';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvSeries';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  tags: Array<{ __typename?: 'Tag'; slug: string }>;
                  restrictions: { __typename?: 'Restrictions'; blockedForChildren: boolean };
              }
            | {
                  __typename: 'Playlist';
                  name: string;
                  barn: boolean;
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'Single';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvSeries';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  tags: Array<{ __typename?: 'Tag'; slug: string }>;
                  restrictions: { __typename?: 'Restrictions'; blockedForChildren: boolean };
              }
            | {
                  __typename: 'Single';
                  name: string;
                  barn: boolean;
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'Single';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvSeries';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        };
                  urls: { __typename?: 'Urls'; svtplay: string };
                  tags: Array<{ __typename?: 'Tag'; slug: string }>;
                  restrictions: { __typename?: 'Restrictions'; blockedForChildren: boolean };
              }
            | {
                  __typename: 'Trailer';
                  name: string;
                  barn: boolean;
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'Single';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvSeries';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  tags: Array<{ __typename?: 'Tag'; slug: string }>;
                  restrictions: { __typename?: 'Restrictions'; blockedForChildren: boolean };
              }
            | {
                  __typename: 'TvSeries';
                  name: string;
                  barn: boolean;
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'Single';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvSeries';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  tags: Array<{ __typename?: 'Tag'; slug: string }>;
                  restrictions: { __typename?: 'Restrictions'; blockedForChildren: boolean };
              }
            | {
                  __typename: 'TvShow';
                  name: string;
                  barn: boolean;
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'Single';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvSeries';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  tags: Array<{ __typename?: 'Tag'; slug: string }>;
                  restrictions: { __typename?: 'Restrictions'; blockedForChildren: boolean };
              }
            | {
                  __typename: 'Variant';
                  name: string;
                  barn: boolean;
                  whenToDisplaySkipToNext: number | null;
                  parent:
                      | {
                            __typename: 'KidsTvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'Single';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvSeries';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename: 'TvShow';
                            svtId: string;
                            name: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
                  tags: Array<{ __typename?: 'Tag'; slug: string }>;
                  restrictions: { __typename?: 'Restrictions'; blockedForChildren: boolean };
                  highlights: Array<{
                      __typename?: 'Highlight';
                      name: string;
                      slug: string;
                      thumbnail: string | null;
                      thumbnailId: number | null;
                      positionFormatted: string;
                      positionInSeconds: number;
                  }>;
                  videos: Array<
                      | {
                            __typename?: 'Clip';
                            id: string;
                            name: string;
                            svtId: string;
                            accessibility: Accessibility | null;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename?: 'Trailer';
                            id: string;
                            name: string;
                            svtId: string;
                            accessibility: Accessibility | null;
                            urls: { __typename?: 'Urls'; svtplay: string };
                        }
                      | {
                            __typename?: 'Variant';
                            id: string;
                            name: string;
                            accessibility: Accessibility | null;
                            accessibilities: Array<Accessibility>;
                            svtId: string;
                            urls: { __typename?: 'Urls'; svtplay: string };
                            mainLanguage: { __typename?: 'Language'; name: string };
                            restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                        }
                  >;
              };
        live: { __typename?: 'Live'; liveNow: boolean } | null;
    } | null;
    playQueue: {
        __typename?: 'PlayQueue';
        nextToPlay: {
            __typename?: 'Teaser';
            heading: string;
            subHeading: string;
            byline: string;
            badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
            images: {
                __typename?: 'Images';
                wide: {
                    __typename?: 'Image';
                    changed: any;
                    id: string;
                    keyart: boolean;
                    description: string;
                    blurHash: string;
                };
                portrait: {
                    __typename?: 'Image';
                    changed: any;
                    id: string;
                    keyart: boolean;
                    description: string;
                };
            };
            item:
                | {
                      __typename?: 'Clip';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Episode';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'KidsTvShow';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Playlist';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Single';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Trailer';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'TvSeries';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'TvShow';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Variant';
                      svtId: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  };
        } | null;
    };
    associatedContent: {
        __typename?: 'PlayQueue';
        selections: Array<{
            __typename?: 'Selection';
            id: string;
            name: string;
            analyticsIdentifiers: { __typename?: 'SelectionAnalyticsIdentifiers'; listId: string };
            items: Array<{
                __typename?: 'Teaser';
                heading: string;
                selected: boolean;
                badge: { __typename?: 'Badge'; type: string; text: string; altText: string } | null;
                images: {
                    __typename?: 'Images';
                    wide: { __typename?: 'Image'; id: string; changed: any; description: string };
                };
                item:
                    | {
                          __typename?: 'Clip';
                          duration: number;
                          durationFormatted: string;
                          name: string;
                          id: string;
                          svtId: string;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Episode';
                          duration: number;
                          durationFormatted: string;
                          id: string;
                          svtId: string;
                          variants: Array<{
                              __typename?: 'Variant';
                              accessibility: Accessibility | null;
                              videoSvtId: string;
                              urls: { __typename?: 'Urls'; svtplay: string };
                          }>;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'KidsTvShow';
                          id: string;
                          svtId: string;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Playlist';
                          id: string;
                          svtId: string;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Single';
                          duration: number;
                          durationFormatted: string;
                          id: string;
                          svtId: string;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Trailer';
                          duration: number;
                          durationFormatted: string;
                          name: string;
                          id: string;
                          svtId: string;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'TvSeries';
                          id: string;
                          svtId: string;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'TvShow';
                          id: string;
                          svtId: string;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      }
                    | {
                          __typename?: 'Variant';
                          duration: number;
                          durationFormatted: string;
                          id: string;
                          svtId: string;
                          urls: { __typename?: 'Urls'; svtplay: string };
                          restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                      };
            }>;
        }>;
    };
};

export type PlayQueueQueryVariables = Exact<{
    id: Scalars['String'];
}>;

export type PlayQueueQuery = {
    __typename?: 'Query';
    playQueue: {
        __typename?: 'PlayQueue';
        flat: Array<{
            __typename?: 'Teaser';
            name: string;
            item:
                | {
                      __typename: 'Clip';
                      videoSvtId: string;
                      id: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      image: { __typename?: 'Image'; id: string; changed: any; description: string };
                  }
                | {
                      __typename: 'Episode';
                      videoSvtId: string;
                      id: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      image: { __typename?: 'Image'; id: string; changed: any; description: string };
                  }
                | {
                      __typename: 'KidsTvShow';
                      videoSvtId: string;
                      id: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      image: { __typename?: 'Image'; id: string; changed: any; description: string };
                  }
                | {
                      __typename: 'Playlist';
                      videoSvtId: string;
                      id: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      image: { __typename?: 'Image'; id: string; changed: any; description: string };
                  }
                | {
                      __typename: 'Single';
                      videoSvtId: string;
                      id: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      image: { __typename?: 'Image'; id: string; changed: any; description: string };
                  }
                | {
                      __typename: 'Trailer';
                      videoSvtId: string;
                      id: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      image: { __typename?: 'Image'; id: string; changed: any; description: string };
                  }
                | {
                      __typename: 'TvSeries';
                      videoSvtId: string;
                      id: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      image: { __typename?: 'Image'; id: string; changed: any; description: string };
                  }
                | {
                      __typename: 'TvShow';
                      videoSvtId: string;
                      id: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      image: { __typename?: 'Image'; id: string; changed: any; description: string };
                  }
                | {
                      __typename: 'Variant';
                      videoSvtId: string;
                      id: string;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      image: { __typename?: 'Image'; id: string; changed: any; description: string };
                  };
        }>;
    };
};

export type EndScreenRecommendationsQueryVariables = Exact<{
    id: Scalars['String'];
    history: Array<History> | History;
    includeFullOppetArkiv: Maybe<Scalars['Boolean']>;
    userIsAbroad: Scalars['Boolean'];
}>;

export type EndScreenRecommendationsQuery = {
    __typename?: 'Query';
    endScreenRecommendations: {
        __typename?: 'Selection';
        id: string;
        analyticsIdentifiers: {
            __typename?: 'SelectionAnalyticsIdentifiers';
            listId: string;
            listType: string;
        };
        items: Array<{
            __typename?: 'Teaser';
            progressFraction: number | null;
            images: {
                __typename?: 'Images';
                wide: { __typename?: 'Image'; id: string; changed: any; description: string };
            };
            badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
            item:
                | {
                      __typename?: 'Clip';
                      svtId: string;
                      name: string;
                      id: string;
                      oppetArkiv: boolean;
                      genres: Array<{ __typename?: 'Genre'; id: string }>;
                      parent:
                          | { __typename?: 'KidsTvShow'; id: string; name: string }
                          | { __typename?: 'Single'; id: string; name: string }
                          | { __typename?: 'TvSeries'; id: string; name: string }
                          | { __typename?: 'TvShow'; id: string; name: string }
                          | null;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Episode';
                      svtId: string;
                      name: string;
                      id: string;
                      oppetArkiv: boolean;
                      genres: Array<{ __typename?: 'Genre'; id: string }>;
                      parent:
                          | { __typename?: 'KidsTvShow'; id: string; name: string }
                          | { __typename?: 'Single'; id: string; name: string }
                          | { __typename?: 'TvSeries'; id: string; name: string }
                          | { __typename?: 'TvShow'; id: string; name: string };
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'KidsTvShow';
                      svtId: string;
                      name: string;
                      id: string;
                      oppetArkiv: boolean;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Playlist';
                      svtId: string;
                      name: string;
                      id: string;
                      oppetArkiv: boolean;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Single';
                      svtId: string;
                      name: string;
                      id: string;
                      oppetArkiv: boolean;
                      genres: Array<{ __typename?: 'Genre'; id: string }>;
                      parent:
                          | { __typename?: 'KidsTvShow'; id: string; name: string }
                          | { __typename?: 'Single'; id: string; name: string }
                          | { __typename?: 'TvSeries'; id: string; name: string }
                          | { __typename?: 'TvShow'; id: string; name: string };
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Trailer';
                      svtId: string;
                      name: string;
                      id: string;
                      oppetArkiv: boolean;
                      genres: Array<{ __typename?: 'Genre'; id: string }>;
                      parent:
                          | { __typename?: 'KidsTvShow'; id: string; name: string }
                          | { __typename?: 'Single'; id: string; name: string }
                          | { __typename?: 'TvSeries'; id: string; name: string }
                          | { __typename?: 'TvShow'; id: string; name: string }
                          | null;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'TvSeries';
                      svtId: string;
                      name: string;
                      id: string;
                      oppetArkiv: boolean;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'TvShow';
                      svtId: string;
                      name: string;
                      id: string;
                      oppetArkiv: boolean;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  }
                | {
                      __typename?: 'Variant';
                      svtId: string;
                      name: string;
                      id: string;
                      oppetArkiv: boolean;
                      genres: Array<{ __typename?: 'Genre'; id: string }>;
                      parent:
                          | { __typename?: 'KidsTvShow'; id: string; name: string }
                          | { __typename?: 'Single'; id: string; name: string }
                          | { __typename?: 'TvSeries'; id: string; name: string }
                          | { __typename?: 'TvShow'; id: string; name: string }
                          | null;
                      urls: { __typename?: 'Urls'; svtplay: string };
                      restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
                  };
        }>;
    };
};

export type PlayerPageQueryQueryVariables = Exact<{
    videoId: Scalars['String'];
}>;

export type PlayerPageQueryQuery = {
    __typename?: 'Query';
    playerPage: {
        __typename?: 'PlayerPage';
        playerConfig: {
            __typename?: 'PlayerConfig';
            chat: {
                __typename?: 'PlayerChatConfig';
                chatId: string;
                description: string | null;
                hideAvatars: boolean;
                startTime: string | null;
                endTime: string | null;
                id: string;
                reactions: Array<{ __typename?: 'PlayerReaction'; id: string; emoji: string }>;
            } | null;
            extras: { __typename?: 'PlayerExtraConfig'; data: string; id: string } | null;
        } | null;
    };
};

export type ContentItemFragment = {
    __typename?: 'Teaser';
    heading: string;
    subHeading: string;
    byline: string;
    durationFormatted: string | null;
    progressFraction: number | null;
    description: string;
    badge: { __typename?: 'Badge'; altText: string; text: string; type: string } | null;
    images: {
        __typename?: 'Images';
        wide: {
            __typename?: 'Image';
            changed: any;
            id: string;
            keyart: boolean;
            description: string;
            blurHash: string;
        };
        portrait: {
            __typename?: 'Image';
            changed: any;
            id: string;
            keyart: boolean;
            description: string;
            blurHash: string;
        };
    };
    item:
        | {
              __typename?: 'Clip';
              duration: number;
              name: string;
              id: string;
              longDescription: string;
              oppetArkiv: boolean;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              parent:
                  | {
                        __typename?: 'KidsTvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'Single';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvSeries';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | null;
          }
        | {
              __typename?: 'Episode';
              duration: number;
              name: string;
              positionInSeason: string;
              id: string;
              longDescription: string;
              oppetArkiv: boolean;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              variants: Array<{
                  __typename?: 'Variant';
                  accessibility: Accessibility | null;
                  videoSvtId: string;
                  urls: { __typename?: 'Urls'; svtplay: string };
              }>;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              parent:
                  | {
                        __typename?: 'KidsTvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'Single';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvSeries';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    };
          }
        | {
              __typename?: 'KidsTvShow';
              id: string;
              name: string;
              longDescription: string;
              oppetArkiv: boolean;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              parent:
                  | {
                        __typename?: 'KidsTvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'Single';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvSeries';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | null;
          }
        | {
              __typename?: 'Playlist';
              id: string;
              name: string;
              longDescription: string;
              oppetArkiv: boolean;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              parent:
                  | {
                        __typename?: 'KidsTvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'Single';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvSeries';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | null;
          }
        | {
              __typename?: 'Single';
              duration: number;
              name: string;
              id: string;
              longDescription: string;
              oppetArkiv: boolean;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              variants: Array<{
                  __typename?: 'Variant';
                  accessibility: Accessibility | null;
                  urls: { __typename?: 'Urls'; svtplay: string };
              }>;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              parent:
                  | {
                        __typename?: 'KidsTvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'Single';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvSeries';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    };
          }
        | {
              __typename?: 'Trailer';
              duration: number;
              name: string;
              id: string;
              longDescription: string;
              oppetArkiv: boolean;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              parent:
                  | {
                        __typename?: 'KidsTvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'Single';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvSeries';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | null;
          }
        | {
              __typename?: 'TvSeries';
              id: string;
              name: string;
              longDescription: string;
              oppetArkiv: boolean;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              parent:
                  | {
                        __typename?: 'KidsTvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'Single';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvSeries';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | null;
          }
        | {
              __typename?: 'TvShow';
              id: string;
              name: string;
              longDescription: string;
              oppetArkiv: boolean;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              parent:
                  | {
                        __typename?: 'KidsTvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'Single';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvSeries';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | null;
          }
        | {
              __typename?: 'Variant';
              id: string;
              name: string;
              longDescription: string;
              oppetArkiv: boolean;
              svtId: string;
              videoSvtId: string;
              accessibilities: Array<Accessibility>;
              urls: { __typename?: 'Urls'; svtplay: string };
              restrictions: { __typename?: 'Restrictions'; onlyAvailableInSweden: boolean };
              parent:
                  | {
                        __typename?: 'KidsTvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'Single';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvSeries';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | {
                        __typename?: 'TvShow';
                        id: string;
                        name: string;
                        svtId: string;
                        images: {
                            __typename?: 'Images';
                            wide: { __typename?: 'Image'; changed: any; id: string; description: string };
                        };
                    }
                  | null;
          };
};

export interface PossibleTypesResultData {
    possibleTypes: {
        [key: string]: string[];
    };
}
const result: PossibleTypesResultData = {
    possibleTypes: {
        Content: ['KidsTvShow', 'Single', 'TvSeries', 'TvShow'],
        ExtraMaterial: ['Clip', 'Trailer'],
        Listable: [
            'Clip',
            'Episode',
            'KidsTvShow',
            'Playlist',
            'Single',
            'Trailer',
            'TvSeries',
            'TvShow',
            'Variant',
        ],
        Node: [
            'Clip',
            'Episode',
            'KidsTvShow',
            'ProductionPeriod',
            'Season',
            'Single',
            'Trailer',
            'TvSeries',
            'TvShow',
            'Variant',
        ],
        Playable: ['Clip', 'Episode', 'Single', 'Trailer', 'Variant'],
        SearchHitItem: ['Clip', 'Episode', 'Genre', 'KidsTvShow', 'Single', 'Trailer', 'TvSeries', 'TvShow'],
        Video: ['Clip', 'Trailer', 'Variant'],
    },
};
export default result;
